var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulletjournalPana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.38,
    y: 37.04,
    width: 65.94,
    height: 68.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.91,
    y: 37.04,
    width: 65.94,
    height: 68.74,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.88,105.8h-66V37h66Zm-66,0h65.9V37.06h-65.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.78,
    y: 46.28,
    width: 48.21,
    height: 50.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.78,96.88a7.94,7.94,0,0,1-1.19,1.38c-.77.81-1.85,1.91-3.07,3.11s-2.32,2.26-3.15,3a7.56,7.56,0,0,1-1.39,1.16,8,8,0,0,1,1.18-1.38c.77-.81,1.86-1.91,3.07-3.11s2.34-2.26,3.16-3A6.74,6.74,0,0,1,638.78,96.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687,96.75a7.53,7.53,0,0,1,1.38,1.19c.82.77,1.92,1.85,3.11,3.07s2.26,2.32,3,3.15a8.12,8.12,0,0,1,1.16,1.39,7.19,7.19,0,0,1-1.38-1.18c-.81-.77-1.92-1.86-3.11-3.07s-2.27-2.34-3-3.16A7.56,7.56,0,0,1,687,96.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.86,46.42A7.75,7.75,0,0,1,688.05,45c.77-.81,1.85-1.91,3.06-3.1s2.33-2.26,3.15-3a7.92,7.92,0,0,1,1.4-1.16,7.94,7.94,0,0,1-1.19,1.38c-.77.81-1.85,1.91-3.07,3.11s-2.33,2.27-3.15,3A8,8,0,0,1,686.86,46.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.65,46.54a7.37,7.37,0,0,1-1.39-1.19c-.81-.77-1.91-1.85-3.1-3.06s-2.26-2.33-3-3.15a7.78,7.78,0,0,1-1.16-1.4,8.41,8.41,0,0,1,1.38,1.19c.81.77,1.91,1.85,3.11,3.07s2.26,2.33,3,3.15A8,8,0,0,1,638.65,46.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.86,96.54a2.17,2.17,0,0,1,0-.24c0-.17,0-.4,0-.7,0-.63,0-1.54,0-2.72,0-2.38,0-5.84-.05-10.24,0-8.8-.06-21.34-.1-36.36l.19.19-48.08,0h0l.21-.22c0,18.45,0,35.71,0,50.26l-.18-.18,34.81.09,9.78,0,2.59,0h0l-2.55,0-9.74,0-34.93.09h-.19v-.19c0-14.55,0-31.81,0-50.26v-.21h.22l48.08,0h.19v.18c0,15.07-.07,27.65-.09,36.48,0,4.38,0,7.83-.05,10.2,0,1.16,0,2.06,0,2.68,0,.29,0,.51,0,.68A1.57,1.57,0,0,1,686.86,96.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.84,
    y: 63.37,
    width: 16.09,
    height: 16.09,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.14,
    y: 139.8,
    width: 65.94,
    height: 68.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.67,
    y: 139.8,
    width: 65.94,
    height: 68.74,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.63,208.56h-66V139.78h66Zm-65.94-.05h65.9V139.82h-65.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.53,
    y: 149.04,
    width: 48.21,
    height: 50.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.53,199.63a7.94,7.94,0,0,1-1.19,1.38c-.77.81-1.85,1.91-3.06,3.11s-2.33,2.26-3.15,3a7.06,7.06,0,0,1-1.39,1.16,7.23,7.23,0,0,1,1.18-1.37c.77-.82,1.85-1.92,3.07-3.12s2.33-2.26,3.16-3A7.76,7.76,0,0,1,636.53,199.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.75,199.51a8.11,8.11,0,0,1,1.38,1.18c.81.78,1.91,1.86,3.11,3.07s2.26,2.33,3,3.15a7.06,7.06,0,0,1,1.16,1.39,7.75,7.75,0,0,1-1.37-1.18c-.82-.77-1.92-1.86-3.12-3.07s-2.26-2.34-3-3.16A7.76,7.76,0,0,1,684.75,199.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.62,149.17a7.94,7.94,0,0,1,1.19-1.38c.77-.82,1.85-1.92,3.06-3.11s2.33-2.26,3.15-3a8,8,0,0,1,1.39-1.17,7.19,7.19,0,0,1-1.18,1.38c-.77.81-1.85,1.92-3.07,3.12s-2.34,2.26-3.16,3A7.76,7.76,0,0,1,684.62,149.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.4,149.29A7.94,7.94,0,0,1,635,148.1c-.81-.77-1.91-1.85-3.11-3.06s-2.26-2.33-3-3.15a7.06,7.06,0,0,1-1.16-1.39,7.23,7.23,0,0,1,1.37,1.18c.82.77,1.92,1.85,3.12,3.07s2.26,2.33,3,3.16A7.76,7.76,0,0,1,636.4,149.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.62,199.29a.87.87,0,0,1,0-.24c0-.17,0-.4,0-.7,0-.63,0-1.54,0-2.71,0-2.38,0-5.85-.05-10.25,0-8.8,0-21.34-.09-36.35l.19.18-48.08,0h0l.22-.21c0,18.44,0,35.7,0,50.25l-.19-.18,34.82.09,9.78.05,2.58,0h.91a.89.89,0,0,1-.22,0h-.65l-2.55,0-9.73,0-34.94.1h-.18v-.19c0-14.55,0-31.81,0-50.25v-.22h.22l48.08,0h.18V149c0,15.06-.07,27.64-.09,36.47,0,4.38,0,7.83-.05,10.2,0,1.16,0,2.06,0,2.68,0,.29,0,.51,0,.68S684.62,199.3,684.62,199.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.6,
    y: 166.12,
    width: 16.09,
    height: 16.09,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.98,
    y: 33.13,
    width: 106.77,
    height: 146.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.8,
    y: 33.13,
    width: 110.26,
    height: 146.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.33,
    y: 43.4,
    width: 89.26,
    height: 125.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.33,168.77h89.25V135.89H41.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.81,99.73l2.89,6.73s-6.6,4.81-5.64,12.23,6.46,22.39,6.46,22.39h11.54s5.77-20.88,5.63-24.31-5.08-10.17-5.08-10.17l2.61-6.87S103.92,93.41,95.81,99.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.21,121.85c-2.23-2-5-4.51-5.92-7.92a4.53,4.53,0,0,1,.5-4,4.08,4.08,0,0,1,3.37-1.43,10.21,10.21,0,0,1,3.22.8l-.53,1.42a8.79,8.79,0,0,0-2.73-.7,2.57,2.57,0,0,0-2.12.83,3.26,3.26,0,0,0-.25,2.68c.8,3,3.39,5.31,5.47,7.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.51,122.79l-1.13-1a18,18,0,0,0,3.3-5.25,7.43,7.43,0,0,0,.66-2.61,3.27,3.27,0,0,0-.69-2.26,2.89,2.89,0,0,0-2.46-.89,4.31,4.31,0,0,0-2.55,1.3L111.57,111a5.76,5.76,0,0,1,3.47-1.73,4.41,4.41,0,0,1,3.75,1.4,4.79,4.79,0,0,1,1.07,3.3,9.38,9.38,0,0,1-.78,3.14A19.67,19.67,0,0,1,115.51,122.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.22,99.79a10.42,10.42,0,0,1-2.65.67,39.82,39.82,0,0,1-6.57.59,39.24,39.24,0,0,1-6.58-.49,10.7,10.7,0,0,1-2.66-.62,17.71,17.71,0,0,1,2.71.23,60.63,60.63,0,0,0,6.53.32,61.91,61.91,0,0,0,6.51-.42A17.94,17.94,0,0,1,114.22,99.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58,60.36c-1.11-1.52-6.44-3.45-8.3-3.76-8.31-1.36-17-1.5-25,1.14S82.07,66.09,79,73.91c-1.61,4-2.11,8.49-4.21,12.29-2.68,4.82-7.57,7.94-11.28,12a29.93,29.93,0,0,0-1.57,38.49l22.4.28c-.54-8.81-.52-17.83,2.1-26.26s8.19-16.29,16.23-19.94c8.44-3.83,19.16-2.9,28.33-1.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.77,43.4c2.49,3.84-.71,10.08-4,13.28s-7.4,5.89-8.92,10.2,0,9.1-.71,13.6A13.48,13.48,0,0,1,41.33,90.57V43.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.92,125s1.22,1.7.73,2.8-6.32,8.88-4.13,14.23a61,61,0,0,0,6.57,11.2H81.72s6.71-10.59,6.57-14.12c-.23-5.85-4.5-11.92-4.5-11.92L84.88,125S72.23,121.37,64.92,125Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58,168.77s0-.21,0-.61,0-1,0-1.77c0-1.56,0-3.86,0-6.84,0-6,0-14.71-.06-25.76,0-22.07-.08-53.38-.13-90.39l.25.26-89.24,0h0l.28-.28c0,47,0,90.39-.06,125.37l-.22-.23,64.89.12,18,.06,4.73,0c1.07,0,1.63,0,1.63,0l-1.58,0-4.69,0-18,.06-65,.12H41.1v-.23c0-35,0-78.41-.05-125.37v-.28h.29l89.24,0h.26v.25c-.05,37.08-.1,68.45-.13,90.56,0,11-.05,19.73-.07,25.7,0,3,0,5.24,0,6.79,0,.76,0,1.34,0,1.74S130.58,168.77,130.58,168.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.07,33.13a39.2,39.2,0,0,1-5,5.34,63.64,63.64,0,0,1-5.44,4.93,39.89,39.89,0,0,1,5-5.34A63.64,63.64,0,0,1,141.07,33.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.51,33.09a50.54,50.54,0,0,1,5.64,5,49.15,49.15,0,0,1,5.26,5.37,51.37,51.37,0,0,1-5.64-5A50.22,50.22,0,0,1,30.51,33.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8,180.12a51.32,51.32,0,0,1,5-5.57,50.71,50.71,0,0,1,5.41-5.17,49.5,49.5,0,0,1-5,5.56A49.31,49.31,0,0,1,30.8,180.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.72,180.3c-.15.09-2-2.88-4.8-6.09s-5.52-5.43-5.41-5.56a7.65,7.65,0,0,1,1.88,1.32,34.78,34.78,0,0,1,4,3.87,34.2,34.2,0,0,1,3.31,4.43A7.94,7.94,0,0,1,140.72,180.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.15,
    y: 33.21,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23,59.64a1.35,1.35,0,0,1,0-.24v-.66c0-.6,0-1.45,0-2.53,0-2.22-.05-5.42-.08-9.45l.15.16L239.58,47c.11-.11-.25.25.24-.25h0V59.64l-.24-.25,34.67.11,10.23.07,2.77,0,.72,0a.81.81,0,0,1,.26,0H288l-.69,0-2.71,0-10.18.07-34.84.11h-.25V46.77h0c.49-.49.14-.13.25-.24l48.65.09h.15v.15c0,4.07-.06,7.3-.08,9.54,0,1.07,0,1.9,0,2.5,0,.26,0,.47,0,.63A1.66,1.66,0,0,1,288.23,59.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 673.75,
    y: 316.55,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.83,343a2.07,2.07,0,0,1,0-.23l0-.66c0-.61,0-1.45,0-2.54,0-2.22,0-5.41-.08-9.44l.15.15-48.65.1.25-.25h0v6.52q0,3.23,0,6.33l-.24-.24,34.67.11,10.23.07,2.77,0,.73,0h.25s-.07,0-.22,0h-.7l-2.71,0-10.18.06-34.84.11h-.24V343q0-3.11,0-6.33v-6.52h0l.25-.25,48.65.1H702v.15c0,4.07-.06,7.29-.08,9.53,0,1.07,0,1.91,0,2.5,0,.26,0,.47,0,.64S701.84,343,701.83,343Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.21,52.54a1,1,0,0,1,0-.23v-.66c0-.61,0-1.45,0-2.53,0-2.23,0-5.42-.08-9.45l.15.15-48.65.1c.11-.11-.25.25.24-.25h0V52.54l-.24-.24,34.67.11,10.23.07,2.77,0,.72,0h.26l-.23,0-.69,0-2.71,0-10.18.07-34.84.11h-.25V39.68h0l.25-.25,48.65.1h.15v.15c0,4.07-.06,7.29-.08,9.54,0,1.06,0,1.9,0,2.5l0,.63A1.23,1.23,0,0,1,540.21,52.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.81,39.67a.68.68,0,0,1,0-.24c0-.19,0-.41,0-.68,0-.64,0-1.5,0-2.58,0-2.26-.05-5.45-.09-9.37l.18.18-29.23.07c-.23.22.3-.3.24-.25h0v6.62c0,2.15,0,4.24,0,6.24l-.24-.23,20.91.11,6.1.06,1.64,0,.59,0a3.43,3.43,0,0,1-.53,0l-1.6,0-6,.07-21.07.11h-.23v-.24c0-2,0-4.09,0-6.24V26.81h0l.25-.25,29.23.07H547v.18c0,4-.07,7.19-.09,9.47,0,1.07,0,1.92,0,2.54A8.58,8.58,0,0,1,546.81,39.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.46,269a1.35,1.35,0,0,1,0-.24c0-.17,0-.39,0-.66,0-.6,0-1.45,0-2.53,0-2.22,0-5.42-.09-9.44l.16.15-48.65.09.24-.24h0V269l-.25-.25,34.67.11,10.24.07,2.77,0h.72l.26,0h-.23l-.69,0-2.72,0-10.18.07-34.84.11h-.24V256.16h0l.25-.25,48.65.09h.15v.16c0,4.06-.07,7.29-.09,9.53,0,1.07,0,1.9,0,2.5l0,.63A1.66,1.66,0,0,1,72.46,269Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.05,256.14s0-.09,0-.25,0-.41,0-.68c0-.64,0-1.5,0-2.58,0-2.26-.06-5.45-.1-9.37l.18.18-29.23.07c-.22.22.3-.3.25-.24h0v3.33c0,1.1,0,2.2,0,3.27v6.25l-.24-.24,20.91.11,6.09.07,1.65,0,.58,0a4.89,4.89,0,0,1-.53,0l-1.59,0-6,.07-21.07.11h-.24v-6.48c0-1.07,0-2.17,0-3.27v-3.33h0s.47-.48.25-.25l29.23.07h.18v.17c0,4-.07,7.19-.1,9.48,0,1.07,0,1.91,0,2.54A6.84,6.84,0,0,1,79.05,256.14Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704,426.89c0,.14-149.56.26-334,.26S36,427,36,426.89s149.53-.26,334-.26S704,426.74,704,426.89Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bullet-journal--inject-10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.26,
    y: 84.59,
    width: 491.92,
    height: 345,
    rx: 27.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.48,90H568.24a29,29,0,0,1,29,29V395.15a29,29,0,0,1-29,29H361.48a0,0,0,0,1,0,0V90A0,0,0,0,1,361.48,90Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.92,423.6h-209V89.47h209a29,29,0,0,1,29,29V394.6A29,29,0,0,1,564.92,423.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.92,423.6l2.89-.17a30.33,30.33,0,0,0,8.18-2.08,29.21,29.21,0,0,0,11-8.06,31.06,31.06,0,0,0,4.59-7.44,29.45,29.45,0,0,0,2.18-9.69c.13-1.76,0-3.59.07-5.45V385c0-3.93,0-8.06,0-12.36q0-12.93,0-28c0-20.12,0-43,0-68.34s0-53.06,0-82.83q0-22.33,0-46.15,0-11.9,0-24.13v-4.6l-.07-1.52-.09-1.53L593.3,114c-.09-.5-.13-1-.25-1.51l-.39-1.49A28.58,28.58,0,0,0,587,100.06a29.19,29.19,0,0,0-9.85-7.58,28.85,28.85,0,0,0-12.26-2.77h-209l.26-.26c0,127.18,0,243.54-.06,334.13l-.2-.2,152.56.09,41.81.05,10.91,0,3.72,0-3.72,0-10.91,0-41.81.06-152.56.09h-.2v-.21c0-90.59,0-206.95-.06-334.13v-.26H564.91a29.48,29.48,0,0,1,22.47,10.53,29.08,29.08,0,0,1,5.74,11.08l.39,1.51c.13.51.17,1,.26,1.54l.23,1.54.09,1.55.07,1.54v28.73q0,23.79,0,46.15c0,29.77,0,57.51,0,82.83s0,48.22,0,68.34q0,15.09,0,28c0,4.3,0,8.43,0,12.36v5.75c0,1.87.05,3.68-.09,5.46a29.51,29.51,0,0,1-2.22,9.75,31.35,31.35,0,0,1-4.63,7.47A29.16,29.16,0,0,1,576,421.45a30.61,30.61,0,0,1-8.22,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.07,118.38a3.22,3.22,0,0,1,.46,1.63,3.16,3.16,0,1,1-5.85-1.63h-5a3.16,3.16,0,1,1-5.38,0h-5a3.16,3.16,0,1,1-5.38,0h-5a3.16,3.16,0,1,1-5.39,0h-5a3.15,3.15,0,1,1-5.38,0h-5a3.16,3.16,0,1,1-5.38,0h-5a3.15,3.15,0,1,1-5.85,1.63,3.22,3.22,0,0,1,.46-1.63h-5a3.15,3.15,0,1,1-5.38,0H381.5V247.86h89.23V118.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.92,423.6H140.34a22.43,22.43,0,0,1-22.43-22.43V111.9a22.43,22.43,0,0,1,22.43-22.43H355.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.92,423.6c0-2.12-.1-137.1-.24-334.13l.24.23-109.65,0H142.81a30.78,30.78,0,0,0-7.5.59,21.08,21.08,0,0,0-6.91,2.92A23,23,0,0,0,123.08,98a21.45,21.45,0,0,0-3.51,6.21c-1.84,4.48-1.31,9.4-1.4,14.17v84.43c0,36.63,0,71.95,0,105.6q0,25.24,0,49.18v23.56c0,3.86,0,7.7,0,11.5v8.51c.07.92,0,1.86.19,2.77a22.25,22.25,0,0,0,22.39,19.46h10.51l39.92,0,164.78.18-164.71.19-40,0H140.71A22.7,22.7,0,0,1,117.89,404c-.15-.94-.12-1.89-.19-2.83v-8.51c0-3.8,0-7.64,0-11.5V357.6q0-23.91,0-49.18c0-33.65,0-69,0-105.6V147q0-14.18,0-28.57c0-2.4,0-4.79,0-7.21a22.7,22.7,0,0,1,5-13.49,23.51,23.51,0,0,1,5.45-4.89,21.4,21.4,0,0,1,7.07-3,31.06,31.06,0,0,1,7.62-.61H246.27l109.65,0h.24v.24C356,286.5,355.92,421.48,355.92,423.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.25,100.37s-.05.08-.17.23l-.56.63-2.19,2.41c-1.92,2.07-4.66,5.09-8,8.86-6.71,7.53-15.76,18.13-25.21,30.28S132.63,166.33,127,174.7c-2.82,4.18-5.08,7.58-6.61,10-.76,1.15-1.35,2.06-1.79,2.71l-.47.7c-.11.16-.17.24-.18.23a1.56,1.56,0,0,1,.13-.26l.43-.72,1.7-2.77c1.48-2.41,3.69-5.85,6.47-10.06,5.56-8.42,13.56-19.86,23-32s18.56-22.74,25.35-30.21c3.39-3.73,6.18-6.72,8.14-8.75l2.27-2.33.6-.6A1.21,1.21,0,0,1,186.25,100.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,172.55c16-1.73,32.46-7.88,45-17.89a231.38,231.38,0,0,0-45,17.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.38,152.67C157.06,151,171,146,182.52,136.72a200.88,200.88,0,0,0-40.14,15.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.3,123.66c12.69-8.21,24.24-20.21,30.56-33.93-13.76,8.56-24.4,18-30.56,33.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,129.09a80.71,80.71,0,0,0,40.55-18.86c-14.46,4.76-27.4,11.19-40.55,18.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.33,154.37c-2-14.27-1.33-27.6,4.66-40.69-.43,14.5-1.22,26.59-4.66,40.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.66,171.42c-4.29-14.65-5.73-28.72-1.51-43.39,1.83,15.27,2.9,28.07,1.51,43.39",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.35,137.13c-.89-13.25,1.73-27.59,8.07-39.26a190.67,190.67,0,0,1-8.07,39.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.93,177a1.56,1.56,0,0,1-.17-.23l-.46-.69c-.41-.66-1-1.56-1.72-2.71-1.48-2.36-3.65-5.76-6.37-9.93-5.43-8.35-13.18-19.72-22.31-31.88s-17.9-22.76-24.41-30.3c-3.25-3.78-5.91-6.8-7.76-8.88l-2.13-2.41-.54-.63a1.58,1.58,0,0,1-.17-.23s.08.06.21.19.35.35.58.6c.54.56,1.27,1.35,2.2,2.34,1.91,2,4.61,5,7.9,8.77,6.59,7.48,15.41,18.07,24.56,30.23s16.84,23.58,22.2,32c2.68,4.2,4.8,7.63,6.22,10L365.4,176c.16.3.3.53.41.72A1,1,0,0,1,365.93,177Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.36,102.46c-2.49,15.65-.91,33,5.36,47.53a228.76,228.76,0,0,0-5.36-47.53",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.49,121.6c-2.25,14.41-1,29,4.78,42.38a198.07,198.07,0,0,0-4.78-42.38",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18,151c4.53,14.21,13,28.33,24.4,37.91C369,173.55,362.78,161,349.18,151",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.13,145.43A79.77,79.77,0,0,0,352.58,189c-.78-15-3.55-29-7.45-43.52",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.15,120.16c14.09,1.84,26.63,5.9,37.55,15-13.71-4.17-25-8.07-37.55-15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.18,103.66c15.07-.28,28.85,2,41.74,9.83-15-2.22-27.5-4.53-41.74-9.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.19,137c12.86,2.59,25.83,8.81,35.31,17.87A189.1,189.1,0,0,1,339.19,137",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.3,294.49s-.07-.07-.17-.22l-.46-.7c-.42-.65-1-1.56-1.72-2.71-1.48-2.36-3.65-5.76-6.37-9.93-5.43-8.35-13.19-19.72-22.31-31.87s-17.9-22.77-24.41-30.31c-3.25-3.77-5.91-6.8-7.77-8.88l-2.12-2.4-.54-.64c-.12-.14-.18-.22-.17-.23a1.32,1.32,0,0,1,.21.19l.58.6,2.2,2.34c1.91,2,4.61,5,7.9,8.77,6.58,7.48,15.41,18.07,24.55,30.23s16.85,23.59,22.2,32c2.68,4.2,4.8,7.63,6.23,10l1.63,2.76.42.73A.92.92,0,0,1,575.3,294.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.72,220c-2.49,15.65-.91,33,5.37,47.53A228.25,228.25,0,0,0,521.72,220",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.85,239.13c-2.24,14.41-1,29,4.79,42.38a197.37,197.37,0,0,0-4.79-42.38",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.55,268.49c4.53,14.21,13,28.33,24.39,37.91-4.58-15.33-10.8-27.91-24.39-37.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.5,263A79.77,79.77,0,0,0,562,306.47c-.79-15-3.55-29-7.45-43.52",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.51,237.68c14.1,1.85,26.63,5.9,37.55,15-13.7-4.17-25-8.06-37.55-15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.55,221.19c15.07-.29,28.85,2,41.73,9.82-15-2.22-27.5-4.52-41.73-9.82",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.55,254.56c12.86,2.59,25.84,8.81,35.31,17.88a188.84,188.84,0,0,1-35.31-17.88",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.83,363.2s-.06.06-.21.16l-.63.42-2.48,1.57c-2.16,1.35-5.27,3.34-9.09,5.82-7.63,5-18,12.07-29.15,20.41S385.45,408,378.55,413.91c-3.45,3-6.22,5.4-8.12,7.1l-2.2,1.94-.58.5q-.19.17-.21.15l.18-.19.54-.53,2.14-2c1.86-1.75,4.6-4.22,8-7.23,6.85-6,16.53-14.09,27.65-22.45s21.58-15.41,29.26-20.31c3.85-2.45,7-4.39,9.18-5.69l2.52-1.5.67-.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.68,412.2c14.32,2.28,30.16.84,43.47-4.9a209,209,0,0,0-43.47,4.9",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.19,398.36c13.18,2.06,26.53.95,38.76-4.37a180.48,180.48,0,0,0-38.76,4.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.05,378.52c13-4.14,25.91-11.85,34.67-22.31-14,4.19-25.52,9.88-34.67,22.31",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,382.22a72.86,72.86,0,0,0,39.8-6.81c-13.72.72-26.52,3.25-39.8,6.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.87,399.59c1.69-12.89,5.39-24.36,13.72-34.34-3.81,12.53-7.38,22.88-13.72,34.34",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.78,411.45c-.26-13.79,1.83-26.39,9-38.17-2,13.74-4.14,25.15-9,38.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.31,387.66c2.36-11.76,8.06-23.63,16.35-32.29a173,173,0,0,1-16.35,32.29",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.2,324a1.16,1.16,0,0,1-.15.26l-.46.73-1.82,2.81c-1.6,2.42-3.89,5.94-6.67,10.32-5.56,8.76-13,21-20.56,34.94s-13.84,26.81-18.17,36.24c-2.17,4.72-3.89,8.55-5.06,11.21-.58,1.3-1,2.32-1.36,3.05l-.37.79a.94.94,0,0,1-.14.26,1,1,0,0,1,.09-.28c.09-.21.19-.48.32-.81l1.27-3.09c1.1-2.69,2.77-6.55,4.9-11.28,4.25-9.48,10.47-22.42,18-36.35s15.07-26.17,20.72-34.88c2.82-4.36,5.16-7.86,6.81-10.24l1.91-2.75.51-.7C260.13,324.06,260.19,324,260.2,324Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.73,407c15.92-4.41,31.65-13.4,42.74-25.64A238.26,238.26,0,0,0,212.73,407",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.34,384.38c14.63-4.11,27.94-11.57,38.1-22.86a205.47,205.47,0,0,0-38.1,22.86",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.79,351.11c11.52-10.44,21.25-24.54,25.39-39.52-12.55,11-21.79,22.31-25.39,39.52",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.29,357.35a83,83,0,0,0,38-25.89c-13.88,7.24-26,15.91-38,25.89",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.55,386.27c-4.35-14.16-5.93-27.79-2-42.08,2,14.79,3.17,27.2,2,42.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.52,405.69c-6.79-14.16-10.59-28.21-8.74-43.8,4.4,15.2,7.61,28,8.74,43.8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,366.61c-3.11-13.31-2.82-28.3,1.68-41.2a197.19,197.19,0,0,1-1.68,41.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.84,145c0,1.58-1.14,2.53-3,2.53H147v2.2h-1v-7.26h2.84C150.7,142.44,151.84,143.39,151.84,145Zm-1,0c0-1-.7-1.63-2-1.63H147v3.26h1.77C150.1,146.6,150.8,146,150.8,145Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.32,142h1v7.7h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.57,146.38v3.32h-.94V149a2.06,2.06,0,0,1-1.81.79c-1.25,0-2-.66-2-1.62s.57-1.6,2.21-1.6h1.57v-.2c0-.84-.48-1.33-1.47-1.33a2.79,2.79,0,0,0-1.74.59l-.42-.74a3.64,3.64,0,0,1,2.27-.71C159.72,144.15,160.57,144.88,160.57,146.38Zm-1,1.64v-.77H158c-1,0-1.27.39-1.27.85s.46.9,1.22.9A1.6,1.6,0,0,0,159.57,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.63,146.54v3.16h-1v-3c0-1.08-.54-1.61-1.49-1.61a1.63,1.63,0,0,0-1.74,1.83v2.83h-1v-5.5h1V145a2.35,2.35,0,0,1,2-.88A2.13,2.13,0,0,1,167.63,146.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.69,146.54v3.16h-1v-3c0-1.08-.54-1.61-1.48-1.61a1.64,1.64,0,0,0-1.75,1.83v2.83h-1v-5.5h1V145a2.36,2.36,0,0,1,2-.88A2.13,2.13,0,0,1,174.69,146.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.52,147.28h-4.46a1.85,1.85,0,0,0,2,1.61,2.09,2.09,0,0,0,1.59-.66l.55.64a3,3,0,0,1-5.13-1.92,2.69,2.69,0,0,1,2.76-2.8,2.65,2.65,0,0,1,2.72,2.83C181.54,147.07,181.53,147.19,181.52,147.28Zm-4.46-.71h3.53a1.78,1.78,0,0,0-3.53,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.87,144.15v1h-.22a1.65,1.65,0,0,0-1.74,1.86v2.74h-1v-5.5h1v.93A2.09,2.09,0,0,1,185.87,144.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.5,179.29h-2.12v-1h5.42v1h-2.12v5.38H169.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.41,181.82v2.85h-1.08v-.59a1.73,1.73,0,0,1-1.53.66c-1.12,0-1.82-.61-1.82-1.46s.55-1.45,2-1.45h1.25v-.08c0-.66-.4-1.05-1.21-1.05a2.43,2.43,0,0,0-1.48.48l-.44-.83a3.42,3.42,0,0,1,2.06-.6C176.59,179.75,177.41,180.41,177.41,181.82Zm-1.15,1.33v-.57h-1.17c-.78,0-1,.3-1,.65s.35.68.93.68A1.24,1.24,0,0,0,176.26,183.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.31,184.19l.43-.87a3.23,3.23,0,0,0,1.7.49c.72,0,1-.2,1-.54,0-.93-3-.06-3-2,0-.92.83-1.52,2.15-1.52a3.82,3.82,0,0,1,1.82.42L182,181a2.68,2.68,0,0,0-1.39-.36c-.7,0-1,.23-1,.55,0,1,3,.11,3,2,0,.91-.84,1.51-2.21,1.51A3.85,3.85,0,0,1,178.31,184.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.55,182.58l-.85.81v1.28h-1.14V177.9h1.14V182l2.36-2.19h1.37l-2,2,2.23,2.82h-1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.65,184.19l.44-.87a3.21,3.21,0,0,0,1.7.49c.72,0,1-.2,1-.54,0-.93-3-.06-3-2,0-.92.83-1.52,2.14-1.52a3.83,3.83,0,0,1,1.83.42l-.44.86a2.71,2.71,0,0,0-1.4-.36c-.69,0-1,.23-1,.55,0,1,3,.11,3,2,0,.91-.84,1.51-2.21,1.51A3.88,3.88,0,0,1,188.65,184.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.38,200v.36l-1.47,3.29h-.55l1.44-3.19h-1.67v.65h-.5V200Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.72,201.23a.35.35,0,0,1,.36-.36.36.36,0,1,1-.36.36Zm0,2.1a.35.35,0,0,1,.36-.36.36.36,0,0,1,0,.72A.35.35,0,0,1,148.72,203.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.91,201.83c0-1.18.64-1.86,1.49-1.86s1.48.68,1.48,1.86-.63,1.87-1.48,1.87S149.91,203,149.91,201.83Zm2.45,0c0-.93-.39-1.4-1-1.4s-1,.47-1,1.4.4,1.4,1,1.4S152.36,202.77,152.36,201.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.38,201.83c0-1.18.64-1.86,1.49-1.86s1.48.68,1.48,1.86-.63,1.87-1.48,1.87S153.38,203,153.38,201.83Zm2.45,0c0-.93-.39-1.4-1-1.4s-1,.47-1,1.4.4,1.4,1,1.4S155.83,202.77,155.83,201.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.87,202.74h-1.94l-.4.92H158l1.65-3.65h.51l1.66,3.65h-.55Zm-.18-.41-.79-1.79-.79,1.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.73,203.66V201l-1.32,2.21h-.24L162.85,201v2.64h-.49V200h.42l1.52,2.56,1.5-2.56h.43v3.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6,213.94c0,.66-.56,1.07-1.45,1.07s-1.44-.41-1.44-1.07a.88.88,0,0,1,.64-.88.82.82,0,0,1-.51-.79c0-.61.52-1,1.31-1s1.32.38,1.32,1a.83.83,0,0,1-.52.79A.9.9,0,0,1,148.6,213.94Zm-.52,0c0-.4-.36-.65-.93-.65s-.92.25-.92.65.34.67.92.67S148.08,214.33,148.08,213.92Zm-1.73-1.63c0,.36.3.59.8.59s.81-.23.81-.59-.32-.58-.81-.58S146.35,211.93,146.35,212.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.07,212.54a.35.35,0,0,1,.35-.36.36.36,0,0,1,0,.72A.35.35,0,0,1,149.07,212.54Zm0,2.1a.34.34,0,0,1,.35-.35.33.33,0,0,1,.34.35.34.34,0,0,1-.34.36A.35.35,0,0,1,149.07,214.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.26,213.15c0-1.19.63-1.87,1.48-1.87s1.49.68,1.49,1.87-.64,1.86-1.49,1.86S150.26,214.33,150.26,213.15Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S152.71,214.08,152.71,213.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.73,213.15c0-1.19.63-1.87,1.48-1.87s1.49.68,1.49,1.87-.64,1.86-1.49,1.86S153.73,214.33,153.73,213.15Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S156.18,214.08,156.18,213.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.21,214.06h-1.93l-.4.91h-.54l1.65-3.64h.51l1.66,3.64h-.55Zm-.18-.42-.79-1.78-.78,1.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.08,215v-2.66l-1.32,2.22h-.24l-1.31-2.2V215h-.5v-3.64h.43l1.51,2.56,1.5-2.56h.43V215Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.44,224.41a1.68,1.68,0,0,1-1.73,1.91,1.79,1.79,0,0,1-.9-.21l.2-.41a1.22,1.22,0,0,0,.7.17c.74,0,1.21-.46,1.21-1.37v-.13a1.22,1.22,0,0,1-1,.48,1.12,1.12,0,0,1-1.25-1.1,1.17,1.17,0,0,1,1.29-1.15C147.89,222.6,148.44,223.25,148.44,224.41Zm-.64-.69c0-.37-.3-.7-.87-.7a.71.71,0,0,0-.8.71c0,.42.31.7.82.7A.77.77,0,0,0,147.8,223.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.92,223.85a.35.35,0,0,1,.36-.35.33.33,0,0,1,.34.35.34.34,0,0,1-.34.36A.36.36,0,0,1,148.92,223.85Zm0,2.1a.35.35,0,0,1,.36-.35.33.33,0,0,1,.34.35.34.34,0,0,1-.34.36A.36.36,0,0,1,148.92,226Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.12,224.46c0-1.19.63-1.86,1.48-1.86s1.49.67,1.49,1.86-.64,1.86-1.49,1.86S150.12,225.65,150.12,224.46Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S152.57,225.39,152.57,224.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.59,224.46c0-1.19.63-1.86,1.48-1.86s1.49.67,1.49,1.86-.64,1.86-1.49,1.86S153.59,225.65,153.59,224.46Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S156,225.39,156,224.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.07,225.37h-1.93l-.41.91h-.53l1.65-3.64h.51l1.66,3.64h-.55Zm-.18-.42-.79-1.78-.78,1.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.94,226.28v-2.65l-1.32,2.21h-.24l-1.31-2.2v2.64h-.5v-3.64H163l1.52,2.56,1.5-2.56h.43v3.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,234v3.64h-.52V234.4h-.82V234Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.65,235.77c0-1.19.64-1.86,1.49-1.86s1.48.67,1.48,1.86-.63,1.86-1.48,1.86S147.65,237,147.65,235.77Zm2.45,0c0-.93-.39-1.4-1-1.4s-1,.47-1,1.4.4,1.4,1,1.4S150.1,236.7,150.1,235.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.11,235.16a.35.35,0,0,1,.7,0,.35.35,0,1,1-.7,0Zm0,2.1a.35.35,0,1,1,.35.36A.35.35,0,0,1,151.11,237.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.3,235.77c0-1.19.64-1.86,1.49-1.86s1.48.67,1.48,1.86-.63,1.86-1.48,1.86S152.3,237,152.3,235.77Zm2.45,0c0-.93-.39-1.4-1-1.4s-1,.47-1,1.4.4,1.4,1,1.4S154.75,236.7,154.75,235.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,235.77c0-1.19.63-1.86,1.49-1.86s1.48.67,1.48,1.86-.63,1.86-1.48,1.86S155.77,237,155.77,235.77Zm2.45,0c0-.93-.39-1.4-1-1.4s-1,.47-1,1.4.4,1.4,1,1.4S158.22,236.7,158.22,235.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.26,236.68h-1.94l-.4.91h-.54L162,234h.52l1.65,3.64h-.54Zm-.19-.41-.78-1.79-.79,1.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.12,237.59v-2.65l-1.31,2.21h-.24l-1.32-2.2v2.64h-.5V234h.43l1.52,2.56,1.5-2.56h.42v3.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,245.26v3.64h-.52v-3.19h-.82v-.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.78,245.26v3.64h-.52v-3.19h-.82v-.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.56,246.47a.36.36,0,0,1,.36-.35.36.36,0,0,1,0,.71A.36.36,0,0,1,149.56,246.47Zm0,2.11a.36.36,0,0,1,.36-.36.36.36,0,0,1,0,.71A.36.36,0,0,1,149.56,248.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.76,247.08c0-1.18.63-1.86,1.48-1.86s1.49.68,1.49,1.86-.64,1.86-1.49,1.86S150.76,248.27,150.76,247.08Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S153.21,248,153.21,247.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.23,247.08c0-1.18.63-1.86,1.48-1.86s1.49.68,1.49,1.86-.64,1.86-1.49,1.86S154.23,248.27,154.23,247.08Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S156.68,248,156.68,247.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.71,248h-1.94l-.4.91h-.53l1.65-3.64H161l1.66,3.64h-.55Zm-.18-.41-.79-1.79-.78,1.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.57,248.9v-2.65l-1.32,2.21H165l-1.31-2.19v2.63h-.5v-3.64h.42l1.52,2.56,1.5-2.56h.43v3.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,256.57v3.65h-.52V257h-.82v-.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.21,259.76v.46h-2.62v-.36l1.49-1.43c.38-.37.45-.6.45-.83,0-.38-.26-.61-.77-.61a1.14,1.14,0,0,0-.93.4l-.36-.31a1.69,1.69,0,0,1,1.34-.55c.76,0,1.24.39,1.24,1a1.47,1.47,0,0,1-.59,1.14l-1.12,1.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.63,257.79a.35.35,0,0,1,.35-.36.36.36,0,0,1,0,.71A.35.35,0,0,1,150.63,257.79Zm0,2.1a.35.35,0,0,1,.35-.36.36.36,0,0,1,0,.72A.35.35,0,0,1,150.63,259.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.82,258.39c0-1.18.63-1.86,1.48-1.86s1.49.68,1.49,1.86-.64,1.87-1.49,1.87S151.82,259.58,151.82,258.39Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S154.27,259.33,154.27,258.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.29,258.39c0-1.18.63-1.86,1.48-1.86s1.49.68,1.49,1.86-.64,1.87-1.49,1.87S155.29,259.58,155.29,258.39Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S157.74,259.33,157.74,258.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.39,257.84c0,.79-.57,1.27-1.52,1.27H161v1.11h-.52v-3.65h1.42C162.82,256.57,163.39,257.05,163.39,257.84Zm-.52,0c0-.52-.35-.81-1-.81H161v1.63h.89C162.52,258.66,162.87,258.36,162.87,257.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.53,260.22v-2.66l-1.32,2.21H166l-1.32-2.19v2.64h-.5v-3.65h.43l1.52,2.56,1.5-2.56H168v3.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,267.88v3.65h-.52v-3.19h-.82v-.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.14,270.45c0,.62-.45,1.12-1.38,1.12a2.06,2.06,0,0,1-1.33-.44l.24-.41a1.67,1.67,0,0,0,1.09.38c.55,0,.86-.24.86-.64s-.27-.63-.9-.63h-.29v-.37l.92-1.12h-1.76v-.46H150v.36l-1,1.17C149.77,269.48,150.14,269.89,150.14,270.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.62,269.1a.35.35,0,0,1,.35-.36.36.36,0,0,1,0,.72A.35.35,0,0,1,150.62,269.1Zm0,2.1a.34.34,0,0,1,.35-.35.33.33,0,0,1,.34.35.34.34,0,0,1-.34.36A.35.35,0,0,1,150.62,271.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.81,269.71c0-1.19.63-1.87,1.48-1.87s1.49.68,1.49,1.87-.64,1.86-1.49,1.86S151.81,270.89,151.81,269.71Zm2.45,0c0-.94-.4-1.4-1-1.4s-1,.46-1,1.4.39,1.39,1,1.39S154.26,270.64,154.26,269.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.28,269.71c0-1.19.63-1.87,1.48-1.87s1.49.68,1.49,1.87-.64,1.86-1.49,1.86S155.28,270.89,155.28,269.71Zm2.45,0c0-.94-.4-1.4-1-1.4s-1,.46-1,1.4.39,1.39,1,1.39S157.73,270.64,157.73,269.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.38,269.15c0,.79-.57,1.27-1.52,1.27H161v1.11h-.52v-3.65h1.42C162.81,267.88,163.38,268.36,163.38,269.15Zm-.52,0c0-.52-.35-.81-1-.81H161V270h.89C162.51,270,162.86,269.67,162.86,269.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.52,271.53v-2.66l-1.32,2.21H166l-1.32-2.19v2.64h-.5v-3.65h.43l1.52,2.56,1.5-2.56H168v3.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,279.2v3.64h-.52v-3.19h-.82v-.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.82,281.94h-.69v.9h-.51v-.9h-2v-.36l1.86-2.38H150l-1.78,2.3h1.4v-.79h.49v.79h.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.16,280.41a.34.34,0,0,1,.35-.35.33.33,0,0,1,.34.35.34.34,0,0,1-.34.36A.35.35,0,0,1,151.16,280.41Zm0,2.1a.34.34,0,0,1,.35-.35.33.33,0,0,1,.34.35.34.34,0,0,1-.34.36A.35.35,0,0,1,151.16,282.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.35,281c0-1.19.63-1.86,1.49-1.86s1.48.67,1.48,1.86-.64,1.86-1.48,1.86S152.35,282.2,152.35,281Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S154.8,282,154.8,281Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.82,281c0-1.19.63-1.86,1.48-1.86s1.49.67,1.49,1.86-.64,1.86-1.49,1.86S155.82,282.2,155.82,281Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S158.27,282,158.27,281Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.32,280.47c0,.79-.57,1.27-1.52,1.27h-.9v1.1h-.52V279.2h1.42C164.75,279.2,165.32,279.68,165.32,280.47Zm-.52,0c0-.52-.35-.82-1-.82h-.89v1.63h.89C164.45,281.28,164.8,281,164.8,280.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.46,282.84v-2.65l-1.32,2.21h-.24l-1.32-2.2v2.64h-.5V279.2h.43l1.52,2.56,1.5-2.56H170v3.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,290.51v3.64h-.52V291h-.82v-.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.21,293.06c0,.63-.45,1.13-1.38,1.13a2.06,2.06,0,0,1-1.34-.44l.24-.41a1.62,1.62,0,0,0,1.09.39c.55,0,.86-.26.86-.65s-.26-.67-1.1-.67h-.83l.2-1.9H150V291h-1.62l-.09,1h.4C149.78,292,150.21,292.41,150.21,293.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.63,291.72a.34.34,0,0,1,.35-.35.33.33,0,0,1,.34.35.34.34,0,0,1-.34.36A.35.35,0,0,1,150.63,291.72Zm0,2.1a.34.34,0,0,1,.35-.35.33.33,0,0,1,.34.35.34.34,0,0,1-.34.36A.35.35,0,0,1,150.63,293.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.82,292.33c0-1.19.63-1.86,1.48-1.86s1.49.67,1.49,1.86-.64,1.86-1.49,1.86S151.82,293.52,151.82,292.33Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S154.27,293.26,154.27,292.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.29,292.33c0-1.19.63-1.86,1.48-1.86s1.49.67,1.49,1.86-.64,1.86-1.49,1.86S155.29,293.52,155.29,292.33Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S157.74,293.26,157.74,292.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.39,291.78c0,.79-.57,1.27-1.52,1.27H161v1.1h-.52v-3.64h1.42C162.82,290.51,163.39,291,163.39,291.78Zm-.52,0c0-.52-.35-.82-1-.82H161v1.64h.89C162.52,292.6,162.87,292.3,162.87,291.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.53,294.15V291.5l-1.32,2.21H166l-1.32-2.2v2.64h-.5v-3.64h.43l1.52,2.56,1.5-2.56H168v3.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,301.82v3.64h-.52v-3.19h-.82v-.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,304.35a1.18,1.18,0,0,1-1.29,1.15c-1,0-1.53-.65-1.53-1.81a1.68,1.68,0,0,1,1.72-1.91,1.83,1.83,0,0,1,.91.21l-.2.41a1.24,1.24,0,0,0-.7-.18c-.74,0-1.21.47-1.21,1.38a.62.62,0,0,0,0,.13,1.2,1.2,0,0,1,1-.48A1.13,1.13,0,0,1,150.47,304.35Zm-.5,0c0-.42-.33-.7-.84-.7a.75.75,0,0,0-.83.71c0,.37.3.7.86.7A.72.72,0,0,0,150,304.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.85,303a.35.35,0,1,1,.7,0,.35.35,0,1,1-.7,0Zm0,2.1a.35.35,0,1,1,.35.36A.35.35,0,0,1,150.85,305.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,303.64c0-1.19.64-1.86,1.49-1.86s1.48.67,1.48,1.86-.63,1.86-1.48,1.86S152,304.83,152,303.64Zm2.45,0c0-.93-.39-1.4-1-1.4s-1,.47-1,1.4.4,1.4,1,1.4S154.49,304.57,154.49,303.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.51,303.64c0-1.19.64-1.86,1.49-1.86s1.48.67,1.48,1.86-.63,1.86-1.48,1.86S155.51,304.83,155.51,303.64Zm2.45,0c0-.93-.39-1.4-1-1.4s-1,.47-1,1.4.4,1.4,1,1.4S158,304.57,158,303.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.61,303.09c0,.79-.57,1.27-1.51,1.27h-.9v1.1h-.53v-3.64h1.43C163,301.82,163.61,302.3,163.61,303.09Zm-.52,0c0-.52-.34-.82-1-.82h-.88v1.64h.88C162.75,303.91,163.09,303.61,163.09,303.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.76,305.46v-2.65L166.43,305h-.24l-1.31-2.2v2.64h-.5v-3.64h.43l1.51,2.56,1.5-2.56h.43v3.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,313.13v3.64h-.52v-3.19h-.82v-.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.3,313.13v.35l-1.47,3.29h-.55l1.44-3.19h-1.66v.65h-.5v-1.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.65,314.34A.35.35,0,0,1,151,314a.36.36,0,0,1,0,.71A.35.35,0,0,1,150.65,314.34Zm0,2.1a.35.35,0,0,1,.35-.35.36.36,0,0,1,0,.71A.35.35,0,0,1,150.65,316.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.84,315c0-1.19.63-1.86,1.49-1.86s1.48.67,1.48,1.86-.64,1.86-1.48,1.86S151.84,316.14,151.84,315Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S154.29,315.88,154.29,315Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.31,315c0-1.19.63-1.86,1.49-1.86s1.48.67,1.48,1.86-.64,1.86-1.48,1.86S155.31,316.14,155.31,315Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S157.76,315.88,157.76,315Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.41,314.4c0,.79-.57,1.27-1.52,1.27H161v1.1h-.52v-3.64h1.42C162.84,313.13,163.41,313.61,163.41,314.4Zm-.52,0c0-.52-.35-.82-1-.82H161v1.64h.89C162.54,315.22,162.89,314.92,162.89,314.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.55,316.77v-2.65l-1.32,2.21H166l-1.31-2.19v2.63h-.5v-3.64h.42l1.52,2.56,1.5-2.56h.43v3.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,324.44v3.65h-.52V324.9h-.82v-.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.52,327.06c0,.66-.56,1.07-1.45,1.07s-1.44-.41-1.44-1.07a.9.9,0,0,1,.64-.88.84.84,0,0,1-.51-.79c0-.61.53-1,1.31-1s1.32.38,1.32,1a.84.84,0,0,1-.51.79A.91.91,0,0,1,150.52,327.06Zm-.52,0c0-.4-.35-.65-.93-.65s-.92.25-.92.65.34.67.92.67S150,327.45,150,327Zm-1.73-1.63c0,.36.3.58.8.58s.81-.22.81-.58-.32-.59-.81-.59S148.27,325.05,148.27,325.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,325.66a.35.35,0,1,1,.35.35A.35.35,0,0,1,151,325.66Zm0,2.1a.35.35,0,1,1,.35.36A.35.35,0,0,1,151,327.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.18,326.26c0-1.18.64-1.86,1.49-1.86s1.48.68,1.48,1.86-.63,1.87-1.48,1.87S152.18,327.45,152.18,326.26Zm2.45,0c0-.93-.39-1.4-1-1.4s-1,.47-1,1.4.4,1.4,1,1.4S154.63,327.2,154.63,326.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.65,326.26c0-1.18.64-1.86,1.49-1.86s1.48.68,1.48,1.86-.63,1.87-1.48,1.87S155.65,327.45,155.65,326.26Zm2.45,0c0-.93-.39-1.4-1-1.4s-1,.47-1,1.4.4,1.4,1,1.4S158.1,327.2,158.1,326.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.76,325.71c0,.79-.58,1.27-1.52,1.27h-.9v1.11h-.52v-3.65h1.42C163.18,324.44,163.76,324.92,163.76,325.71Zm-.53,0c0-.52-.34-.81-1-.81h-.88v1.63h.88C162.89,326.53,163.23,326.23,163.23,325.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.9,328.09v-2.66l-1.32,2.21h-.23L165,325.45v2.64h-.5v-3.65H165l1.51,2.56,1.5-2.56h.43v3.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,335.76v3.64h-.52v-3.19h-.82v-.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.36,337.53a1.68,1.68,0,0,1-1.72,1.91,1.85,1.85,0,0,1-.91-.21l.2-.41a1.32,1.32,0,0,0,.7.17c.74,0,1.21-.46,1.21-1.37v-.13a1.21,1.21,0,0,1-1.05.48,1.12,1.12,0,0,1-1.24-1.11,1.17,1.17,0,0,1,1.28-1.15C149.81,335.71,150.36,336.37,150.36,337.53Zm-.64-.69c0-.38-.3-.7-.87-.7a.71.71,0,0,0-.8.7c0,.43.32.71.83.71A.76.76,0,0,0,149.72,336.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.85,337a.35.35,0,1,1,.35.36A.35.35,0,0,1,150.85,337Zm0,2.1a.35.35,0,1,1,.7,0,.35.35,0,1,1-.7,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,337.58c0-1.19.64-1.87,1.49-1.87s1.48.68,1.48,1.87-.63,1.86-1.48,1.86S152,338.76,152,337.58Zm2.45,0c0-.94-.39-1.4-1-1.4s-1,.46-1,1.4.4,1.4,1,1.4S154.49,338.51,154.49,337.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.51,337.58c0-1.19.64-1.87,1.49-1.87s1.48.68,1.48,1.87-.63,1.86-1.48,1.86S155.51,338.76,155.51,337.58Zm2.45,0c0-.94-.39-1.4-1-1.4s-1,.46-1,1.4.4,1.4,1,1.4S158,338.51,158,337.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.61,337c0,.8-.57,1.27-1.51,1.27h-.9v1.11h-.53v-3.64h1.43C163,335.76,163.61,336.23,163.61,337Zm-.52,0c0-.51-.34-.81-1-.81h-.88v1.63h.88C162.75,337.84,163.09,337.55,163.09,337Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.76,339.4v-2.66L166.43,339h-.24l-1.31-2.2v2.64h-.5v-3.64h.43l1.51,2.56,1.5-2.56h.43v3.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.29,350.26v.45h-2.62v-.35l1.48-1.43c.39-.38.46-.61.46-.84s-.27-.6-.78-.6a1.13,1.13,0,0,0-.93.4l-.35-.31a1.66,1.66,0,0,1,1.33-.55c.76,0,1.25.39,1.25,1a1.48,1.48,0,0,1-.6,1.15l-1.11,1.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.7,348.89c0-1.19.63-1.86,1.48-1.86s1.49.67,1.49,1.86-.64,1.86-1.49,1.86S148.7,350.08,148.7,348.89Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S151.15,349.82,151.15,348.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.15,348.28a.35.35,0,0,1,.36-.35.33.33,0,0,1,.34.35.34.34,0,0,1-.34.36A.36.36,0,0,1,152.15,348.28Zm0,2.1a.35.35,0,0,1,.36-.35.33.33,0,0,1,.34.35.34.34,0,0,1-.34.36A.36.36,0,0,1,152.15,350.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.35,348.89c0-1.19.63-1.86,1.48-1.86s1.49.67,1.49,1.86-.64,1.86-1.49,1.86S153.35,350.08,153.35,348.89Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S155.8,349.82,155.8,348.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.82,348.89c0-1.19.63-1.86,1.48-1.86s1.49.67,1.49,1.86-.64,1.86-1.49,1.86S156.82,350.08,156.82,348.89Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S159.27,349.82,159.27,348.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.92,348.34c0,.79-.57,1.27-1.52,1.27h-.9v1.1H162v-3.64h1.42C164.35,347.07,164.92,347.55,164.92,348.34Zm-.52,0c0-.52-.35-.82-1-.82h-.89v1.63h.89C164.05,349.15,164.4,348.86,164.4,348.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.06,350.71v-2.65l-1.32,2.21h-.24l-1.32-2.2v2.64h-.5v-3.64h.43l1.52,2.56,1.5-2.56h.43v3.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.29,361.57V362h-2.62v-.35l1.48-1.43c.39-.38.46-.61.46-.84s-.27-.6-.78-.6a1.16,1.16,0,0,0-.93.4l-.35-.31a1.66,1.66,0,0,1,1.33-.55c.76,0,1.25.39,1.25,1a1.47,1.47,0,0,1-.6,1.15l-1.11,1.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.84,358.38V362h-.51v-3.19h-.83v-.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.63,359.59a.34.34,0,0,1,.35-.35.33.33,0,0,1,.34.35.34.34,0,0,1-.34.36A.35.35,0,0,1,150.63,359.59Zm0,2.1a.34.34,0,0,1,.35-.35.33.33,0,0,1,.34.35.34.34,0,0,1-.34.36A.35.35,0,0,1,150.63,361.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.82,360.2c0-1.19.63-1.86,1.48-1.86s1.49.67,1.49,1.86-.64,1.86-1.49,1.86S151.82,361.39,151.82,360.2Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S154.27,361.13,154.27,360.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.29,360.2c0-1.19.63-1.86,1.48-1.86s1.49.67,1.49,1.86-.64,1.86-1.49,1.86S155.29,361.39,155.29,360.2Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S157.74,361.13,157.74,360.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.39,359.65c0,.79-.57,1.27-1.52,1.27H161V362h-.52v-3.64h1.42C162.82,358.38,163.39,358.86,163.39,359.65Zm-.52,0c0-.52-.35-.82-1-.82H161v1.64h.89C162.52,360.47,162.87,360.17,162.87,359.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.53,362v-2.65l-1.32,2.21H166l-1.32-2.2V362h-.5v-3.64h.43l1.52,2.56,1.5-2.56H168V362Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.29,372.88v.45h-2.62V373l1.48-1.43c.39-.38.46-.61.46-.83,0-.38-.27-.61-.78-.61a1.16,1.16,0,0,0-.93.4l-.35-.31a1.66,1.66,0,0,1,1.33-.55c.76,0,1.25.39,1.25,1a1.47,1.47,0,0,1-.6,1.15l-1.11,1.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.27,372.88v.45h-2.62V373l1.49-1.43c.38-.38.46-.61.46-.83,0-.38-.27-.61-.78-.61a1.14,1.14,0,0,0-.93.4l-.36-.31a1.7,1.7,0,0,1,1.34-.55c.76,0,1.25.39,1.25,1a1.5,1.5,0,0,1-.6,1.15l-1.12,1.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.69,370.9a.34.34,0,0,1,.35-.35.33.33,0,0,1,.34.35.34.34,0,0,1-.34.36A.35.35,0,0,1,151.69,370.9Zm0,2.1a.35.35,0,0,1,.35-.35.36.36,0,0,1,0,.71A.35.35,0,0,1,151.69,373Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.88,371.51c0-1.19.63-1.86,1.49-1.86s1.48.67,1.48,1.86-.64,1.86-1.48,1.86S152.88,372.7,152.88,371.51Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S155.33,372.44,155.33,371.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.35,371.51c0-1.19.63-1.86,1.49-1.86s1.48.67,1.48,1.86-.64,1.86-1.48,1.86S156.35,372.7,156.35,371.51Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S158.8,372.44,158.8,371.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.45,371c0,.79-.57,1.27-1.52,1.27H162v1.1h-.52v-3.64h1.42C163.88,369.69,164.45,370.17,164.45,371Zm-.52,0c0-.52-.35-.82-1-.82H162v1.64h.89C163.58,371.78,163.93,371.48,163.93,371Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.59,373.33v-2.65l-1.32,2.21H167l-1.31-2.2v2.64h-.5v-3.64h.42l1.52,2.56,1.5-2.56h.43v3.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.29,384.19v.45h-2.62v-.35l1.48-1.43c.39-.38.46-.6.46-.83s-.27-.61-.78-.61a1.16,1.16,0,0,0-.93.4l-.35-.31a1.66,1.66,0,0,1,1.33-.55c.76,0,1.25.39,1.25,1a1.46,1.46,0,0,1-.6,1.15l-1.11,1.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.2,383.57c0,.62-.45,1.12-1.37,1.12a2,2,0,0,1-1.34-.45l.24-.41a1.63,1.63,0,0,0,1.1.39c.54,0,.85-.25.85-.64s-.27-.64-.9-.64h-.29v-.36l.92-1.13h-1.76V381h2.41v.36l-.95,1.17C150.83,382.6,151.2,383,151.2,383.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.68,382.21a.35.35,0,0,1,.35-.35.36.36,0,0,1,0,.71A.35.35,0,0,1,151.68,382.21Zm0,2.11A.35.35,0,0,1,152,384a.34.34,0,0,1,.34.36.35.35,0,0,1-.34.36A.36.36,0,0,1,151.68,384.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,382.82c0-1.18.63-1.86,1.49-1.86s1.48.68,1.48,1.86-.64,1.87-1.48,1.87S152.87,384,152.87,382.82Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S155.32,383.75,155.32,382.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.34,382.82c0-1.18.63-1.86,1.48-1.86s1.49.68,1.49,1.86-.64,1.87-1.49,1.87S156.34,384,156.34,382.82Zm2.45,0c0-.93-.4-1.4-1-1.4s-1,.47-1,1.4.39,1.4,1,1.4S158.79,383.75,158.79,382.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.44,382.27c0,.79-.57,1.27-1.52,1.27H162v1.1h-.52V381h1.42C163.87,381,164.44,381.48,164.44,382.27Zm-.52,0c0-.52-.35-.82-1-.82H162v1.64h.89C163.57,383.09,163.92,382.79,163.92,382.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.58,384.64V382l-1.32,2.21H167L165.71,382v2.63h-.5V381h.42l1.52,2.56,1.5-2.56h.43v3.64Z",
    style: {
      fill: "#407BFF"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,192.16c0,.14-30.28.26-67.62.26s-67.63-.12-67.63-.26,30.27-.27,67.63-.27S278.65,192,278.65,192.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.94,178.29h2.79a3.21,3.21,0,1,1,0,6.39h-2.79Zm2.73,5.38a2.2,2.2,0,1,0,0-4.38h-1.55v4.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,182.24a2.6,2.6,0,1,1,2.59,2.5A2.45,2.45,0,0,1,263,182.24Zm4,0a1.45,1.45,0,1,0-1.45,1.52A1.42,1.42,0,0,0,267,182.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,181.88v2.8H272.9V182c0-.87-.43-1.29-1.16-1.29a1.3,1.3,0,0,0-1.36,1.47v2.47h-1.14V179.8h1.09v.63a2.14,2.14,0,0,1,1.68-.68A1.9,1.9,0,0,1,274,181.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.1,182.6h-3.82a1.47,1.47,0,0,0,1.58,1.17,1.74,1.74,0,0,0,1.32-.53l.61.71a2.74,2.74,0,0,1-4.65-1.71,2.42,2.42,0,0,1,2.51-2.49,2.38,2.38,0,0,1,2.47,2.52C280.12,182.36,280.11,182.49,280.1,182.6Zm-3.83-.75H279a1.32,1.32,0,0,0-1.38-1.19A1.34,1.34,0,0,0,276.27,181.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,181.48a3.46,3.46,0,0,1,5.95-2.22l-.77.73a2.21,2.21,0,0,0-1.7-.75,2.25,2.25,0,1,0,0,4.49,2.21,2.21,0,0,0,1.7-.76l.77.73a3.45,3.45,0,0,1-5.95-2.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.34,182.24a2.6,2.6,0,1,1,2.59,2.5A2.45,2.45,0,0,1,298.34,182.24Zm4.05,0a1.45,1.45,0,1,0-1.46,1.52A1.42,1.42,0,0,0,302.39,182.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.78,181.88v2.8h-1.14V182c0-.87-.41-1.29-1.1-1.29s-1.27.5-1.27,1.46v2.48h-1.14V182c0-.87-.4-1.29-1.09-1.29s-1.27.5-1.27,1.46v2.48h-1.14V179.8h1.08v.62a2,2,0,0,1,1.6-.67,1.81,1.81,0,0,1,1.64.81,2.29,2.29,0,0,1,1.83-.81A1.87,1.87,0,0,1,312.78,181.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.38,181.88v2.8h-1.14V182c0-.87-.4-1.29-1.09-1.29s-1.27.5-1.27,1.46v2.48h-1.14V182c0-.87-.4-1.29-1.1-1.29s-1.27.5-1.27,1.46v2.48h-1.14V179.8h1.09v.62a2,2,0,0,1,1.6-.67,1.82,1.82,0,0,1,1.64.81,2.27,2.27,0,0,1,1.82-.81A1.87,1.87,0,0,1,322.38,181.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.45,182.6h-3.83a1.47,1.47,0,0,0,1.58,1.17,1.71,1.71,0,0,0,1.32-.53l.62.71a2.74,2.74,0,0,1-4.66-1.71,2.42,2.42,0,0,1,2.52-2.49,2.37,2.37,0,0,1,2.46,2.52C328.46,182.36,328.46,182.49,328.45,182.6Zm-3.84-.75h2.77a1.32,1.32,0,0,0-1.38-1.19A1.35,1.35,0,0,0,324.61,181.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.36,181.88v2.8h-1.14V182c0-.87-.43-1.29-1.16-1.29a1.3,1.3,0,0,0-1.36,1.47v2.47h-1.14V179.8h1.08v.63a2.15,2.15,0,0,1,1.68-.68A1.9,1.9,0,0,1,334.36,181.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.73,184.41a1.77,1.77,0,0,1-1.09.33A1.5,1.5,0,0,1,336,183.1v-2.35h-.8v-.91h.8v-1.11h1.14v1.11h1.31v.91H337.1v2.32a.64.64,0,0,0,.68.73,1,1,0,0,0,.64-.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,203.69c0,.14-23.35.26-52.15.26s-52.16-.12-52.16-.26,23.35-.26,52.16-.26S278.65,203.54,278.65,203.69Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,215.22c0,.14-23.35.26-52.15.26s-52.16-.12-52.16-.26,23.35-.26,52.16-.26S278.65,215.07,278.65,215.22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,226.75c0,.14-23.35.26-52.15.26s-52.16-.12-52.16-.26,23.35-.26,52.16-.26S278.65,226.6,278.65,226.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,238.28c0,.14-23.35.26-52.15.26s-52.16-.12-52.16-.26,23.35-.26,52.16-.26S278.65,238.14,278.65,238.28Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,249.81c0,.14-23.35.26-52.15.26s-52.16-.12-52.16-.26,23.35-.26,52.16-.26S278.65,249.67,278.65,249.81Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,261.34c0,.15-23.35.26-52.15.26s-52.16-.11-52.16-.26,23.35-.26,52.16-.26S278.65,261.2,278.65,261.34Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,272.87c0,.15-23.35.26-52.15.26s-52.16-.11-52.16-.26,23.35-.26,52.16-.26S278.65,272.73,278.65,272.87Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,284.4c0,.15-23.35.27-52.15.27s-52.16-.12-52.16-.27,23.35-.26,52.16-.26S278.65,284.26,278.65,284.4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,295.94c0,.14-23.35.26-52.15.26s-52.16-.12-52.16-.26,23.35-.26,52.16-.26S278.65,295.79,278.65,295.94Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,307.47c0,.14-23.35.26-52.15.26s-52.16-.12-52.16-.26,23.35-.26,52.16-.26S278.65,307.32,278.65,307.47Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,319c0,.14-23.35.26-52.15.26s-52.16-.12-52.16-.26,23.35-.26,52.16-.26S278.65,318.85,278.65,319Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,330.53c0,.14-23.35.26-52.15.26s-52.16-.12-52.16-.26,23.35-.26,52.16-.26S278.65,330.39,278.65,330.53Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,342.06c0,.14-23.35.26-52.15.26s-52.16-.12-52.16-.26,23.35-.26,52.16-.26S278.65,341.92,278.65,342.06Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,353.59c0,.15-23.35.26-52.15.26s-52.16-.11-52.16-.26,23.35-.26,52.16-.26S278.65,353.45,278.65,353.59Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,365.12c0,.15-23.35.26-52.15.26s-52.16-.11-52.16-.26,23.35-.26,52.16-.26S278.65,365,278.65,365.12Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,376.65c0,.15-23.35.26-52.15.26s-52.16-.11-52.16-.26,23.35-.26,52.16-.26S278.65,376.51,278.65,376.65Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 195.73,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 207.26,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 218.79,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 230.33,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 241.86,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 253.39,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 264.92,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 276.45,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 287.98,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 299.51,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 311.04,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 322.58,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 334.11,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 345.64,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 357.17,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 368.7,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 380.23,
    width: 3.7,
    height: 3.7,
    style: {
      fill: "#e0e0e0"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,388.19c0,.14-23.35.26-52.15.26s-52.16-.12-52.16-.26,23.35-.26,52.16-.26S278.65,388,278.65,388.19Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 290.48,
    y: 189.35,
    width: 49.35,
    height: 207.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.7,156.58c0,.15-14.13.27-31.54.27s-31.55-.12-31.55-.27,14.12-.26,31.55-.26S460.7,156.44,460.7,156.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.7,169.53c0,.15-14.13.26-31.54.26s-31.55-.11-31.55-.26,14.12-.26,31.55-.26S460.7,169.39,460.7,169.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.7,182.48c0,.14-14.13.26-31.54.26s-31.55-.12-31.55-.26,14.12-.26,31.55-.26S460.7,182.34,460.7,182.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.7,195.43c0,.14-14.13.26-31.54.26s-31.55-.12-31.55-.26,14.12-.26,31.55-.26S460.7,195.28,460.7,195.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.7,208.37c0,.15-14.13.26-31.54.26s-31.55-.11-31.55-.26,14.12-.26,31.55-.26S460.7,208.23,460.7,208.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.7,221.32c0,.15-14.13.26-31.54.26s-31.55-.11-31.55-.26,14.12-.26,31.55-.26S460.7,221.18,460.7,221.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.7,234.27c0,.14-14.13.26-31.54.26s-31.55-.12-31.55-.26,14.12-.26,31.55-.26S460.7,234.13,460.7,234.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.15,277.26s1.7-15.59,24.92-16.18,39.89,7.06,60.35,4c14.49-2.17,19.12-3.1,19.12-3.1s-3.77,7.93-9.13,10.51h11.52s-5,8.94-25.21,10.33-49.62-5.56-60.73-3.58-15.28,5.56-15.28,5.56.24-8.35,5.4-11.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.36,280.18c0,2-1.53,3.29-4,3.29h-1.56v2.33h-2.52v-8.92h4.08C506.83,276.88,508.36,278.14,508.36,280.18Zm-2.55,0c0-.83-.52-1.31-1.57-1.31h-1.4v2.61h1.4C505.29,281.48,505.81,281,505.81,280.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.15,278.78V281a3.53,3.53,0,0,0-.54,0,1.51,1.51,0,0,0-1.66,1.71v3.17h-2.42v-6.91h2.31v.83A2.82,2.82,0,0,1,514.15,278.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.88,276.84a1.34,1.34,0,0,1,1.48-1.28,1.31,1.31,0,0,1,1.48,1.24,1.49,1.49,0,0,1-3,0Zm.27,2.05h2.42v6.91h-2.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.7,282.33a3.91,3.91,0,1,1,3.9,3.58A3.61,3.61,0,0,1,518.7,282.33Zm5.35,0a1.46,1.46,0,1,0-2.9,0,1.46,1.46,0,1,0,2.9,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.24,278.78V281a3.65,3.65,0,0,0-.55,0,1.5,1.5,0,0,0-1.65,1.71v3.17h-2.42v-6.91h2.3v.83A2.84,2.84,0,0,1,532.24,278.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533,276.84a1.33,1.33,0,0,1,1.48-1.28,1.3,1.3,0,0,1,1.47,1.24,1.49,1.49,0,0,1-2.95,0Zm.27,2.05h2.42v6.91h-2.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542,285.52a3.24,3.24,0,0,1-1.68.39c-1.77,0-2.81-.86-2.81-2.63V281h-1v-1.81h1v-1.8h2.42v1.8h1.58V281h-1.58v2.29a.71.71,0,0,0,.73.79,1.32,1.32,0,0,0,.74-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.65,276.84a1.34,1.34,0,0,1,1.48-1.28,1.31,1.31,0,0,1,1.48,1.24,1.49,1.49,0,0,1-3,0Zm.27,2.05h2.42v6.91h-2.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.92,283h-5a1.61,1.61,0,0,0,1.7,1.11,2.2,2.2,0,0,0,1.59-.6l1.28,1.32a3.76,3.76,0,0,1-3,1.12c-2.46,0-4-1.51-4-3.58a3.57,3.57,0,0,1,3.8-3.55,3.45,3.45,0,0,1,3.69,3.58C554,282.54,553.94,282.77,553.92,283Zm-5-1.28h2.82a1.36,1.36,0,0,0-1.41-1.18A1.37,1.37,0,0,0,548.87,281.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.53,285.2l.73-1.66a4.81,4.81,0,0,0,2.41.64c.81,0,1.08-.18,1.08-.47,0-.93-4.08.13-4.08-2.64,0-1.3,1.2-2.29,3.37-2.29a6.1,6.1,0,0,1,2.73.58L560,281a4.09,4.09,0,0,0-2-.51c-.81,0-1.11.23-1.11.48,0,1,4.07-.07,4.07,2.67,0,1.27-1.18,2.26-3.42,2.26A6.37,6.37,0,0,1,554.53,285.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.86,
    y: 351.89,
    width: 26.91,
    height: 5.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.86,
    y: 324.03,
    width: 36.46,
    height: 5.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.86,
    y: 339.24,
    width: 34.13,
    height: 4.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.94,310.46h-1v-.72h2.87v.72h-1V313h-.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.09,311.52v-1.78h.9v1.75c0,.55.23.77.61.77s.61-.22.61-.77v-1.75h.89v1.78a1.51,1.51,0,0,1-3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.28,312.25v.7h-2.57v-3.21h2.51v.7h-1.61V311H390v.68h-1.42v.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.56,312.66l.3-.67a2,2,0,0,0,1.06.32c.37,0,.52-.11.52-.27,0-.5-1.82-.13-1.82-1.32,0-.58.46-1,1.41-1a2.36,2.36,0,0,1,1.17.28l-.28.67a1.85,1.85,0,0,0-.89-.25c-.38,0-.52.13-.52.29,0,.49,1.82.12,1.82,1.3,0,.56-.47,1-1.42,1A2.51,2.51,0,0,1,390.56,312.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.74,309.74h1.52a1.61,1.61,0,1,1,0,3.21h-1.52Zm1.48,2.48a.88.88,0,1,0,0-1.76h-.57v1.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.62,312.32h-1.35L398,313h-.93l1.42-3.21h.89l1.42,3.21h-.95Zm-.26-.67-.41-1-.42,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.59,311.8V313h-.91v-1.17l-1.22-2h1l.76,1.27.76-1.27h.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.67,310.94a.49.49,0,0,1,.52-.52.52.52,0,1,1-.52.52Zm0,1.53a.49.49,0,0,1,.52-.51.5.5,0,0,1,.52.51.51.51,0,0,1-.52.52A.5.5,0,0,1,403.67,312.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,323.55l-1,3.2h-1l-.62-1.95-.64,1.95h-1l-1-3.2H382l.64,2,.68-2h.83l.65,2.06.67-2.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.18,326.05v.7h-2.57v-3.2h2.51v.7h-1.61v.54h1.42v.68h-1.42v.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.68,323.55h1.52a1.61,1.61,0,1,1,0,3.2h-1.52Zm1.48,2.48a.88.88,0,1,0,0-1.76h-.57V326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.51,323.55v3.2h-.75l-1.41-1.7v1.7h-.89v-3.2h.75l1.41,1.71v-1.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.72,326.05v.7h-2.57v-3.2h2.51v.7H398v.54h1.43v.68H398v.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,326.46l.29-.66a2.12,2.12,0,0,0,1.06.31c.38,0,.52-.1.52-.26,0-.51-1.82-.14-1.82-1.33,0-.57.47-1,1.42-1a2.4,2.4,0,0,1,1.16.28l-.28.68a1.82,1.82,0,0,0-.88-.25c-.38,0-.52.13-.52.29,0,.49,1.82.12,1.82,1.3,0,.56-.47,1-1.42,1A2.51,2.51,0,0,1,400,326.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.18,323.55h1.52a1.61,1.61,0,1,1,0,3.2h-1.52Zm1.48,2.48a.88.88,0,1,0,0-1.76h-.57V326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.06,326.13H407.7l-.25.62h-.92l1.41-3.2h.89l1.42,3.2h-.94Zm-.27-.67-.41-1-.41,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,325.6v1.15h-.9v-1.16l-1.23-2h1l.76,1.27.76-1.27h.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.1,324.74a.5.5,0,0,1,.52-.51.49.49,0,0,1,.52.51.5.5,0,0,1-.52.52A.5.5,0,0,1,413.1,324.74Zm0,1.54a.5.5,0,0,1,.52-.52.52.52,0,1,1-.52.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.86,338.52h-1v-.72h2.87v.72h-1V341h-.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.13,337.8V341h-.9v-1.25H386V341h-.9V337.8h.9V339h1.24V337.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.74,339.58V337.8h.91v1.75c0,.55.23.77.61.77s.6-.22.6-.77V337.8h.9v1.78a1.51,1.51,0,0,1-3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.77,340.16h-.5V341h-.9V337.8h1.46c.88,0,1.43.46,1.43,1.19a1.06,1.06,0,0,1-.63,1l.69,1h-1Zm0-1.64h-.51v.94h.51c.37,0,.56-.18.56-.47S394.15,338.52,393.78,338.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.53,340.72l.3-.67a2,2,0,0,0,1.05.32c.38,0,.52-.11.52-.26,0-.51-1.82-.14-1.82-1.33,0-.57.47-1,1.42-1a2.4,2.4,0,0,1,1.16.28l-.27.67a2,2,0,0,0-.89-.25c-.38,0-.52.13-.52.29,0,.49,1.82.13,1.82,1.31,0,.56-.47,1-1.42,1A2.51,2.51,0,0,1,395.53,340.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.71,337.8h1.52a1.61,1.61,0,1,1,0,3.21h-1.52Zm1.48,2.48a.88.88,0,1,0,0-1.75h-.57v1.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.59,340.39h-1.35L403,341h-.92l1.41-3.21h.9l1.42,3.21h-1Zm-.26-.67-.42-1-.41,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.55,339.86V341h-.9v-1.17l-1.22-2h.95l.76,1.28.76-1.28h.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.63,339a.53.53,0,1,1,.52.51A.5.5,0,0,1,408.63,339Zm0,1.53a.53.53,0,0,1,1.05,0,.53.53,0,0,1-1.05,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.09,352v.7h1.41v.7h-1.41v1.1h-.91v-3.2h2.51v.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.52,353.68H386v.85h-.9v-3.2h1.46c.88,0,1.43.45,1.43,1.18a1.07,1.07,0,0,1-.63,1l.69,1h-1Zm0-1.64H386V353h.51c.37,0,.56-.17.56-.47S386.9,352,386.53,352Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.5,351.33h.91v3.2h-.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.05,351.33h1.52a1.61,1.61,0,1,1,0,3.2h-1.52Zm1.48,2.48a.88.88,0,1,0,0-1.76H391v1.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.93,353.91h-1.35l-.25.62h-.93l1.42-3.2h.89l1.42,3.2h-.95Zm-.26-.67-.41-1-.42,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.9,353.38v1.15H398v-1.16l-1.22-2h1l.76,1.27.76-1.27h.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,352.52a.53.53,0,0,1,1,0,.53.53,0,0,1-1,0Zm0,1.54a.53.53,0,1,1,.53.51A.5.5,0,0,1,400,354.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.26,
    y: 123.39,
    width: 91.91,
    height: 114.3,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.4,155.54a1.32,1.32,0,1,1-1.32-1.32A1.32,1.32,0,0,1,392.4,155.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.08,156.88a1.34,1.34,0,1,1,1.34-1.34A1.35,1.35,0,0,1,391.08,156.88Zm0-2.63a1.29,1.29,0,1,0,1.29,1.29A1.29,1.29,0,0,0,391.08,154.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.08,
    cy: 168.55,
    r: 1.32,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.08,169.9a1.35,1.35,0,1,1,0-2.69,1.35,1.35,0,0,1,0,2.69Zm0-2.64a1.3,1.3,0,1,0,1.29,1.29A1.29,1.29,0,0,0,391.08,167.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.08,
    cy: 181.56,
    r: 1.32,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.08,182.91a1.35,1.35,0,1,1,1.34-1.35A1.35,1.35,0,0,1,391.08,182.91Zm0-2.64a1.3,1.3,0,1,0,1.29,1.29A1.29,1.29,0,0,0,391.08,180.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.4,194.58a1.32,1.32,0,1,1-1.32-1.32A1.33,1.33,0,0,1,392.4,194.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.08,195.92a1.35,1.35,0,1,1,1.34-1.34A1.35,1.35,0,0,1,391.08,195.92Zm0-2.64a1.3,1.3,0,1,0,1.29,1.3A1.3,1.3,0,0,0,391.08,193.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.08,
    cy: 207.59,
    r: 1.32,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.08,208.93a1.35,1.35,0,1,1,1.34-1.34A1.35,1.35,0,0,1,391.08,208.93Zm0-2.64a1.3,1.3,0,1,0,1.29,1.3A1.3,1.3,0,0,0,391.08,206.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.08,
    cy: 220.6,
    r: 1.32,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.08,221.94a1.34,1.34,0,1,1,1.34-1.34A1.35,1.35,0,0,1,391.08,221.94Zm0-2.63a1.29,1.29,0,1,0,1.29,1.29A1.29,1.29,0,0,0,391.08,219.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.4,233.61a1.32,1.32,0,1,1-1.32-1.32A1.32,1.32,0,0,1,392.4,233.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.08,235a1.35,1.35,0,1,1,0-2.69,1.35,1.35,0,0,1,0,2.69Zm0-2.64a1.3,1.3,0,1,0,1.29,1.29A1.29,1.29,0,0,0,391.08,232.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.54,297.8c0,.15-11.38.26-25.41.26s-25.4-.11-25.4-.26,11.37-.26,25.4-.26S467.54,297.66,467.54,297.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.54,311.47c0,.14-11.38.26-25.41.26s-25.4-.12-25.4-.26,11.37-.26,25.4-.26S467.54,311.33,467.54,311.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.54,325.14c0,.14-10.6.26-23.67.26s-23.66-.12-23.66-.26,10.59-.26,23.66-.26S467.54,325,467.54,325.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.54,340c0,.15-11.38.26-25.41.26s-25.4-.11-25.4-.26,11.37-.26,25.4-.26S467.54,339.84,467.54,340Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.54,354.83c0,.14-11.38.26-25.41.26s-25.4-.12-25.4-.26,11.37-.26,25.4-.26S467.54,354.68,467.54,354.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.06,294s0-.16,0-.46,0-.76,0-1.33c0-1.18,0-2.9,0-5.13,0-4.47-.06-11-.09-19.19l.16.16-91.91.1h0l.26-.26c0,9,0,17.77,0,26.11l-.25-.25,65.62.11,19.27.08,5.2,0,1.35,0h.47l-.44,0H574.3l-5.14,0-19.22.07-65.79.12h-.25V294c0-8.34,0-17.11,0-26.11v-.26h.26l91.91.09h.16v.17c0,8.25-.07,14.79-.09,19.29,0,2.21,0,3.92,0,5.09,0,.56,0,1,0,1.3S576.06,294,576.06,294Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.15,
    y: 303.31,
    width: 91.91,
    height: 26.12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.15,
    y: 336.02,
    width: 91.91,
    height: 26.12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.15,
    y: 368.73,
    width: 91.91,
    height: 26.12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.26,134.82c0,1.54-1.27,2.44-3.67,2.44h-4.81v-8.91h4.56c2.34,0,3.49,1,3.49,2.33a2.09,2.09,0,0,1-1.2,1.93A2.26,2.26,0,0,1,154.26,134.82Zm-6-4.65v1.72H150c.84,0,1.27-.3,1.27-.87s-.43-.85-1.27-.85Zm3.44,4.37c0-.61-.45-.91-1.32-.91h-2.12v1.81h2.12C151.26,135.44,151.71,135.15,151.71,134.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5,133.29v-4.94H158v4.86c0,1.53.64,2.14,1.69,2.14s1.69-.61,1.69-2.14v-4.86h2.48v4.94c0,2.66-1.55,4.15-4.19,4.15S155.5,136,155.5,133.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.59,128.35h2.52v6.91h4.25v2h-6.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.36,128.35h2.52v6.91h4.25v2h-6.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.29,135.32v1.94h-7.16v-8.91h7v2h-4.5v1.5h4v1.88h-4v1.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.59,130.35h-2.74v-2h8v2h-2.73v6.91h-2.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.34,136.13l1.37-1.63a2,2,0,0,0,1.54.93c.73,0,1.13-.45,1.13-1.3V130.3h-3.09v-2h5.58V134c0,2.32-1.2,3.46-3.44,3.46A3.85,3.85,0,0,1,200.34,136.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.12,132.81a5,5,0,1,1,5,4.63A4.66,4.66,0,0,1,208.12,132.81Zm7.36,0a2.41,2.41,0,1,0-2.4,2.54A2.38,2.38,0,0,0,215.48,132.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.28,133.29v-4.94h2.52v4.86c0,1.53.64,2.14,1.7,2.14s1.68-.61,1.68-2.14v-4.86h2.48v4.94c0,2.66-1.55,4.15-4.19,4.15S219.28,136,219.28,133.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.27,134.89h-1.38v2.37h-2.52v-8.91h4.08c2.43,0,4,1.26,4,3.3a3,3,0,0,1-1.75,2.81l1.93,2.8h-2.71Zm0-4.56h-1.4V133h1.4c1.05,0,1.57-.49,1.57-1.3S234.34,130.33,233.29,130.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.28,128.35v8.91H245.2l-3.93-4.75v4.75h-2.48v-8.91h2.08l3.94,4.75v-4.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,135.53h-3.77l-.7,1.73H248l3.94-8.91h2.48l4,8.91h-2.62Zm-.74-1.86-1.15-2.85L252,133.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.07,128.35h2.53v6.91h4.25v2h-6.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.29,
    y: 154.94,
    width: 147.6,
    height: 6.76,
    style: {
      fill: "#407BFF"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M355.92,423.6c-.14,0-.26-74.31-.26-166s.12-166,.26-166,.26,74.3.26,166S356.07,423.6,355.92,423.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.19,181.46c-.05,0,0-.45-.26-1.2a4.92,4.92,0,0,0-1.83-2.63,4.78,4.78,0,1,0,0,7.66,4.92,4.92,0,0,0,1.83-2.63c.22-.75.21-1.2.26-1.2s0,.11,0,.32a3.61,3.61,0,0,1-.1.93,5,5,0,0,1-1.81,2.88,5.18,5.18,0,0,1-4.93.8,5.23,5.23,0,0,1,0-9.86,5.18,5.18,0,0,1,4.93.8,5,5,0,0,1,1.81,2.88,3.61,3.61,0,0,1,.1.93C159.22,181.35,159.21,181.46,159.19,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.44,181.85a11.71,11.71,0,0,1-3.43.26h-.43v-.26a10.85,10.85,0,0,1,.26-3.26,10.85,10.85,0,0,1,.26,3.26l-.26-.26H154A11.31,11.31,0,0,1,157.44,181.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.56 143.06 401.53 143.06 403.6 133.03 450.31 133.03 448.56 143.06",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.65,129.14v8.92h-2.07l-3.94-4.75v4.75h-2.47v-8.92h2.07l3.94,4.75v-4.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.89,134.59a3.91,3.91,0,1,1,3.9,3.58A3.61,3.61,0,0,1,417.89,134.59Zm5.35,0a1.46,1.46,0,1,0-2.91,0,1.47,1.47,0,1,0,2.91,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.57,137.78a3.22,3.22,0,0,1-1.68.39c-1.77,0-2.81-.86-2.81-2.63v-2.32h-1v-1.81h1v-1.8h2.43v1.8h1.58v1.81h-1.58v2.29a.7.7,0,0,0,.72.79,1.32,1.32,0,0,0,.74-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.32,135.22h-5a1.61,1.61,0,0,0,1.7,1.11,2.2,2.2,0,0,0,1.59-.6l1.28,1.32a3.75,3.75,0,0,1-2.95,1.12c-2.46,0-4.05-1.51-4.05-3.58a3.57,3.57,0,0,1,3.8-3.55,3.45,3.45,0,0,1,3.69,3.58C439.35,134.8,439.33,135,439.32,135.22Zm-5.06-1.28h2.82a1.36,1.36,0,0,0-1.41-1.18A1.37,1.37,0,0,0,434.26,133.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.93,137.46l.72-1.66a4.81,4.81,0,0,0,2.41.64c.81,0,1.08-.18,1.08-.47,0-.93-4.07.13-4.07-2.64,0-1.3,1.19-2.29,3.36-2.29a6.1,6.1,0,0,1,2.73.58l-.73,1.65a4.09,4.09,0,0,0-2-.51c-.81,0-1.11.23-1.11.48,0,1,4.07-.07,4.07,2.67,0,1.27-1.17,2.26-3.42,2.26A6.3,6.3,0,0,1,439.93,137.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.28,134.85h1.4a1.61,1.61,0,1,1,0,3.21h-1.4Zm1.37,2.71a1.1,1.1,0,1,0,0-2.2h-.78v2.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.82,136.46a1.73,1.73,0,1,1,1.73,1.64A1.65,1.65,0,0,1,492.82,136.46Zm2.86,0a1.13,1.13,0,1,0-1.13,1.12A1.1,1.1,0,0,0,495.68,136.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501,134.85v3.21h-.49l-1.76-2.17v2.17h-.59v-3.21h.49l1.76,2.17v-2.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.64,136.46a1.73,1.73,0,1,1,1.73,1.64A1.64,1.64,0,0,1,501.64,136.46Zm2.85,0a1.13,1.13,0,1,0-1.12,1.12A1.09,1.09,0,0,0,504.49,136.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.33,135.36h-1.06v-.51H508v.51h-1.06v2.7h-.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.29,135.35v1h1.54v.5h-1.54v1.23h-.6v-3.21H512v.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.34,136.46a1.73,1.73,0,1,1,1.73,1.64A1.64,1.64,0,0,1,512.34,136.46Zm2.85,0a1.13,1.13,0,1,0-1.12,1.12A1.09,1.09,0,0,0,515.19,136.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.52,138.06l-.66-.94H517v.93h-.6v-3.21h1.32c.84,0,1.36.43,1.36,1.14a1,1,0,0,1-.68,1l.74,1.05Zm-.81-2.7H517v1.28h.69c.52,0,.79-.24.79-.65S518.23,135.36,517.71,135.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522,136.42h.57v1.28a2.06,2.06,0,0,1-1.26.4,1.65,1.65,0,1,1,0-3.29,1.66,1.66,0,0,1,1.29.52l-.38.37a1.19,1.19,0,0,0-.88-.37,1.13,1.13,0,1,0,0,2.25,1.27,1.27,0,0,0,.66-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.7,137.56v.5h-2.4v-3.21h2.34v.5h-1.75v.84h1.55v.49h-1.55v.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527,135.36H526v-.51h2.72v.51h-1.06v2.7H527Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.15,153.15c0,.14-17.28.26-38.6.26s-38.6-.12-38.6-.26,17.28-.26,38.6-.26S565.15,153,565.15,153.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.15,143.06c0,.14-17.28.26-38.6.26s-38.6-.12-38.6-.26,17.28-.26,38.6-.26S565.15,142.92,565.15,143.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.15,162.89c0,.15-17.28.26-38.6.26S488,163,488,162.89s17.28-.26,38.6-.26S565.15,162.75,565.15,162.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.15,172.64c0,.14-17.28.26-38.6.26s-38.6-.12-38.6-.26,17.28-.26,38.6-.26S565.15,172.5,565.15,172.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.15,182.39c0,.14-17.28.26-38.6.26s-38.6-.12-38.6-.26,17.28-.27,38.6-.27S565.15,182.24,565.15,182.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.15,192.13c0,.15-17.28.26-38.6.26s-38.6-.11-38.6-.26,17.28-.26,38.6-.26S565.15,192,565.15,192.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.15,201.88c0,.14-17.28.26-38.6.26S488,202,488,201.88s17.28-.26,38.6-.26S565.15,201.73,565.15,201.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.15,211.62c0,.15-17.28.26-38.6.26s-38.6-.11-38.6-.26,17.28-.26,38.6-.26S565.15,211.48,565.15,211.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.15,221.92c0,.14-17.28.26-38.6.26s-38.6-.12-38.6-.26,17.28-.26,38.6-.26S565.15,221.78,565.15,221.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.25,311.22a.28.28,0,0,1,.29-.29.29.29,0,0,1,.29.29.3.3,0,0,1-.29.3A.29.29,0,0,1,489.25,311.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.53,309.07c0-1.51.78-2.45,1.9-2.45s1.89.94,1.89,2.45-.78,2.45-1.89,2.45S490.53,310.58,490.53,309.07Zm3.44,0c0-1.35-.63-2.13-1.54-2.13s-1.55.78-1.55,2.13.63,2.13,1.55,2.13S494,310.42,494,309.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.29,306.65v4.84h-.35V307h-1.18v-.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.25,344.23a.28.28,0,0,1,.29-.29.29.29,0,0,1,.29.29.3.3,0,0,1-.29.3A.29.29,0,0,1,489.25,344.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.53,342.08c0-1.51.78-2.45,1.9-2.45s1.89.94,1.89,2.45-.78,2.45-1.89,2.45S490.53,343.59,490.53,342.08Zm3.44,0c0-1.35-.63-2.13-1.54-2.13s-1.55.78-1.55,2.13.63,2.13,1.55,2.13S494,343.43,494,342.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.3,344.18v.32H495v-.25l2-2c.57-.58.68-.91.68-1.28,0-.61-.42-1-1.22-1a1.72,1.72,0,0,0-1.39.56l-.25-.22a2.12,2.12,0,0,1,1.66-.66c.95,0,1.56.49,1.56,1.27a2,2,0,0,1-.79,1.5l-1.78,1.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.25,377.24a.28.28,0,0,1,.29-.29.29.29,0,0,1,.29.29.3.3,0,0,1-.29.3A.29.29,0,0,1,489.25,377.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.53,375.09c0-1.51.78-2.45,1.9-2.45s1.89.94,1.89,2.45-.78,2.45-1.89,2.45S490.53,376.6,490.53,375.09Zm3.44,0c0-1.35-.63-2.13-1.54-2.13s-1.55.78-1.55,2.13.63,2.13,1.55,2.13S494,376.44,494,375.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.12,376.15c0,.8-.58,1.39-1.69,1.39a2.33,2.33,0,0,1-1.71-.65l.18-.26a2.11,2.11,0,0,0,1.53.59c.87,0,1.33-.41,1.33-1.07s-.44-1.07-1.41-1.07h-.3v-.26l1.43-1.83H494.9v-.32h3v.25l-1.45,1.86C497.58,374.81,498.12,375.36,498.12,376.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.78,126.1a1.9,1.9,0,1,0,.07,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.85,126.07s.11-.14.41-.22a1.91,1.91,0,0,1,1.27.13,1.89,1.89,0,0,1,1.11,1.57,2,2,0,0,1-3.46,1.65,2,2,0,0,1,.17-2.92c.25-.18.42-.21.43-.18a2.67,2.67,0,0,0-.76,1.33,1.53,1.53,0,0,0,.48,1.42,1.57,1.57,0,0,0,2.66-1.27,1.52,1.52,0,0,0-.8-1.27A2.66,2.66,0,0,0,556.85,126.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.08,108.17a1.9,1.9,0,1,0,.07,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.15,108.14s.11-.15.4-.23a1.93,1.93,0,0,1,1.27.14,1.89,1.89,0,0,1,1.11,1.57,2,2,0,0,1-3.46,1.65,1.9,1.9,0,0,1-.52-1.85,1.87,1.87,0,0,1,.7-1.07c.24-.18.41-.21.43-.18a2.6,2.6,0,0,0-.77,1.33,1.54,1.54,0,0,0,.49,1.42,1.57,1.57,0,0,0,2.65-1.27,1.5,1.5,0,0,0-.79-1.27A2.56,2.56,0,0,0,559.15,108.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584,140.89a30.86,30.86,0,0,1-1.21-4.51,31.86,31.86,0,0,1-1.05-4.56,16,16,0,0,1,1.55,4.43A16,16,0,0,1,584,140.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.73,102.76a4.19,4.19,0,0,1,.22.7c.14.51.32,1.18.54,2,.45,1.76,1.13,4.31,2,7.44,1.72,6.27,4.3,14.87,7.4,24.3s6,17.94,8,24.14c1,3.1,1.76,5.62,2.27,7.36.25.84.44,1.51.59,2a3.6,3.6,0,0,1,.16.71,4.52,4.52,0,0,1-.26-.68c-.18-.5-.4-1.16-.68-2l-2.43-7.3c-2.06-6.17-5-14.66-8.1-24.1s-5.62-18.06-7.26-24.36c-.81-3.15-1.44-5.71-1.83-7.49-.18-.85-.33-1.53-.44-2A3.27,3.27,0,0,1,567.73,102.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.4,133.3a16.39,16.39,0,0,1-2.59-.89c-1.59-.59-3.78-1.37-6.23-2.14s-4.71-1.37-6.35-1.79a17,17,0,0,1-2.63-.75,12.36,12.36,0,0,1,2.72.39,64.45,64.45,0,0,1,12.62,3.95A12.7,12.7,0,0,1,575.4,133.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.85,127.47a22.79,22.79,0,0,1-1,3.11c-.68,1.9-1.6,4.53-2.58,7.46s-1.8,5.58-2.4,7.51a20.33,20.33,0,0,1-1.06,3.1,19.82,19.82,0,0,1,.7-3.2c.51-2,1.29-4.65,2.27-7.58s2-5.55,2.72-7.42A19.69,19.69,0,0,1,588.85,127.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588,125.69a1.9,1.9,0,1,0,.07,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.1,125.66s.12-.14.41-.22a1.91,1.91,0,0,1,1.27.13,1.89,1.89,0,0,1,1.11,1.57,2,2,0,0,1-3.46,1.65,1.87,1.87,0,0,1-.52-1.85,1.91,1.91,0,0,1,.69-1.07c.25-.18.42-.21.43-.18a2.76,2.76,0,0,0-.76,1.33,1.54,1.54,0,0,0,.49,1.42,1.56,1.56,0,0,0,2.65-1.27,1.5,1.5,0,0,0-.8-1.27A2.65,2.65,0,0,0,588.1,125.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.45,100a1.9,1.9,0,1,0,.07,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.52,100s.11-.14.41-.22a1.92,1.92,0,0,1,1.27.13,1.88,1.88,0,0,1,1.1,1.57,2,2,0,0,1-3.45,1.65,1.87,1.87,0,0,1-.53-1.84,1.9,1.9,0,0,1,.7-1.08c.24-.18.41-.2.43-.18a2.72,2.72,0,0,0-.77,1.33,1.56,1.56,0,0,0,.49,1.42,1.69,1.69,0,0,0,1.77.29,1.72,1.72,0,0,0,.89-1.56,1.56,1.56,0,0,0-.8-1.27A2.66,2.66,0,0,0,566.52,100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565,121.4a19.18,19.18,0,0,1,.87,4.32,19.41,19.41,0,0,1,.35,4.4,19.18,19.18,0,0,1-.87-4.32A18.13,18.13,0,0,1,565,121.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.87,116.63c-.1.12-2.41-1.58-5.43-3.38s-5.61-3-5.54-3.19a23.26,23.26,0,0,1,5.8,2.74A24,24,0,0,1,570.87,116.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.33,120.55a1.9,1.9,0,1,0,.07,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.4,120.52s.12-.14.41-.22a1.91,1.91,0,0,1,1.27.13,1.89,1.89,0,0,1,1.11,1.57,2,2,0,0,1-3.46,1.65,1.87,1.87,0,0,1-.52-1.85,2,2,0,0,1,.69-1.07c.25-.18.42-.2.43-.18a2.67,2.67,0,0,0-.76,1.33,1.53,1.53,0,0,0,.48,1.42,1.71,1.71,0,0,0,1.77.29,1.68,1.68,0,0,0,.89-1.56,1.53,1.53,0,0,0-.8-1.27A2.66,2.66,0,0,0,564.4,120.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580,109.52a1.82,1.82,0,1,0,2.47.86,1.89,1.89,0,0,0-2.4-.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580,109.48s.11-.14.41-.22a2,2,0,0,1,2.38,1.7,2.14,2.14,0,0,1-1.15,2.06,2.11,2.11,0,0,1-2.31-.41,1.87,1.87,0,0,1-.53-1.84,1.9,1.9,0,0,1,.7-1.08c.25-.17.42-.2.43-.17a2.55,2.55,0,0,0-.76,1.32,1.52,1.52,0,0,0,.48,1.42,1.69,1.69,0,0,0,1.77.29,1.7,1.7,0,0,0,.89-1.56,1.56,1.56,0,0,0-.8-1.27A2.66,2.66,0,0,0,580,109.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.17,112.39a52.46,52.46,0,0,1-2.82,6.85,51.53,51.53,0,0,1-3.3,6.65,53.9,53.9,0,0,1,2.83-6.86A51.74,51.74,0,0,1,580.17,112.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.28,129.3a2,2,0,1,0,.08,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.36,129.27s.11-.14.4-.23a1.93,1.93,0,0,1,1.27.14,1.89,1.89,0,0,1,1.11,1.57,2,2,0,0,1-3.46,1.65,2,2,0,0,1,.17-2.92c.25-.18.42-.21.43-.18a2.85,2.85,0,0,0-.76,1.33,1.54,1.54,0,0,0,.49,1.42,1.56,1.56,0,0,0,2.65-1.27,1.5,1.5,0,0,0-.79-1.27A2.56,2.56,0,0,0,580.36,129.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.86,
    y: 296.3,
    width: 28.42,
    height: 5.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.34,298.48v-1.69l-.82,1.38h-.41l-.82-1.34v1.65h-.83v-3.2h.74l1.13,1.85,1.1-1.85h.74v3.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.64,296.88a1.79,1.79,0,1,1,1.79,1.67A1.68,1.68,0,0,1,385.64,296.88Zm2.65,0a.87.87,0,1,0-.86.92A.85.85,0,0,0,388.29,296.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.73,295.28v3.2H392l-1.41-1.7v1.7h-.89v-3.2h.75l1.41,1.71v-1.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.37,295.28h1.51a1.61,1.61,0,1,1,0,3.2h-1.51Zm1.47,2.48a.88.88,0,1,0,0-1.76h-.57v1.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.25,297.86h-1.36l-.25.62h-.93l1.42-3.2H399l1.42,3.2h-.94Zm-.27-.67-.41-1-.41,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.21,297.34v1.14h-.91v-1.16l-1.22-2h1l.76,1.27.76-1.27h.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.29,296.47a.5.5,0,0,1,.52-.51.49.49,0,0,1,.52.51.5.5,0,0,1-.52.52A.5.5,0,0,1,403.29,296.47Zm0,1.54a.5.5,0,0,1,.52-.51.49.49,0,0,1,.52.51.5.5,0,0,1-.52.52A.51.51,0,0,1,403.29,298Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M367.41,415.55l-7.28-.22c.63-20.69-2.94-41.81-6.38-62.23-4.34-25.65-8.81-52.18-5.18-78.52,1.79-12.9,5.49-25.48,9.08-37.65,2.76-9.36,5.63-19,7.51-28.67,7.39-37.74-5.29-115.78-5.24-115.35,3.18-1,2.58-3.79,4.56-2.6,9.1,35.91,15.5,80.56,7.83,119.37-2,9.95-4.87,19.79-7.68,29.3-3.51,11.92-7.14,24.24-8.84,36.6-3.49,25.23.9,51.2,5.14,76.31C364.43,372.66,368.06,394.14,367.41,415.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M364,412.11l-7.28-.22c.63-20.69-2.93-41.81-6.38-62.22-4.33-25.66-8.81-52.19-5.18-78.53,1.79-12.9,5.49-25.48,9.08-37.65,2.76-9.36,5.63-19,7.51-28.67,7.39-37.74-5.29-115.78-5.24-115.35,3.18-1,5.88-1.19,7.87,0,5.72,36.13,12.19,78,4.52,116.77-2,9.95-4.87,19.79-7.67,29.31-3.52,11.91-7.14,24.23-8.85,36.59-3.49,25.23.9,51.2,5.14,76.31C361,369.22,364.62,390.7,364,412.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,412.11c0-.16,0-.63,0-1.68s0-2.75,0-4.92c-.06-4.32-.27-10.71-1.09-18.89s-2.2-18.16-4.13-29.7-4.36-24.65-6.14-39.3a225.62,225.62,0,0,1-1.69-23.09c-.1-4,0-8.14.23-12.33s.69-8.44,1.37-12.73a221.8,221.8,0,0,1,6.17-26.2c2.55-8.9,5.4-18,7.76-27.46a182.79,182.79,0,0,0,4.89-29.55,246.13,246.13,0,0,0,.48-31.28c-.92-21.28-4.19-43.14-7.74-65.47l.13.18a6.42,6.42,0,0,0-3.39-.8,14.73,14.73,0,0,0-3.68.64l-.59.18-.33-.21c1-.12.29,0,.53,0l0,.12,0,.23.07.46.14.93.29,1.86.54,3.71,1,7.4q1,7.38,1.8,14.69c1.1,9.75,2,19.4,2.64,28.92s1,18.93,1,28.18a168.74,168.74,0,0,1-2,27.17,253.9,253.9,0,0,1-6.38,25.39c-2.4,8.19-4.82,16.16-6.81,24a161.59,161.59,0,0,0-4.29,23.25,164.15,164.15,0,0,0-.66,22.24,324,324,0,0,0,4.37,39.65c1.95,12.05,3.89,22.94,5.28,32.59s2.29,18.07,2.7,25.06.38,12.54.27,16.48l-.06-.05,5.44.19,1.84.08-1.82,0-5.46-.13h-.05v-.06c.09-3.94.11-9.49-.35-16.47s-1.34-15.39-2.78-25-3.38-20.52-5.34-32.57a321.89,321.89,0,0,1-4.44-39.7,163.19,163.19,0,0,1,.63-22.29,160.58,160.58,0,0,1,4.28-23.32c2-7.88,4.41-15.86,6.8-24a255.65,255.65,0,0,0,6.35-25.34,168.73,168.73,0,0,0,2-27.09c0-9.23-.34-18.63-1-28.14s-1.53-19.16-2.63-28.9q-.82-7.31-1.8-14.68l-1-7.4-.55-3.7-.28-1.86-.14-.92L356.3,90l0-.23,0-.12c.16-.06-.4,0,.37-.17l-.22-.23L357,89a15.15,15.15,0,0,1,3.82-.66,6.94,6.94,0,0,1,3.66.87l.11.07,0,.12c3.55,22.33,6.81,44.22,7.73,65.53a247.07,247.07,0,0,1-.5,31.34,182.68,182.68,0,0,1-4.91,29.63c-2.38,9.49-5.24,18.58-7.79,27.47A222,222,0,0,0,353,269.54c-.68,4.28-1.1,8.52-1.38,12.69s-.34,8.27-.25,12.29A228.1,228.1,0,0,0,353,317.58c1.75,14.63,4.2,27.74,6.06,39.29s3.3,21.53,4,29.73,1,14.59,1,18.91c0,2.16,0,3.83-.06,4.94S364,412.11,364,412.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.68,
    y: 101.36,
    width: 86.41,
    height: 19.57,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,112l-1.63,1c-.45.28-.83.5-1.15.68a5.19,5.19,0,0,1-.8.39,1.54,1.54,0,0,1-.59.13,1.49,1.49,0,0,1-.45-.06.89.89,0,0,1-.3-.18.65.65,0,0,1-.17-.26,1.21,1.21,0,0,1-.05-.34.85.85,0,0,1,.05-.26c0-.09.09-.19.14-.28s.12-.19.18-.3a3.59,3.59,0,0,0,.17-.34l.95-2.1L475,112l-.11,0a.24.24,0,0,1-.14,0,.15.15,0,0,1,0-.13.35.35,0,0,1,.06-.17.73.73,0,0,1,.24-.19l1.61-.94.64-.37.61-.34.51-.29.35-.2h.8l.05.06a.49.49,0,0,1,0,.13,1.72,1.72,0,0,1-.09.46c-.06.19-.14.41-.23.66l-.31.76c-.12.27-.22.52-.32.76l-.31.7-.33.73a1.53,1.53,0,0,0,.53-.17c.25-.11.54-.26.89-.45l1.17-.68,1.41-.82a.12.12,0,0,1,.09,0,.24.24,0,0,1,.14.05.15.15,0,0,1,.07.14.25.25,0,0,1-.07.16A.66.66,0,0,1,482,112Zm-1.72-4.82h.14l.24,0,.27,0a1.6,1.6,0,0,1,.26.08.77.77,0,0,1,.2.13.31.31,0,0,1,.09.2l-.9.69-.41.19a.24.24,0,0,1-.18-.06.51.51,0,0,1-.09-.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.86,111.53l.13,0a.27.27,0,0,1,.15,0,.14.14,0,0,1,.08.12c0,.06-.07.14-.19.24l-.46.33-.55.34-.49.3c-.18.12-.39.26-.62.43s-.46.33-.7.49a5.73,5.73,0,0,1-.71.4,1.54,1.54,0,0,1-.64.16.58.58,0,0,1-.43-.18.86.86,0,0,1-.18-.6,2.51,2.51,0,0,1,.08-.56,5.3,5.3,0,0,1,.24-.75c.14-.34.26-.63.36-.89l.26-.65c.06-.18.11-.33.14-.45a.86.86,0,0,0,.05-.27q0-.21-.15-.21a.81.81,0,0,0-.44.2,7.44,7.44,0,0,0-.62.52q-.35.33-.72.75c-.26.29-.49.58-.72.88s-.44.59-.62.88a6.31,6.31,0,0,0-.42.8.26.26,0,0,1-.09.13,1.11,1.11,0,0,1-.16.11l-.19.07a.76.76,0,0,1-.21,0,.43.43,0,0,1-.29-.1.41.41,0,0,1-.12-.34,1.6,1.6,0,0,1,.07-.45c.05-.17.11-.34.16-.49s.14-.49.22-.75l.23-.69c.08-.24.17-.48.25-.71l.12-.2a1.51,1.51,0,0,0,.11-.22.85.85,0,0,0,.09-.22.68.68,0,0,0,0-.19c0-.1-.05-.15-.14-.15a1.37,1.37,0,0,0-.67.2,5.51,5.51,0,0,0-.78.54c-.26.22-.53.47-.8.74s-.51.56-.73.84a8.9,8.9,0,0,0-.58.81,3.35,3.35,0,0,0-.33.66c0,.11-.08.2-.11.29a1,1,0,0,1-.1.21.41.41,0,0,1-.14.12.41.41,0,0,1-.21,0A.38.38,0,0,1,484,114a.71.71,0,0,1-.09-.38,1.3,1.3,0,0,1,.06-.32,5,5,0,0,1,.17-.5l.22-.62.26-.66.24-.63c.08-.21.15-.39.2-.55l-3,1.75a.3.3,0,0,1-.15,0,.19.19,0,0,1-.13,0,.12.12,0,0,1-.05-.11.32.32,0,0,1,.07-.19,1,1,0,0,1,.26-.21l2.22-1.29.19-.13.23-.11.25-.08a1,1,0,0,1,.25,0,.4.4,0,0,1,.24.07.58.58,0,0,1,.19.16.7.7,0,0,1,.11.21.6.6,0,0,1,0,.22,1.55,1.55,0,0,1,0,.22l-.07.27-.12.38c-.06.15-.13.35-.22.59l.46-.61c.16-.21.33-.42.51-.62a7.66,7.66,0,0,1,.57-.57,3.5,3.5,0,0,1,.63-.48,3.34,3.34,0,0,1,.72-.33,2.56,2.56,0,0,1,.79-.12.61.61,0,0,1,.25.06.54.54,0,0,1,.21.19.87.87,0,0,1,.16.32,1.56,1.56,0,0,1,.06.46,3.11,3.11,0,0,1-.09.69,4.83,4.83,0,0,1-.31.9,6.43,6.43,0,0,1,.89-1.09,6.06,6.06,0,0,1,.88-.72,4.08,4.08,0,0,1,.81-.44,5.56,5.56,0,0,1,.69-.23,1.24,1.24,0,0,1,.37.06,1.35,1.35,0,0,1,.35.14,1,1,0,0,1,.26.25.68.68,0,0,1,.1.35.49.49,0,0,1,0,.12.52.52,0,0,1,0,.11,3.92,3.92,0,0,1-.21.56c-.08.2-.18.4-.28.61s-.2.41-.3.6-.2.39-.28.57a4.29,4.29,0,0,0-.21.46,1.1,1.1,0,0,0-.08.33c0,.1,0,.15.11.15a.67.67,0,0,0,.29-.12l.45-.3.55-.38.6-.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.85,111.54l3.3-2.08,0-.07.14-.16a2.51,2.51,0,0,1,.23-.21,1.89,1.89,0,0,1,.31-.22,2.42,2.42,0,0,1,.39-.16,1.73,1.73,0,0,1,.47-.06,4.13,4.13,0,0,1,.76.07,2.31,2.31,0,0,1,.75.27,1.52,1.52,0,0,1,.57.53,1.61,1.61,0,0,1,.23.89,1.48,1.48,0,0,1-.14.57,3.13,3.13,0,0,1-.39.67,6.22,6.22,0,0,1-.61.7,8.47,8.47,0,0,1-.78.66l2.35-1.4h.09a.12.12,0,0,1,.11,0,.16.16,0,0,1,0,.12.32.32,0,0,1-.06.18.52.52,0,0,1-.18.18c-.52.3-1,.56-1.39.78a11.09,11.09,0,0,1-1.11.54,9.07,9.07,0,0,1-.9.35,6.62,6.62,0,0,1-.77.19,5.94,5.94,0,0,1-.71.08c-.23,0-.46,0-.71,0-.17.37-.35.75-.54,1.12l-.55,1.08c-.18.35-.35.69-.5,1a7.83,7.83,0,0,0-.37.9s0,.09-.07.15a1.37,1.37,0,0,1-.13.2,1.33,1.33,0,0,1-.16.17.25.25,0,0,1-.17.07.75.75,0,0,1-.21,0,1,1,0,0,1-.21-.07.71.71,0,0,1-.17-.11.25.25,0,0,1-.06-.16s0,0,0,0a3.87,3.87,0,0,1,.27-.85c.13-.33.3-.69.49-1.08s.4-.81.63-1.25l.7-1.34c.24-.45.47-.9.69-1.34s.42-.88.6-1.29a1.74,1.74,0,0,1,.1-.19l.14-.21.15-.19.13-.17-.38.22-.66.39-.84.5-.92.54-.07,0a.14.14,0,0,1-.12-.06.2.2,0,0,1-.06-.15.29.29,0,0,1,.06-.16A.54.54,0,0,1,495.85,111.54Zm5.29-2.21a1.07,1.07,0,0,0-.7.33,5.56,5.56,0,0,0-.74.9c-.24.38-.49.82-.74,1.31s-.49,1-.73,1.59a3.12,3.12,0,0,0,.78-.11,4.61,4.61,0,0,0,.83-.3,5.14,5.14,0,0,0,.78-.46,3.87,3.87,0,0,0,.67-.6,3,3,0,0,0,.46-.71,1.92,1.92,0,0,0,.17-.78,3.32,3.32,0,0,0,0-.48,1.35,1.35,0,0,0-.14-.37.69.69,0,0,0-.24-.24A.8.8,0,0,0,501.14,109.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.32,109a1.47,1.47,0,0,1,.64.14,1.38,1.38,0,0,1,.47.39,1.72,1.72,0,0,1,.3.57,2.56,2.56,0,0,1,.1.69,2.9,2.9,0,0,1-.05.48c0,.17-.09.35-.15.53a3.76,3.76,0,0,1-.23.55,3.64,3.64,0,0,1-.31.51l.29-.16.36-.2.4-.23.4-.23,1-.56a.21.21,0,0,1,.12,0c.09,0,.14,0,.14.15a.5.5,0,0,1-.26.39l-.59.38c-.24.14-.5.29-.78.43a7.13,7.13,0,0,1-.85.38,3,3,0,0,1-.81.19,3.92,3.92,0,0,1-1.13.6,4.48,4.48,0,0,1-1.53.23,2.92,2.92,0,0,1-.72-.07,1.19,1.19,0,0,1-.48-.23.73.73,0,0,1-.26-.36,1.44,1.44,0,0,1-.08-.49,2.45,2.45,0,0,1,.16-.85,5.8,5.8,0,0,1,.4-.88,6.6,6.6,0,0,1,.52-.81,6.15,6.15,0,0,1,.49-.61,6.42,6.42,0,0,1-.56.41c-.24.16-.52.34-.82.52l-1,.57-1,.59a.37.37,0,0,1-.14,0,.17.17,0,0,1-.12,0,.16.16,0,0,1,0-.12.27.27,0,0,1,.07-.18.78.78,0,0,1,.23-.2l1.61-.94,1.15-.68c.33-.18.61-.33.85-.44a4.56,4.56,0,0,1,.69-.26,3.78,3.78,0,0,1,.7-.13Q508.84,109,509.32,109Zm-2.49,4.64a2,2,0,0,0,.77-.16,3.73,3.73,0,0,0,.73-.44.53.53,0,0,1-.12-.22.88.88,0,0,1,0-.24.37.37,0,0,1,.15-.32.55.55,0,0,1,.34-.11.78.78,0,0,1,.41.12,2.38,2.38,0,0,0,.38-.34,2.53,2.53,0,0,0,.31-.42,2.11,2.11,0,0,0,.21-.46,1.28,1.28,0,0,0,.08-.46.94.94,0,0,0-.07-.37.74.74,0,0,0-.23-.3,1.1,1.1,0,0,0-.42-.21,2.22,2.22,0,0,0-.62-.08,1.39,1.39,0,0,0-.61.16,2.8,2.8,0,0,0-.58.43,4.56,4.56,0,0,0-.51.62,5.09,5.09,0,0,0-.42.71,5.27,5.27,0,0,0-.27.72,2.22,2.22,0,0,0-.1.64,1,1,0,0,0,.14.53A.54.54,0,0,0,506.83,113.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.48,109.62a1.35,1.35,0,0,1-.06.37,3.26,3.26,0,0,1-.14.45c-.06.16-.12.32-.19.48s-.13.32-.18.48-.11.3-.15.43a1.64,1.64,0,0,0,0,.34.29.29,0,0,0,0,.19.18.18,0,0,0,.17.07.63.63,0,0,0,.25-.07l.37-.19.47-.29.55-.34a.19.19,0,0,1,.12,0,.17.17,0,0,1,.17.17.32.32,0,0,1-.06.17,1.69,1.69,0,0,1-.23.21,10.22,10.22,0,0,1-1.48.93,2.62,2.62,0,0,1-1.07.33,1.23,1.23,0,0,1-.51-.09.31.31,0,0,1-.18-.29,1,1,0,0,1,.17-.5,3.94,3.94,0,0,1,.56-.71,2.48,2.48,0,0,0,.24-.55,4.41,4.41,0,0,0,.12-.59c0-.19.05-.37.06-.53s0-.29,0-.39a.73.73,0,0,0-.08-.37.27.27,0,0,0-.26-.13.58.58,0,0,0-.39.18,2.16,2.16,0,0,0-.37.5,5.64,5.64,0,0,0-.38.74c-.13.29-.25.6-.38.93s-.27.68-.4,1-.29.71-.43,1.07a2.14,2.14,0,0,1-.1.22.74.74,0,0,1-.13.21.61.61,0,0,1-.16.16.33.33,0,0,1-.19.06.48.48,0,0,1-.35-.11.43.43,0,0,1-.12-.34.76.76,0,0,1,0-.15.88.88,0,0,1,.06-.17l1.2-2.42a5.37,5.37,0,0,1,.51-1,5.18,5.18,0,0,1,.49-.65l-1,.61-1,.6-.89.54-.75.46-.55.32-.31.16a.23.23,0,0,1-.11,0,.15.15,0,0,1-.12,0,.18.18,0,0,1,0-.13.38.38,0,0,1,.06-.19.58.58,0,0,1,.21-.2l1.66-1,.65-.39.62-.37.51-.31.34-.2a5.39,5.39,0,0,1,.58-.3,3.28,3.28,0,0,1,.57-.21,3.39,3.39,0,0,1,.57-.13,5.54,5.54,0,0,1,.6-.06.57.57,0,0,1,.29.09,1,1,0,0,1,.28.22,1.11,1.11,0,0,1,.21.32A.85.85,0,0,1,519.48,109.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.92,109.08c.11,0,.16.11.16.18a.44.44,0,0,1-.12.3,1.19,1.19,0,0,1-.32.25,3.05,3.05,0,0,1-.44.19,4.43,4.43,0,0,1-.49.13l-.47.09-.37,0-.94,0H524c-.1.51-.19.94-.26,1.3s-.14.68-.2.94-.09.47-.1.61,0,.27,0,.4a.31.31,0,0,0,0,.17.12.12,0,0,0,.12.06,1.33,1.33,0,0,0,.67-.21,8.89,8.89,0,0,0,.84-.52l1-.69a7.1,7.1,0,0,1,1.26-.75l.13,0,.09,0a.13.13,0,0,1,.14.14.46.46,0,0,1-.08.22.84.84,0,0,1-.28.23c-.63.38-1.1.68-1.4.9l-1.07.77a6.73,6.73,0,0,1-.86.53,1.82,1.82,0,0,1-.8.2.73.73,0,0,1-.54-.19,1,1,0,0,1-.28-.46,2.13,2.13,0,0,1-.11-.58c0-.21,0-.39,0-.56a5.72,5.72,0,0,1,.08-.92c.05-.31.1-.61.15-.89l-1,.6-1,.59a.08.08,0,0,1-.07,0,.22.22,0,0,1-.13-.06.18.18,0,0,1-.06-.14.29.29,0,0,1,.06-.16.59.59,0,0,1,.2-.17l1.1-.63c.35-.2.68-.41,1-.62v-.06l-.8,0h-.22a.24.24,0,0,1-.17-.06.25.25,0,0,1-.08-.15.17.17,0,0,1,.1-.13,1.12,1.12,0,0,1,.3-.11,4,4,0,0,1,.46-.1c.18,0,.38-.06.6-.09a13.82,13.82,0,0,1,.81-2,5.61,5.61,0,0,1,1-1.42,3.52,3.52,0,0,1,1.22-.84,4,4,0,0,1,1.52-.27,1,1,0,0,1,.54.12.41.41,0,0,1,.17.35,1.41,1.41,0,0,1-.27.72,6.21,6.21,0,0,1-.73.94c-.31.34-.69.7-1.12,1.09s-.92.77-1.45,1.17l.81-.06.8-.07.78-.07.72-.08a.14.14,0,0,0,.1-.06.16.16,0,0,1,.11,0Zm-.62-3.67a1.56,1.56,0,0,0-.67.15,2.56,2.56,0,0,0-.6.41,4.29,4.29,0,0,0-.53.63,7.12,7.12,0,0,0-.46.77,7.85,7.85,0,0,0-.4.88c-.13.31-.24.62-.34.93.56-.41,1.05-.79,1.48-1.15s.77-.69,1.06-1a5.28,5.28,0,0,0,.64-.79,1.18,1.18,0,0,0,.21-.56.26.26,0,0,0-.07-.2A.48.48,0,0,0,527.3,105.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.42,112.05l-.08,0a.11.11,0,0,1-.09,0,.29.29,0,0,1,0-.14.45.45,0,0,1,0-.18.37.37,0,0,1,.16-.17l2.31-1.35a5.64,5.64,0,0,1,.93-.43,8.25,8.25,0,0,1,1-.3c.34-.07.67-.13,1-.17s.65,0,.94,0a3.64,3.64,0,0,1,.48,0,3,3,0,0,1,.38.1.76.76,0,0,1,.25.15.27.27,0,0,1,.09.2.11.11,0,0,1-.07.12.34.34,0,0,1-.14,0l-.18,0a.29.29,0,0,0-.14,0,2.72,2.72,0,0,1-.12.4c0,.16-.1.33-.16.5s-.11.33-.15.46-.07.22-.08.24-.13.38-.22.65-.19.63-.3,1.07l.14-.07.35-.19.49-.28.57-.32,1.48-.89a.37.37,0,0,1,.15,0,.14.14,0,0,1,.11,0,.21.21,0,0,1,0,.12.48.48,0,0,1-.07.2.51.51,0,0,1-.23.2L533,114a1.17,1.17,0,0,1-.23.11l-.2,0a.35.35,0,0,1-.21-.06.36.36,0,0,1-.15-.15.72.72,0,0,1-.08-.22,1.18,1.18,0,0,1,0-.27,1.63,1.63,0,0,1,0-.31,2.17,2.17,0,0,1,.08-.3,3,3,0,0,1-.42.61,2.89,2.89,0,0,1-.52.43,2.22,2.22,0,0,1-.56.27,2,2,0,0,1-.57.08,1.49,1.49,0,0,1-.52-.08,1.24,1.24,0,0,1-.43-.26,1.19,1.19,0,0,1-.3-.42,1.55,1.55,0,0,1-.1-.59,2.5,2.5,0,0,1,0-.45,4.91,4.91,0,0,1,.1-.5l.15-.49c.06-.16.12-.31.18-.44Zm5.67-2.32a2.77,2.77,0,0,0-1,.17,3.29,3.29,0,0,0-.85.45,3.86,3.86,0,0,0-.71.63,5.08,5.08,0,0,0-.54.73,4.4,4.4,0,0,0-.34.74,2.09,2.09,0,0,0-.12.65.82.82,0,0,0,.14.52.51.51,0,0,0,.46.2,1,1,0,0,0,.41-.11,2.42,2.42,0,0,0,.45-.31,6,6,0,0,0,.45-.43l.41-.49c.13-.17.23-.33.33-.49a2.17,2.17,0,0,0,.2-.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.74,110a1.92,1.92,0,0,0-.59.13,6.69,6.69,0,0,0-.78.37c-.28.16-.58.34-.88.55a9.77,9.77,0,0,0-.9.69,10.33,10.33,0,0,0-.83.79,8.42,8.42,0,0,0-.69.83.22.22,0,0,0,0,.14,1,1,0,0,1,0,.23.49.49,0,0,1-.14.21.47.47,0,0,1-.33.09.6.6,0,0,1-.25,0,.36.36,0,0,1-.14-.1.25.25,0,0,1,0-.15,1.25,1.25,0,0,1,0-.21,1.13,1.13,0,0,1,.07-.33c0-.14.09-.31.16-.5s.14-.4.22-.62l.25-.65c.09-.22.17-.44.25-.65s.14-.39.19-.55l-3,1.76h-.09a.17.17,0,0,1-.13,0,.21.21,0,0,1,0-.12.32.32,0,0,1,.07-.19.4.4,0,0,1,.19-.17l1.54-.92,1-.57.55-.32.28-.15a.52.52,0,0,1,.16-.06.36.36,0,0,1,.15,0,.44.44,0,0,1,.3.1.3.3,0,0,1,.11.23,1,1,0,0,1-.08.36c-.05.15-.12.31-.2.49s-.16.36-.24.55-.15.35-.21.51a1.16,1.16,0,0,1-.06.15,1.21,1.21,0,0,1,0,.14,2.05,2.05,0,0,1-.08.19l-.14.32a9,9,0,0,1,.61-.71c.24-.24.49-.48.77-.71a8.49,8.49,0,0,1,.88-.67,7.18,7.18,0,0,1,1-.56,5.42,5.42,0,0,1,1-.37,4.13,4.13,0,0,1,1-.14.59.59,0,0,1,.43.13.52.52,0,0,1,.12.36,1.71,1.71,0,0,1-.07.45,4.65,4.65,0,0,1-.18.58c-.08.21-.17.43-.27.67s-.2.48-.31.72l-.33.73c-.1.25-.21.48-.3.7a5,5,0,0,0,.73-.37c.26-.15.53-.32.82-.51l.93-.62c.33-.23.68-.45,1-.68a.21.21,0,0,1,.12,0c.1,0,.15.06.15.17a.4.4,0,0,1-.07.19.59.59,0,0,1-.2.18c-.49.31-.94.6-1.34.88l-1.09.74a6.57,6.57,0,0,1-.89.51,1.81,1.81,0,0,1-.76.19,1.25,1.25,0,0,1-.36,0,.69.69,0,0,1-.24-.14.51.51,0,0,1-.15-.21.69.69,0,0,1,0-.25.67.67,0,0,1,.06-.28,1.31,1.31,0,0,1,.16-.31c.13-.28.27-.57.43-.88s.3-.61.43-.88.25-.53.34-.74a1.48,1.48,0,0,0,.14-.47C543.82,110.07,543.79,110,543.74,110Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.49,109.08c.11,0,.16.11.16.18a.44.44,0,0,1-.12.3,1.13,1.13,0,0,1-.31.25,3.81,3.81,0,0,1-.45.19,3.92,3.92,0,0,1-.49.13l-.47.09-.37,0-.93,0h-.9c-.1.51-.19.94-.26,1.3s-.14.68-.2.94a6,6,0,0,0-.09.61c0,.13,0,.27,0,.4a.43.43,0,0,0,0,.17.15.15,0,0,0,.13.06,1.4,1.4,0,0,0,.67-.21c.24-.13.52-.31.83-.52l1-.69a7.09,7.09,0,0,1,1.27-.75l.12,0,.09,0a.12.12,0,0,1,.14.14.46.46,0,0,1-.08.22.9.9,0,0,1-.27.23q-1,.57-1.41.9l-1.06.77a7.55,7.55,0,0,1-.87.53,1.79,1.79,0,0,1-.8.2.73.73,0,0,1-.54-.19,1,1,0,0,1-.28-.46,2.59,2.59,0,0,1-.11-.58c0-.21,0-.39,0-.56a5.72,5.72,0,0,1,.08-.92c.06-.31.11-.61.15-.89l-1,.6-1,.59a.11.11,0,0,1-.07,0A.18.18,0,0,1,547,112a.19.19,0,0,1-.07-.14.29.29,0,0,1,.06-.16.64.64,0,0,1,.21-.17l1.1-.63c.34-.2.67-.41,1-.62v-.06l-.8,0h-.22a.24.24,0,0,1-.17-.06A.31.31,0,0,1,548,110s0-.09.11-.13a1.12,1.12,0,0,1,.3-.11,3.26,3.26,0,0,1,.46-.1c.17,0,.37-.06.59-.09a13.82,13.82,0,0,1,.81-2,5.38,5.38,0,0,1,1-1.42,3.39,3.39,0,0,1,1.21-.84,4.07,4.07,0,0,1,1.52-.27.94.94,0,0,1,.54.12.41.41,0,0,1,.17.35,1.47,1.47,0,0,1-.26.72,7.86,7.86,0,0,1-.73.94c-.32.34-.69.7-1.13,1.09s-.92.77-1.45,1.17l.81-.06.81-.07.77-.07.72-.08a.14.14,0,0,0,.1-.06.16.16,0,0,1,.11,0Zm-.61-3.67a1.53,1.53,0,0,0-.67.15,2.21,2.21,0,0,0-.6.41,3.78,3.78,0,0,0-.54.63,7.12,7.12,0,0,0-.46.77,7.85,7.85,0,0,0-.4.88q-.18.47-.33.93c.56-.41,1-.79,1.47-1.15s.77-.69,1.06-1a4.71,4.71,0,0,0,.64-.79,1.12,1.12,0,0,0,.22-.56.26.26,0,0,0-.08-.2A.46.46,0,0,0,553.88,105.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.77,112.36a5.15,5.15,0,0,1-5.24-5V95h1v12.33a4.24,4.24,0,0,0,8.47,0V89.08a6.61,6.61,0,0,0-13.2,0h-1a7.61,7.61,0,0,1,15.2,0v18.24A5.15,5.15,0,0,1,499.77,112.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M500.91,113a5.17,5.17,0,0,1-5.25-5.06V95.62h1V108a4.22,4.22,0,0,0,8.43,0V89.71h1V108A5.17,5.17,0,0,1,500.91,113Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 473.29,
    y: 120.92,
    width: 82.51,
    height: 2.46
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M296,147.3a2,2,0,0,1-.29-.52l-.72-1.52c-.64-1.39-1.53-3.3-2.6-5.63-2.22-4.75-5.4-11.24-9.24-18.24s-7.41-13.32-9.84-18c-1.22-2.32-2.19-4.21-2.83-5.52l-.74-1.52a2.2,2.2,0,0,1-.22-.55,3.36,3.36,0,0,1,.31.5l.83,1.47c.73,1.35,1.74,3.19,3,5.44l10,17.89c3.85,7,7,13.55,9.12,18.34,1.06,2.39,1.91,4.34,2.46,5.7q.38.94.63,1.56A3,3,0,0,1,296,147.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,118.46a18,18,0,0,1,2.86.44c1.76.31,4.19.71,6.89,1s5.15.57,6.93.71a21.46,21.46,0,0,1,2.88.28,13.09,13.09,0,0,1-2.9.08c-1.79,0-4.26-.21-7-.55s-5.14-.8-6.89-1.21A14,14,0,0,1,282,118.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.85,126.7a22.71,22.71,0,0,1,.45-3.25c.33-2,.78-4.74,1.23-7.79s.79-5.81,1-7.82a22.29,22.29,0,0,1,.5-3.24,20.21,20.21,0,0,1-.13,3.28c-.16,2-.45,4.8-.9,7.86s-1,5.8-1.37,7.78A19.14,19.14,0,0,1,270.85,126.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,128.3a1.7,1.7,0,1,0-.06,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.91,128.35s-.09.16-.36.29a1.93,1.93,0,0,1-1.28.09,1.9,1.9,0,0,1-1.37-1.35,2,2,0,0,1,3.12-2.24,1.95,1.95,0,0,1,.34,2.91c-.21.22-.37.28-.39.25a2.63,2.63,0,0,0,.52-1.44,1.53,1.53,0,0,0-.73-1.31,1.57,1.57,0,0,0-2.39,1.72,1.51,1.51,0,0,0,1,1.1A2.7,2.7,0,0,0,271.91,128.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.74,149.79a1.7,1.7,0,1,0-.06.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.68,149.84s-.09.15-.36.29a1.93,1.93,0,0,1-1.28.09,1.9,1.9,0,0,1-1.37-1.35,2,2,0,0,1,3.12-2.24,1.95,1.95,0,0,1,.34,2.91c-.21.22-.37.27-.39.25a2.63,2.63,0,0,0,.52-1.44,1.53,1.53,0,0,0-.73-1.31,1.57,1.57,0,0,0-2.39,1.71,1.51,1.51,0,0,0,1,1.11A2.7,2.7,0,0,0,297.68,149.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.4,128.47a18,18,0,0,1-1.62-4.1,18.38,18.38,0,0,1-1.12-4.26,18.87,18.87,0,0,1,1.61,4.1A19.39,19.39,0,0,1,295.4,128.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.47,134.2c.07-.13,2.64,1.13,5.93,2.37s6.06,2,6,2.17a23.46,23.46,0,0,1-6.2-1.68A23.2,23.2,0,0,1,290.47,134.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,129.19a1.89,1.89,0,1,0-.06,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.15,129.23s-.09.16-.37.3a1.84,1.84,0,0,1-1.27.08,1.88,1.88,0,0,1-1.37-1.34,2,2,0,0,1,3.12-2.24,1.88,1.88,0,0,1,.83,1.73,1.91,1.91,0,0,1-.49,1.18c-.21.22-.37.27-.39.25a2.63,2.63,0,0,0,.52-1.44,1.55,1.55,0,0,0-.73-1.31,1.57,1.57,0,0,0-2.39,1.71,1.49,1.49,0,0,0,1,1.11A2.55,2.55,0,0,0,296.15,129.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.78,142.8a1.83,1.83,0,1,0-.07,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.71,142.85s-.08.16-.36.29a1.95,1.95,0,0,1-2.64-1.26,2,2,0,0,1,3.12-2.23,1.86,1.86,0,0,1,.83,1.72,1.88,1.88,0,0,1-.49,1.18c-.21.22-.38.28-.39.25a2.58,2.58,0,0,0,.51-1.44,1.52,1.52,0,0,0-.72-1.31,1.7,1.7,0,0,0-1.79,0,1.67,1.67,0,0,0-.6,1.69,1.52,1.52,0,0,0,1,1.11A2.69,2.69,0,0,0,282.71,142.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.05,140a54,54,0,0,1,1.57-7.24,52.6,52.6,0,0,1,2.08-7.12,54,54,0,0,1-1.57,7.25A52.72,52.72,0,0,1,282.05,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,123.38a1.7,1.7,0,1,0-.06.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.9,123.43s-.09.16-.36.29a1.91,1.91,0,0,1-1.28.09,1.87,1.87,0,0,1-1.36-1.35,2,2,0,0,1,3.11-2.23,1.95,1.95,0,0,1,.35,2.9c-.22.22-.38.28-.4.25a2.54,2.54,0,0,0,.52-1.43,1.53,1.53,0,0,0-.72-1.32,1.58,1.58,0,0,0-2.4,1.72,1.54,1.54,0,0,0,1,1.11A2.63,2.63,0,0,0,278.9,123.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.91,114.83a11.32,11.32,0,0,1,2.16,2.66,11.37,11.37,0,0,1,1.74,3,11.32,11.32,0,0,1-2.16-2.66A11.37,11.37,0,0,1,272.91,114.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.8,372.71a2.1,2.1,0,0,1,0,.53c-.06.39-.13.88-.22,1.47-.22,1.36-.52,3.19-.87,5.43-.74,4.57-1.69,10.91-2.28,17.95s-1,13.46-1.57,18.07c-.25,2.3-.48,4.17-.66,5.45-.09.6-.16,1.09-.21,1.48a2,2,0,0,1-.11.51,1.72,1.72,0,0,1,0-.52c0-.4.07-.89.12-1.49.12-1.37.29-3.22.49-5.47.44-4.62.84-11,1.42-18.07s1.61-13.41,2.43-18c.41-2.28.77-4.12,1-5.39.13-.59.23-1.07.32-1.46A1.72,1.72,0,0,1,468.8,372.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.31,404.45a17.77,17.77,0,0,1-2.13-2c-1.28-1.24-3.08-2.93-5.12-4.72s-4-3.34-5.36-4.45a21.53,21.53,0,0,1-2.24-1.84,12.82,12.82,0,0,1,2.46,1.55c1.46,1,3.42,2.55,5.48,4.35s3.82,3.54,5.05,4.85A14,14,0,0,1,464.31,404.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.17,403.84a23.39,23.39,0,0,1-2.18,2.44c-1.39,1.47-3.3,3.5-5.37,5.79s-3.9,4.38-5.23,5.9a22.44,22.44,0,0,1-2.21,2.41,18.23,18.23,0,0,1,1.93-2.65c1.26-1.58,3.05-3.72,5.13-6s4-4.29,5.48-5.7A19.37,19.37,0,0,1,478.17,403.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.14,401.89a1.82,1.82,0,1,0,1.91,1.78,1.9,1.9,0,0,0-1.84-1.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.21,401.88s.17-.08.47,0a2,2,0,0,1,1.11.64,1.89,1.89,0,0,1,.38,1.88,2,2,0,0,1-3.83.12,1.89,1.89,0,0,1,.26-1.9,2,2,0,0,1,1.07-.71c.3-.06.47,0,.47,0a2.63,2.63,0,0,0-1.24.9,1.54,1.54,0,0,0-.12,1.5,1.57,1.57,0,0,0,2.94-.09,1.55,1.55,0,0,0-.22-1.49A2.66,2.66,0,0,0,478.21,401.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.74,369.67a1.87,1.87,0,1,0,.08,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.82,369.67s.16-.08.46,0a1.93,1.93,0,0,1,1.11.64,1.86,1.86,0,0,1,.38,1.88,2,2,0,0,1-3.83.12,1.86,1.86,0,0,1,.27-1.9,2,2,0,0,1,1.06-.71c.3-.06.47,0,.47,0s-.7.11-1.23.91a1.53,1.53,0,0,0-.13,1.49,1.57,1.57,0,0,0,2.94-.08,1.52,1.52,0,0,0-.22-1.49A2.7,2.7,0,0,0,468.82,369.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.79,388.67a18.57,18.57,0,0,1-.94,4.31,18.91,18.91,0,0,1-1.45,4.17,18.31,18.31,0,0,1,1-4.31A19.86,19.86,0,0,1,458.79,388.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.08,386.67c-.13.07-1.56-2.41-3.6-5.28s-3.9-5.05-3.79-5.16a32.86,32.86,0,0,1,7.39,10.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.52,387.63a1.67,1.67,0,1,0,.08,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.6,387.62s.16-.08.46,0a2,2,0,0,1,1.11.64,1.89,1.89,0,0,1,.38,1.88,2,2,0,0,1-3.83.12,1.86,1.86,0,0,1,.27-1.9,2,2,0,0,1,1.06-.71c.3-.06.47,0,.47,0a2.58,2.58,0,0,0-1.23.9,1.52,1.52,0,0,0-.13,1.5,1.57,1.57,0,0,0,2.94-.09,1.52,1.52,0,0,0-.22-1.49A2.7,2.7,0,0,0,458.6,387.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.26,383.82a1.87,1.87,0,1,0,.08,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.34,383.82s.16-.08.46,0a2,2,0,0,1,1.49,2.52,2,2,0,0,1-3.83.12,2,2,0,0,1,1.33-2.61c.3-.06.47,0,.47,0s-.7.1-1.23.91a1.5,1.5,0,0,0-.13,1.49,1.57,1.57,0,0,0,2.94-.09,1.5,1.5,0,0,0-.22-1.48A2.61,2.61,0,0,0,477.34,383.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.31,386.54a53.3,53.3,0,0,1-5.35,5.14,55.16,55.16,0,0,1-5.69,4.75,51.22,51.22,0,0,1,5.34-5.14A52,52,0,0,1,476.31,386.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.59,402.06a1.82,1.82,0,0,0,.15,3.64,1.82,1.82,0,0,0-.07-3.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.67,402.06s.16-.08.46,0a1.93,1.93,0,0,1,1.11.64,1.86,1.86,0,0,1,.38,1.88,2,2,0,0,1-3.83.12,2,2,0,0,1,1.33-2.61c.3-.06.47,0,.47,0s-.7.11-1.23.91a1.53,1.53,0,0,0-.13,1.49,1.57,1.57,0,0,0,2.94-.09,1.51,1.51,0,0,0-.22-1.48A2.7,2.7,0,0,0,469.67,402.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.84,412.54a22.62,22.62,0,0,1-.1-6.84,11.76,11.76,0,0,1,.31,3.42A11.09,11.09,0,0,1,469.84,412.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.89,382.41s.13.13.33.41l.84,1.23,3.05,4.57c2.59,3.85,6.2,9.14,10.56,14.7s8.4,10.56,11.15,14.3c1.39,1.86,2.49,3.38,3.24,4.45l.85,1.22c.19.29.28.44.26.45a2.37,2.37,0,0,1-.35-.38l-.93-1.17-3.36-4.35c-2.82-3.68-6.88-8.63-11.27-14.2s-7.95-10.91-10.45-14.82c-1.26-1.95-2.25-3.55-2.92-4.66l-.76-1.28A2.51,2.51,0,0,1,124.89,382.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.21,408.71a18.89,18.89,0,0,1-2.89,0c-1.78,0-4.25,0-7,0s-5.18.25-6.95.39a20.84,20.84,0,0,1-2.89.17,13.31,13.31,0,0,1,2.85-.54,69,69,0,0,1,7-.54c2.73-.08,5.21,0,7,.11A14.34,14.34,0,0,1,143.21,408.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,398.83a24,24,0,0,1,.06,3.27c0,2,0,4.81,0,7.89s.13,5.87.19,7.89a23.82,23.82,0,0,1,0,3.27,18.42,18.42,0,0,1-.39-3.25c-.16-2-.3-4.81-.34-7.9s0-5.89.14-7.91A18.46,18.46,0,0,1,153,398.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.59,397.42a1.81,1.81,0,1,0,.06-.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.65,397.36s.06-.17.31-.34a1.94,1.94,0,0,1,1.25-.29,1.89,1.89,0,0,1,1.56,1.12,2.14,2.14,0,0,1-.41,2.32,2.11,2.11,0,0,1-2.32.37,1.86,1.86,0,0,1-1.1-1.57,1.89,1.89,0,0,1,.3-1.24c.18-.25.33-.33.35-.31a2.64,2.64,0,0,0-.28,1.5,1.5,1.5,0,0,0,.92,1.18,1.56,1.56,0,0,0,2.09-2.06,1.5,1.5,0,0,0-1.17-.94A2.63,2.63,0,0,0,151.65,397.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.78,380.23a1.89,1.89,0,0,0,0,2.56,1.82,1.82,0,1,0,0-2.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.83,380.17s.07-.17.32-.34a1.94,1.94,0,0,1,2.8.83,2.1,2.1,0,0,1-.4,2.31,2.13,2.13,0,0,1-2.32.38,1.86,1.86,0,0,1-1.1-1.57,1.94,1.94,0,0,1,.3-1.25c.18-.25.33-.33.35-.3a2.65,2.65,0,0,0-.29,1.5,1.53,1.53,0,0,0,.93,1.18,1.69,1.69,0,0,0,1.76-.31,1.67,1.67,0,0,0,.33-1.76,1.55,1.55,0,0,0-1.17-.94A2.74,2.74,0,0,0,122.83,380.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.43,400.91a19.14,19.14,0,0,1,2.24,3.8,18.46,18.46,0,0,1,1.77,4,19.4,19.4,0,0,1-2.23-3.8A18.58,18.58,0,0,1,128.43,400.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.4,394.48c-.05.15-2.78-.7-6.23-1.41s-6.3-1.05-6.29-1.2a23.79,23.79,0,0,1,6.39.69A23.57,23.57,0,0,1,132.4,394.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.51,400.33a2,2,0,1,0,.06-.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.57,400.28s.06-.17.31-.35a2,2,0,0,1,2.81.83,2,2,0,0,1-2.73,2.7,1.92,1.92,0,0,1-1.1-1.58,1.9,1.9,0,0,1,.31-1.24c.17-.25.32-.33.34-.31a2.66,2.66,0,0,0-.28,1.51,1.55,1.55,0,0,0,.92,1.18,1.57,1.57,0,0,0,2.1-2.07,1.53,1.53,0,0,0-1.17-.94A2.61,2.61,0,0,0,127.57,400.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.65,384.79a1.81,1.81,0,1,0,.06-.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.71,384.73s.06-.17.31-.34a1.93,1.93,0,0,1,1.24-.29,1.89,1.89,0,0,1,1.57,1.12,2,2,0,0,1-2.73,2.69,1.86,1.86,0,0,1-1.1-1.57,1.89,1.89,0,0,1,.3-1.24c.18-.25.33-.33.35-.31a2.64,2.64,0,0,0-.28,1.5,1.49,1.49,0,0,0,.92,1.18,1.65,1.65,0,0,0,1.76-.31,1.67,1.67,0,0,0,.33-1.76,1.5,1.5,0,0,0-1.17-.93A2.63,2.63,0,0,0,138.71,384.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.8,387.43a51.62,51.62,0,0,1-.41,7.4,53.8,53.8,0,0,1-.94,7.35,52.66,52.66,0,0,1,.42-7.4A53.53,53.53,0,0,1,139.8,387.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.45,403.37a1.9,1.9,0,0,0,0,2.56,1.82,1.82,0,1,0,0-2.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.51,403.31s.06-.17.31-.34a1.94,1.94,0,0,1,1.25-.29,1.89,1.89,0,0,1,1.56,1.12,2.14,2.14,0,0,1-.41,2.32,2.11,2.11,0,0,1-2.32.37,1.93,1.93,0,0,1-.79-2.81c.17-.25.32-.33.34-.31a2.64,2.64,0,0,0-.28,1.5,1.52,1.52,0,0,0,.92,1.18,1.68,1.68,0,0,0,1.77-.3,1.73,1.73,0,0,0,.33-1.77,1.53,1.53,0,0,0-1.17-.93A2.66,2.66,0,0,0,145.51,403.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.77,410.87a22.78,22.78,0,0,1-4.73-4.94,11.7,11.7,0,0,1,2.56,2.29A11.43,11.43,0,0,1,152.77,410.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.18,118.51c-7.6,0-15.64-2.43-23.33-7.14-9.14-5.6-18.46-15.7-25.51-23.23l7.54-.38c6.76,7.22,12.81,13.12,21.24,18.29,9,5.52,18.81,7.47,26.91,5.37,5.65-1.47,11.31-5.11,16.37-10.51,4.78-5.11,6.21-7.42,9.67-13,2.92-1.24,5.38-1.31,7.37,0-3.61,5.77-7.29,11.64-12.49,17.19-5.94,6.36-12.45,10.49-19.35,12.29A33.61,33.61,0,0,1,304.18,118.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.18,118.51l.25,0,.72,0c.64,0,1.59-.09,2.81-.23a32.58,32.58,0,0,0,10.25-2.95,44.31,44.31,0,0,0,13.29-9.9,74.72,74.72,0,0,0,6.49-8c2.11-3,4.15-6.18,6.26-9.57l.07.3a5.75,5.75,0,0,0-3.43-.92,10.83,10.83,0,0,0-3.72.93l.1-.09a64.08,64.08,0,0,1-15,17.88A31.59,31.59,0,0,1,311,111.7a29.81,29.81,0,0,1-13.13.14A41.67,41.67,0,0,1,287.1,108a66.91,66.91,0,0,1-9.29-6A120.39,120.39,0,0,1,262.7,87.92l.19.07-7.54.38.16-.38a217,217,0,0,0,17.11,17,69.91,69.91,0,0,0,8.07,6,53.7,53.7,0,0,0,7.61,4,44.26,44.26,0,0,0,11.61,3.16c1.38.16,2.45.23,3.18.27l.82,0,.27,0a28.77,28.77,0,0,1-4.29-.18,42.91,42.91,0,0,1-11.7-3,52.78,52.78,0,0,1-7.67-3.93,69.49,69.49,0,0,1-8.15-6,214.93,214.93,0,0,1-17.2-17l-.33-.36.49,0,7.54-.39H263l.07.08a120.77,120.77,0,0,0,15.07,14.06,67.06,67.06,0,0,0,9.22,5.91,41.41,41.41,0,0,0,10.6,3.77,29.53,29.53,0,0,0,12.9-.13,31.11,31.11,0,0,0,11.1-5.64,57,57,0,0,0,8.5-8.43,79.43,79.43,0,0,0,6.44-9.29l0-.07.06,0a11.16,11.16,0,0,1,3.9-.95,6.14,6.14,0,0,1,3.68,1l.18.12-.11.19c-2.12,3.38-4.18,6.61-6.31,9.56a74.13,74.13,0,0,1-6.56,8,44.07,44.07,0,0,1-13.44,9.89A32.36,32.36,0,0,1,308,118.38,25.28,25.28,0,0,1,304.18,118.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.69,198.71s-.46.18-1.38.45a29.58,29.58,0,0,1-4.06.9,31.24,31.24,0,0,1-6.58.26,11.26,11.26,0,0,1-4-.83,4,4,0,0,1-1.72-1.46,2.93,2.93,0,0,1-.24-2.34,2.11,2.11,0,0,1,1.77-1.64,1.81,1.81,0,0,1,1.24.4,2.57,2.57,0,0,1,.76,1.1,2.87,2.87,0,0,1-.37,2.64,5.36,5.36,0,0,1-2.23,1.72,15.66,15.66,0,0,1-11.9,0,4,4,0,0,1-2.28-2.28,2.35,2.35,0,0,1,1.45-2.81,1.5,1.5,0,0,1,1.58.6,2.27,2.27,0,0,1,.35,1.7,3.45,3.45,0,0,1-2.38,2.43,31.74,31.74,0,0,1-6.93,1.57,8.59,8.59,0,0,1-3.63-.24,4,4,0,0,1-2.63-2.51,2.86,2.86,0,0,1-.07-1.76,2.07,2.07,0,0,1,1.17-1.3,2.71,2.71,0,0,1,1.73-.17,1.7,1.7,0,0,1,1.26,1.17v.05l0,0A14.31,14.31,0,0,1,201,201.47a8.84,8.84,0,0,1-3.2-.94,4.47,4.47,0,0,1-2.19-2.38,2.87,2.87,0,0,1,.83-3,2.75,2.75,0,0,1,1.37-.76,1.77,1.77,0,0,1,1.5.38l0,0v0a4.2,4.2,0,0,1-.92,4,5.47,5.47,0,0,1-3.42,1.95,8.32,8.32,0,0,1-3.76-.36,15.46,15.46,0,0,1-3.23-1.52,5.9,5.9,0,0,1-2.32-2.41,2.3,2.3,0,0,1-.14-1.59,1.84,1.84,0,0,1,1-1.18,2.9,2.9,0,0,1,2.79.33,2.55,2.55,0,0,1,1.06,2.33,4.6,4.6,0,0,1-2.45,3.53,8.12,8.12,0,0,1-3.17.83c-.89.06-1.57,0-2,0s-.7,0-.7,0h.7c.46,0,1.14,0,2-.06a7.9,7.9,0,0,0,3.13-.84,4.49,4.49,0,0,0,2.38-3.47,2.43,2.43,0,0,0-1-2.22,2.78,2.78,0,0,0-2.67-.31,1.74,1.74,0,0,0-.91,1.1,2.18,2.18,0,0,0,.14,1.5,5.77,5.77,0,0,0,2.27,2.33A10.62,10.62,0,0,0,195,200.6a5.35,5.35,0,0,0,3.31-1.91,4,4,0,0,0,.88-3.78l0,0a1.55,1.55,0,0,0-1.34-.34,2.55,2.55,0,0,0-1.28.71,2.66,2.66,0,0,0-.77,2.76,4.21,4.21,0,0,0,2.09,2.27,8.41,8.41,0,0,0,3.13.92,14.13,14.13,0,0,0,12.36-5l0,.09a1.49,1.49,0,0,0-1.11-1,2.42,2.42,0,0,0-1.59.16,1.86,1.86,0,0,0-1.06,1.17,2.78,2.78,0,0,0,.06,1.64,3.88,3.88,0,0,0,2.5,2.37,8.51,8.51,0,0,0,3.55.24,31.87,31.87,0,0,0,6.88-1.56,3.29,3.29,0,0,0,2.26-2.27,2.14,2.14,0,0,0-.32-1.55,1.3,1.3,0,0,0-1.37-.53,2.17,2.17,0,0,0-1.32,2.56,3.82,3.82,0,0,0,2.18,2.17,15.51,15.51,0,0,0,11.75,0,5.09,5.09,0,0,0,2.16-1.65,2.65,2.65,0,0,0,.35-2.49,1.88,1.88,0,0,0-1.83-1.4,2,2,0,0,0-1.64,1.52A2.78,2.78,0,0,0,235,198a3.9,3.9,0,0,0,1.66,1.41,11.1,11.1,0,0,0,4,.84,32,32,0,0,0,6.56-.23,31.13,31.13,0,0,0,4.06-.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.69,268.69a14,14,0,0,1-1.38.45,29.58,29.58,0,0,1-4.06.9,31.24,31.24,0,0,1-6.58.26,11,11,0,0,1-4-.83,4,4,0,0,1-1.72-1.46,2.92,2.92,0,0,1-.24-2.34,2.09,2.09,0,0,1,1.77-1.63,1.76,1.76,0,0,1,1.24.39,2.6,2.6,0,0,1,.76,1.11,2.88,2.88,0,0,1-.37,2.64,5.33,5.33,0,0,1-2.23,1.71,15.66,15.66,0,0,1-11.9,0,3.94,3.94,0,0,1-2.28-2.28,2.35,2.35,0,0,1,1.45-2.81,1.5,1.5,0,0,1,1.58.6,2.3,2.3,0,0,1,.35,1.71,3.45,3.45,0,0,1-2.38,2.42,32.34,32.34,0,0,1-6.93,1.58,8.76,8.76,0,0,1-3.63-.25,4,4,0,0,1-2.63-2.5,2.9,2.9,0,0,1-.07-1.77,2.07,2.07,0,0,1,1.17-1.3,2.65,2.65,0,0,1,1.73-.16,1.69,1.69,0,0,1,1.26,1.16v0l0,0A14.31,14.31,0,0,1,201,271.45a8.65,8.65,0,0,1-3.2-.94,4.47,4.47,0,0,1-2.19-2.38,2.87,2.87,0,0,1,.83-3,2.75,2.75,0,0,1,1.37-.76,1.77,1.77,0,0,1,1.5.38l0,0v0a4.2,4.2,0,0,1-.92,4,5.42,5.42,0,0,1-3.42,1.95,8.19,8.19,0,0,1-3.76-.36,15,15,0,0,1-3.23-1.52,5.94,5.94,0,0,1-2.32-2.4,2.34,2.34,0,0,1-.14-1.6,1.87,1.87,0,0,1,1-1.18,2.88,2.88,0,0,1,2.79.34,2.54,2.54,0,0,1,1.06,2.32,4.6,4.6,0,0,1-2.45,3.54,8.08,8.08,0,0,1-3.17.82c-.89.06-1.57,0-2,0s-.7,0-.7,0h.7a19.93,19.93,0,0,0,2-.06,7.9,7.9,0,0,0,3.13-.84,4.49,4.49,0,0,0,2.38-3.46,2.46,2.46,0,0,0-1-2.23,2.78,2.78,0,0,0-2.67-.31,1.74,1.74,0,0,0-.91,1.1,2.18,2.18,0,0,0,.14,1.5,5.79,5.79,0,0,0,2.27,2.34,10.62,10.62,0,0,0,6.89,1.84,5.33,5.33,0,0,0,3.31-1.9,4.07,4.07,0,0,0,.88-3.79l0,0a1.55,1.55,0,0,0-1.34-.34,2.63,2.63,0,0,0-1.28.71,2.67,2.67,0,0,0-.77,2.77,4.21,4.21,0,0,0,2.09,2.27,8.58,8.58,0,0,0,3.13.91,14.1,14.1,0,0,0,12.36-5l0,.09a1.47,1.47,0,0,0-1.11-1,2.42,2.42,0,0,0-1.59.15,1.89,1.89,0,0,0-1.06,1.17,2.78,2.78,0,0,0,.06,1.64,3.9,3.9,0,0,0,2.5,2.38,8.67,8.67,0,0,0,3.55.23,31.87,31.87,0,0,0,6.88-1.56,3.29,3.29,0,0,0,2.26-2.27,2.15,2.15,0,0,0-.32-1.55,1.3,1.3,0,0,0-1.37-.53,2.17,2.17,0,0,0-1.32,2.56,3.82,3.82,0,0,0,2.18,2.17,15.46,15.46,0,0,0,11.75,0,5.09,5.09,0,0,0,2.16-1.65,2.65,2.65,0,0,0,.35-2.49,1.88,1.88,0,0,0-1.83-1.4,2,2,0,0,0-1.64,1.53,2.76,2.76,0,0,0,.22,2.22,3.83,3.83,0,0,0,1.66,1.41,11.1,11.1,0,0,0,4,.84,30.89,30.89,0,0,0,10.62-1.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,208.29s-.78.12-2.22.31l-6.17.8-9.42,1.2c-1.8.21-3.69.52-5.71.68a3.49,3.49,0,0,1-2.9-1,2.44,2.44,0,0,1-.48-1.55,1.48,1.48,0,0,1,.89-1.37h.06a1.33,1.33,0,0,1,.93,1.23,1.92,1.92,0,0,1-.48,1.51,5.21,5.21,0,0,1-3,1.2,15.5,15.5,0,0,1-3.29.36,5.62,5.62,0,0,1-3.22-1,3.29,3.29,0,0,1-1.43-2.9,2.63,2.63,0,0,1,1.94-2.41h0l0,0a2.6,2.6,0,0,1,1,1.67,3.79,3.79,0,0,1-.17,1.92,4.24,4.24,0,0,1-1,1.61,5.28,5.28,0,0,1-1.55,1,10.42,10.42,0,0,1-3.48.73,22.56,22.56,0,0,1-3.39,0,5.45,5.45,0,0,1-3-1.12,3,3,0,0,1-1-2.78,2.57,2.57,0,0,1,.57-1.33,1.71,1.71,0,0,1,1.25-.61,2.19,2.19,0,0,1,2,1.47,2.46,2.46,0,0,1-.18,2.29,3.62,3.62,0,0,1-1.57,1.35,5.39,5.39,0,0,1-3.26.33,13.73,13.73,0,0,1-2-.53l-.67-.24.69.2a14.65,14.65,0,0,0,2,.5,5.37,5.37,0,0,0,3.2-.36,3.5,3.5,0,0,0,1.51-1.31,2.35,2.35,0,0,0,.17-2.18,2.05,2.05,0,0,0-1.88-1.37,1.59,1.59,0,0,0-1.15.56,2.41,2.41,0,0,0-.52,1.25,2.85,2.85,0,0,0,.95,2.63,5.31,5.31,0,0,0,2.91,1.07,23.58,23.58,0,0,0,3.36,0,10.15,10.15,0,0,0,3.41-.72,5.07,5.07,0,0,0,1.49-1,4.11,4.11,0,0,0,.93-1.54,2.91,2.91,0,0,0-.77-3.35h.08a2.43,2.43,0,0,0-1.77,2.23,3,3,0,0,0,1.35,2.71,5.38,5.38,0,0,0,3.1,1,14.62,14.62,0,0,0,3.24-.35,5,5,0,0,0,2.86-1.14,1.7,1.7,0,0,0,.43-1.35,1.14,1.14,0,0,0-.78-1.06h.06a1.3,1.3,0,0,0-.77,1.2,2.21,2.21,0,0,0,.45,1.42,3.31,3.31,0,0,0,2.73.92c2-.14,3.9-.45,5.7-.65l9.42-1.16,6.19-.75C232.23,208.36,233,208.29,233,208.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.86,244.59s-.42.09-1.22.22l-3.48.59-5.52.91-3.45.56c-1.22.18-2.5.46-3.88.54a5.05,5.05,0,0,1-4-1.28,3.15,3.15,0,0,1-1-2.09,2.06,2.06,0,0,1,.29-1.17,2.19,2.19,0,0,1,.93-.8,2,2,0,0,1,2.38.3,1.63,1.63,0,0,1,.36,1.24,2.2,2.2,0,0,1-.58,1.18,5.17,5.17,0,0,1-2.25,1.37,18,18,0,0,1-2.65.52,19.77,19.77,0,0,1-5.58-.15,20.29,20.29,0,0,1-2.81-.71,10.67,10.67,0,0,1-2.67-1.26,4.18,4.18,0,0,1-1.78-2.41,2.8,2.8,0,0,1,1.17-2.75,1.72,1.72,0,0,1,2.69.77,2.8,2.8,0,0,1-.67,3,7.48,7.48,0,0,1-2.69,1.63,22.42,22.42,0,0,1-2.94,1,21.94,21.94,0,0,1-6,.64,11.14,11.14,0,0,1-2.93-.41,3.44,3.44,0,0,1-2.22-1.82,2.39,2.39,0,0,1,.46-2.71,1.58,1.58,0,0,1,1.38-.36,2.3,2.3,0,0,1,1.19.75,2.68,2.68,0,0,1,.57,2.6,4,4,0,0,1-1.73,2,11.9,11.9,0,0,1-4.81,1.36,17.29,17.29,0,0,1-4.68-.18,8.06,8.06,0,0,1-4-1.66,3.71,3.71,0,0,1-1.11-1.69,3,3,0,0,1,.16-1.91A2.89,2.89,0,0,1,186,241a1.79,1.79,0,0,1,1.68-.07,1.93,1.93,0,0,1,1,1.21,3,3,0,0,1,.07,1.47,3,3,0,0,1-1.41,2.08,6.89,6.89,0,0,1-3.38.92c-.81.05-1.24,0-1.24,0l1.23-.08a7.09,7.09,0,0,0,3.35-.94,3,3,0,0,0,1.35-2,2.76,2.76,0,0,0-.07-1.42,1.8,1.8,0,0,0-1-1.13,1.66,1.66,0,0,0-1.57.07,2.71,2.71,0,0,0-1.11,1.31,2.77,2.77,0,0,0-.16,1.82,3.62,3.62,0,0,0,1.08,1.62,7.91,7.91,0,0,0,3.89,1.61,17.33,17.33,0,0,0,4.63.17,11.75,11.75,0,0,0,4.74-1.35,3.88,3.88,0,0,0,1.65-1.88,2.5,2.5,0,0,0-.55-2.41,2,2,0,0,0-1.08-.69,1.38,1.38,0,0,0-1.21.32,2.21,2.21,0,0,0-.41,2.49,3.25,3.25,0,0,0,2.11,1.7,10.52,10.52,0,0,0,2.87.39,21.5,21.5,0,0,0,5.94-.63,22,22,0,0,0,2.91-.95A7.44,7.44,0,0,0,214,243a2.63,2.63,0,0,0,.63-2.77,1.58,1.58,0,0,0-1-1,1.62,1.62,0,0,0-1.37.28,2.61,2.61,0,0,0-1.08,2.54,4,4,0,0,0,1.7,2.28,10.66,10.66,0,0,0,2.62,1.24,18.13,18.13,0,0,0,2.77.7,19,19,0,0,0,5.52.16,18.4,18.4,0,0,0,2.62-.51,4.87,4.87,0,0,0,2.17-1.31,2,2,0,0,0,.54-1.08,1.44,1.44,0,0,0-.32-1.1,1.85,1.85,0,0,0-2.17-.27,1.88,1.88,0,0,0-1.13,1.82,3,3,0,0,0,.92,2,4.92,4.92,0,0,0,3.91,1.25c1.36-.08,2.65-.35,3.87-.53l3.45-.55,5.52-.87,3.5-.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.57,150l-.29,0a7.46,7.46,0,0,0-.83.14,12.62,12.62,0,0,0-3,1.2,18.28,18.28,0,0,1-4.74,2,5.07,5.07,0,0,1-3.18-.33,3.34,3.34,0,0,1-2.07-2.81,2.71,2.71,0,0,1,.76-1.8,2.45,2.45,0,0,1,1.86-.82,1.89,1.89,0,0,1,1.62,1.3,3,3,0,0,1-.13,2.2A3.58,3.58,0,0,1,437,152.8a8.08,8.08,0,0,1-2.22.81,14.06,14.06,0,0,1-4.87.44,4.47,4.47,0,0,1-3.84-3.12,2.47,2.47,0,0,1,.71-2.52,2.75,2.75,0,0,1,2.63-.54,1.77,1.77,0,0,1,1,1,2.23,2.23,0,0,1,0,1.42,3.42,3.42,0,0,1-1.88,2.08,13.41,13.41,0,0,1-2.71.88,24.41,24.41,0,0,1-2.84.49,12.88,12.88,0,0,1-5.7-.33,4,4,0,0,1-2.17-1.79,3.43,3.43,0,0,1-.15-2.75,2.15,2.15,0,0,1,.89-1.08,2.09,2.09,0,0,1,1.36-.26,2.89,2.89,0,0,1,2.12,1.58,3.14,3.14,0,0,1,0,2.6,4.62,4.62,0,0,1-1.62,2,12.11,12.11,0,0,1-9.25.89,4.91,4.91,0,0,1-2.91-3.07,3.25,3.25,0,0,1,1.31-3.57,2.41,2.41,0,0,1,3.32.43,3.37,3.37,0,0,1,.62,3.09,4.36,4.36,0,0,1-1.7,2.21,6.12,6.12,0,0,1-2.15,1,12.63,12.63,0,0,1-3.24.28c-.74,0-1.13,0-1.13,0h1.13a12.86,12.86,0,0,0,3.22-.32,6.21,6.21,0,0,0,2.12-1,4.32,4.32,0,0,0,1.64-2.16,3.25,3.25,0,0,0-.61-3,2.31,2.31,0,0,0-1.44-.83,2.38,2.38,0,0,0-1.7.43,3.09,3.09,0,0,0-1.23,3.41,4.75,4.75,0,0,0,2.82,2.95,11.9,11.9,0,0,0,9.07-.89,4.44,4.44,0,0,0,1.55-1.9,2.94,2.94,0,0,0,0-2.43,2.69,2.69,0,0,0-2-1.47,1.87,1.87,0,0,0-2,1.21,3.18,3.18,0,0,0,.15,2.58,3.71,3.71,0,0,0,2.05,1.69,12.69,12.69,0,0,0,5.6.33,25.94,25.94,0,0,0,2.82-.49,13.24,13.24,0,0,0,2.67-.87,3.19,3.19,0,0,0,1.77-1.94,2,2,0,0,0,0-1.29,1.54,1.54,0,0,0-.89-.88,2.56,2.56,0,0,0-2.42.5,2.26,2.26,0,0,0-.64,2.32,4.28,4.28,0,0,0,3.67,3,14,14,0,0,0,4.8-.43,7.9,7.9,0,0,0,2.17-.78,3.45,3.45,0,0,0,1.51-1.56,2.86,2.86,0,0,0,.13-2.07,1.69,1.69,0,0,0-1.47-1.19,2.55,2.55,0,0,0-2.47,2.45,3.22,3.22,0,0,0,2,2.69,5,5,0,0,0,3.1.34,18.62,18.62,0,0,0,4.72-2,12.55,12.55,0,0,1,3-1.17A5,5,0,0,1,448.57,150Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.64,291.75a5.78,5.78,0,0,1-.79.56,9.33,9.33,0,0,1-2.56,1.11,9.6,9.6,0,0,1-4.4.14,6.22,6.22,0,0,1-2.54-1.07,2.92,2.92,0,0,1-1.31-2.71,2.62,2.62,0,0,1,.84-1.46,1.75,1.75,0,0,1,1.67-.45,1.78,1.78,0,0,1,1.17,1.38,2.58,2.58,0,0,1-.31,1.87,6.68,6.68,0,0,1-3.2,2.29,20.61,20.61,0,0,1-4,1.26,7.92,7.92,0,0,1-4.39-.13,4.18,4.18,0,0,1-1.84-1.38,3,3,0,0,1-.62-2.25,2.74,2.74,0,0,1,1.39-1.92,2,2,0,0,1,2.33.33,3,3,0,0,1-.56,4.45,7.42,7.42,0,0,1-4.75,1.11,13.75,13.75,0,0,1-4.65-1,10.44,10.44,0,0,1-2.06-1.1,2.73,2.73,0,0,1-1.26-1.9A1.63,1.63,0,0,1,433,289a1.68,1.68,0,0,1,1.75,1.22,2.44,2.44,0,0,1-.39,2.1,6.08,6.08,0,0,1-1.48,1.47,8.32,8.32,0,0,1-3.66,1.49,8,8,0,0,1-3.68-.29,3.32,3.32,0,0,1-2.41-2.28,2.12,2.12,0,0,1,.28-1.58,1.5,1.5,0,0,1,1.34-.68,2.22,2.22,0,0,1,2,1.79,2.68,2.68,0,0,1-.83,2.21,3.94,3.94,0,0,1-1.75,1,8,8,0,0,1-2.78.16c-.64-.06-1-.11-1-.11l1,.07a8.1,8.1,0,0,0,2.76-.2,3.81,3.81,0,0,0,1.7-1,2.59,2.59,0,0,0,.79-2.13,2.1,2.1,0,0,0-1.85-1.67,1.39,1.39,0,0,0-1.22.63,2,2,0,0,0-.25,1.47,3.18,3.18,0,0,0,2.32,2.16,7.92,7.92,0,0,0,3.61.27,8.07,8.07,0,0,0,3.57-1.47,5.55,5.55,0,0,0,1.43-1.43,2.23,2.23,0,0,0,.37-1.93,1.5,1.5,0,0,0-1.53-1.09,1.43,1.43,0,0,0-1,1.61,2.55,2.55,0,0,0,1.17,1.76,10.62,10.62,0,0,0,2,1.07,13.63,13.63,0,0,0,4.58,1,7.21,7.21,0,0,0,4.61-1.07,2.83,2.83,0,0,0,.54-4.15,1.75,1.75,0,0,0-2.09-.29,2.55,2.55,0,0,0-1.28,1.77,2.75,2.75,0,0,0,.58,2.1,4,4,0,0,0,1.75,1.31,7.7,7.7,0,0,0,4.28.13,19.54,19.54,0,0,0,4-1.24,6.43,6.43,0,0,0,3.13-2.21,2.46,2.46,0,0,0,.3-1.75,1.5,1.5,0,0,0-2.58-.85,2.43,2.43,0,0,0-.79,1.37,2.77,2.77,0,0,0,1.24,2.58,6.13,6.13,0,0,0,2.49,1.07,9.44,9.44,0,0,0,4.35-.11,10,10,0,0,0,2.56-1.06c.27-.17.48-.3.61-.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.72,308.29l-.18.33a8.35,8.35,0,0,1-.59.93,9.23,9.23,0,0,1-9.85,3.23,5.09,5.09,0,0,1-3.19-2.64,2.7,2.7,0,0,1,2-3.7,1.87,1.87,0,0,1,2,1.4,2.9,2.9,0,0,1-.5,2.58,6.2,6.2,0,0,1-2.2,1.72,12.46,12.46,0,0,1-2.73,1,12.1,12.1,0,0,1-6-.23,7.12,7.12,0,0,1-2.81-1.51,3.73,3.73,0,0,1-.94-1.37,2.52,2.52,0,0,1,0-1.67,2.65,2.65,0,0,1,1-1.37,1.7,1.7,0,0,1,1.7-.13,2,2,0,0,1,1,1.4,2.91,2.91,0,0,1-.15,1.75,4.3,4.3,0,0,1-2.75,2.15,31.27,31.27,0,0,1-3.5.83,9.07,9.07,0,0,1-3.67,0,4.8,4.8,0,0,1-3-2.15,3.15,3.15,0,0,1-.47-1.85,2.32,2.32,0,0,1,.88-1.7,3,3,0,0,1,1.81-.71,2.35,2.35,0,0,1,1,.19,2,2,0,0,1,.75.68l0,0,0,.05a10,10,0,0,1-2.93,4.21,9,9,0,0,1-7.57,2.17,4.48,4.48,0,0,1-3.08-2.4,3.46,3.46,0,0,1-.35-1.95,2.84,2.84,0,0,1,.9-1.74A3,3,0,0,1,526,307a2.26,2.26,0,0,1,1.81.66,3.27,3.27,0,0,1,.52,3.6,5.3,5.3,0,0,1-2.71,2.45,11.3,11.3,0,0,1-3.48.89,12.55,12.55,0,0,1-6.75-1.2,8.42,8.42,0,0,1-2.69-1.94,3,3,0,0,1-.78-3,2.52,2.52,0,0,1,1-1.19,1.86,1.86,0,0,1,1.54-.23,1.58,1.58,0,0,1,1,1.17,2.38,2.38,0,0,1-.2,1.49,3.92,3.92,0,0,1-2.24,1.77,18.77,18.77,0,0,1-2.63.79,7.45,7.45,0,0,1-2.61.16,3.74,3.74,0,0,1-2.24-1.06,3.45,3.45,0,0,1-.8-2.2,2.36,2.36,0,0,1,.88-2,1.92,1.92,0,0,1,2-.07,2.73,2.73,0,0,1,1.23,1.44,3.06,3.06,0,0,1-.75,3.11,5,5,0,0,1-2.21,1.43,10.52,10.52,0,0,1-1.9.43c-1,.13-1.6.14-1.6.14l1.59-.19a8.86,8.86,0,0,0,1.88-.44,5,5,0,0,0,2.18-1.42,3,3,0,0,0,.72-3,2.62,2.62,0,0,0-1.19-1.38,1.8,1.8,0,0,0-1.88.06,2.26,2.26,0,0,0-.82,1.89,3.29,3.29,0,0,0,.77,2.11,3.59,3.59,0,0,0,2.16,1,7.19,7.19,0,0,0,2.56-.16,18.46,18.46,0,0,0,2.6-.8,3.75,3.75,0,0,0,2.15-1.69,2.19,2.19,0,0,0,.19-1.38,1.41,1.41,0,0,0-.87-1.05,2.09,2.09,0,0,0-2.36,1.33,2.87,2.87,0,0,0,.76,2.85,8.12,8.12,0,0,0,2.63,1.89,12.38,12.38,0,0,0,6.65,1.17,11.13,11.13,0,0,0,3.42-.88,5.12,5.12,0,0,0,2.61-2.35,3.1,3.1,0,0,0-.48-3.38,2.05,2.05,0,0,0-1.65-.6,2.82,2.82,0,0,0-1.64.77,2.67,2.67,0,0,0-.84,1.62,3.33,3.33,0,0,0,.33,1.83,4.29,4.29,0,0,0,2.95,2.28,8.78,8.78,0,0,0,7.38-2.12,9.72,9.72,0,0,0,2.87-4.12v.09a1.68,1.68,0,0,0-1.54-.77,2.9,2.9,0,0,0-1.69.65,2.49,2.49,0,0,0-.36,3.3,4.57,4.57,0,0,0,2.88,2.05,8.86,8.86,0,0,0,3.59,0,28.43,28.43,0,0,0,3.48-.82,4.13,4.13,0,0,0,2.63-2,2.31,2.31,0,0,0-.77-2.91,1.51,1.51,0,0,0-1.51.12,2.48,2.48,0,0,0-.93,1.27,2.7,2.7,0,0,0,.9,2.84,6.92,6.92,0,0,0,2.74,1.48,11.75,11.75,0,0,0,6,.23,11.44,11.44,0,0,0,2.69-.95,5.74,5.74,0,0,0,2.15-1.66,2.7,2.7,0,0,0,.48-2.45,1.71,1.71,0,0,0-1.82-1.3A2.59,2.59,0,0,0,554,310.1a5,5,0,0,0,3.11,2.57,8.88,8.88,0,0,0,6.51-.53,9.14,9.14,0,0,0,3.28-2.62,8,8,0,0,0,.6-.91C567.65,308.39,567.72,308.29,567.72,308.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.14,323.79a26.47,26.47,0,0,1-2.13-4.26,26.47,26.47,0,0,1,2.13,4.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.68,323a23.28,23.28,0,0,1-1.16-2.76,20.65,20.65,0,0,1-1-2.84,23.28,23.28,0,0,1,1.16,2.76A22.43,22.43,0,0,1,560.68,323Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.19,320.34a6.25,6.25,0,0,1-.84,2.32,8,8,0,0,1-10.45,3.27,6.43,6.43,0,0,1-2-1.42A11.47,11.47,0,0,0,553,325.8a8,8,0,0,0,10.25-3.21A10.48,10.48,0,0,0,564.19,320.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.79,274.74l-1.3-1.68h-.08l-1.26.07.09,1.75-1.45.08-.35-6.29,2.73-.15c1.68-.09,2.78.73,2.85,2.14a2,2,0,0,1-1.18,2l1.52,2Zm-1.64-5-1.19.07.12,2.19,1.19-.06c.89-.05,1.32-.49,1.28-1.17S398,269.67,397.15,269.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.17,273.58v1.17l-4.88-.07.09-6.3,4.77.07,0,1.17-3.31-.05,0,1.37,2.93,0,0,1.13-2.92,0,0,1.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.9,275.29l.33-3.76-2.12,2.93-.66-.06-1.56-3.18-.33,3.68-1.37-.13.57-6.27,1.2.11,2,4.11,2.66-3.69,1.19.11-.55,6.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.64,275.26l-.19,1.16-4.81-.79,1-6.21,4.7.76-.19,1.16-3.26-.54-.22,1.35,2.88.47-.18,1.12-2.89-.47-.23,1.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.1,277.88l.81-3.69-2.48,2.64-.65-.14-1.14-3.37-.8,3.62-1.34-.3,1.37-6.15,1.18.26,1.45,4.33,3.12-3.32,1.17.26-1.35,6.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.32,277.3c-.11,1.08-1,1.62-2.68,1.47l-3.24-.31.6-6.27,3.06.29c1.57.15,2.31.88,2.22,1.86a1.53,1.53,0,0,1-1,1.3A1.57,1.57,0,0,1,436.32,277.3Zm-1.45-.3c.05-.53-.33-.81-1.08-.89L432.1,276,432,277.5l1.69.16C434.39,277.73,434.82,277.54,434.87,277Zm-2.53-3.58-.14,1.48,1.44.13c.71.07,1.12-.14,1.16-.64s-.31-.77-1-.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.6,277.74l0,1.17-4.88.11-.14-6.3,4.76-.11,0,1.17-3.31.08,0,1.37,2.92-.07,0,1.14-2.93.06,0,1.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.27,278.17l-1.46-1.55h-.07l-1.26.19.26,1.73-1.44.22-.94-6.23,2.7-.4c1.66-.25,2.83.45,3,1.85a2,2,0,0,1-1,2.16l1.7,1.79Zm-2.11-4.85-1.18.18.33,2.17,1.17-.18c.88-.13,1.27-.61,1.17-1.28S447,273.19,446.16,273.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.55,386s-6.13-42.18-5.62-66.73,0-52.15,0-52.15h2.83s-1.92,48.72.17,78.1S91.46,386,91.46,386H86.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.83,219.67a7.46,7.46,0,0,0-2.58-3.77c-1.79-1.14-4.14-.66-6.14,0-8.55,3-16.12,18.95-19.57,27.33l11.34,38.21C108.35,262.49,111.9,237.58,104.83,219.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.59,217.45a2.09,2.09,0,0,1-.16.5c-.15.36-.33.82-.56,1.39-.5,1.2-1.19,2.95-2,5.12-1.67,4.34-3.79,10.41-5.7,17.24s-3.2,13.13-4,17.71c-.4,2.29-.71,4.15-.9,5.44-.1.6-.18,1.09-.24,1.48a1.8,1.8,0,0,1-.12.51,1.86,1.86,0,0,1,0-.52c0-.4.09-.89.16-1.5.14-1.29.39-3.16.75-5.46a165.47,165.47,0,0,1,3.88-17.79,162.06,162.06,0,0,1,5.85-17.23c.87-2.16,1.62-3.89,2.16-5.07.26-.56.47-1,.64-1.36A2.31,2.31,0,0,1,101.59,217.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.84,290.65c-10.63-5.88-16.9-16.93-17.48-29.06-.41-8.48,2.2-16.8,5.15-24.76a3.2,3.2,0,0,1,1.2-1.8c.89-.5,2-.05,2.9.45,7.72,4.4,12.4,12.79,14.89,21.32a42.93,42.93,0,0,1,1.75,17.53,29.16,29.16,0,0,1-8.41,16.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.84,290.65a1.93,1.93,0,0,1,0-.52c0-.38,0-.87,0-1.46,0-1.28,0-3.12-.16-5.39a146.71,146.71,0,0,0-2-17.65c-1.18-6.85-2.61-13-3.67-17.41-.52-2.16-.94-3.94-1.26-5.24-.13-.58-.24-1.06-.32-1.43a3.17,3.17,0,0,1-.09-.51,1.81,1.81,0,0,1,.18.48c.11.37.24.84.41,1.41.35,1.23.83,3,1.4,5.21,1.14,4.42,2.63,10.54,3.81,17.41a129.94,129.94,0,0,1,1.84,17.72c.06,2.28.06,4.12,0,5.4q0,.88-.06,1.47A2.1,2.1,0,0,1,82.84,290.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M82.84,290.65c-10.63-5.88-16.9-16.93-17.48-29.06-.41-8.48,2.2-16.8,5.15-24.76a3.2,3.2,0,0,1,1.2-1.8c.89-.5,2-.05,2.9.45,7.72,4.4,12.4,12.79,14.89,21.32a42.93,42.93,0,0,1,1.75,17.53,29.16,29.16,0,0,1-8.41,16.32"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.83,355.19c10.47,2.29,19.08,9.67,29.17,13.26,6.68,2.38,14.23,3.22,19.56,7.89-1.27-3.23-4.31-5.39-7.25-7.23a130.69,130.69,0,0,0-26.44-12.62c-4.75-1.64-9.9-3-14.74-1.66",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.13,354.83s.08,0,.26-.09.44-.14.8-.21a15.31,15.31,0,0,1,3.14-.34c2.77-.09,6.73.73,11.34,2.39a126.25,126.25,0,0,1,15.85,6.73c2.89,1.46,5.87,3.11,8.88,4.95a41.37,41.37,0,0,1,4.48,3,13.07,13.07,0,0,1,3.62,4.28c.11.23.21.46.31.68l.48,1.08-.9-.79A25.8,25.8,0,0,0,134,371.7c-3.31-1.05-6.58-1.82-9.62-2.88a60.1,60.1,0,0,1-8.3-3.71c-2.52-1.33-4.81-2.65-6.93-3.81a71.15,71.15,0,0,0-10.29-4.87c-1.27-.44-2.26-.76-2.95-.93l-.78-.22-.26-.09a.85.85,0,0,1,.28,0l.78.17c.7.14,1.71.43,3,.84a66.73,66.73,0,0,1,10.4,4.74c2.13,1.14,4.43,2.44,6.95,3.75a62.39,62.39,0,0,0,8.26,3.64c3,1,6.28,1.79,9.61,2.84a26.35,26.35,0,0,1,9.63,4.93l-.42.29c-.09-.2-.18-.43-.29-.64a12.29,12.29,0,0,0-3.48-4.1,40.31,40.31,0,0,0-4.41-3c-3-1.83-6-3.48-8.84-5a133.21,133.21,0,0,0-15.75-6.8c-4.59-1.7-8.48-2.56-11.22-2.54a17.71,17.71,0,0,0-3.12.24A10.81,10.81,0,0,1,95.13,354.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.71,364.51c-13.11-.21-26.9-11.37-39.94-12,13.64-4.41,33.19-.81,39.94,12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.83,333.08c6.65-2.4,14-2.52,20.94-1.43s13.74,3.33,20.45,5.56c-.67-4.55-4.35-8-7.81-11a54.3,54.3,0,0,0-8.21-6.31,18.22,18.22,0,0,0-9.85-2.78,15.59,15.59,0,0,0-10.87,5.48,18,18,0,0,0-4.65,10.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.83,333.08a.92.92,0,0,1,0-.27c0-.17,0-.43.08-.76a17.38,17.38,0,0,1,.63-2.89,19,19,0,0,1,6.11-8.87,14.92,14.92,0,0,1,15.35-2.2,30.28,30.28,0,0,1,8.12,5c1.28,1,2.54,2.14,3.82,3.26a43.78,43.78,0,0,1,3.74,3.61,14.07,14.07,0,0,1,3.8,7.22l.06.42-.4-.14a161.37,161.37,0,0,0-16.07-4.75,57.46,57.46,0,0,0-13.29-1.53A39.46,39.46,0,0,0,88,332.23c-1,.24-1.8.46-2.32.62L85,333l-.2.05s.06,0,.19-.09l.58-.23c.52-.19,1.29-.44,2.31-.71a37.45,37.45,0,0,1,8.86-1.22,56.58,56.58,0,0,1,13.4,1.42A159.13,159.13,0,0,1,126.3,337l-.33.29a13.63,13.63,0,0,0-3.67-6.95,44.38,44.38,0,0,0-3.7-3.57c-1.28-1.12-2.53-2.22-3.8-3.26a30.24,30.24,0,0,0-8-4.93,14.58,14.58,0,0,0-15,2,19.28,19.28,0,0,0-4.1,4.51,17.34,17.34,0,0,0-2,4.14,18.59,18.59,0,0,0-.71,2.84C84.9,332.73,84.85,333.08,84.83,333.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.93,318.61c-8.24-7-20.74-6.35-31.58-6.11a257,257,0,0,1,49,30.52C75.77,335.36,68.35,327.5,57.93,318.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.93,318.61c-8.24-7-20.74-6.35-31.58-6.11a257,257,0,0,1,49,30.52C75.77,335.36,68.35,327.5,57.93,318.61Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M88.54,308.89a90.65,90.65,0,0,1,12.68-7.37c4.34-2,8.39-5.12,12.58-7.39,5.44-2.94,10.15-7,15.14-10.68s10.47-6.95,16.58-7.92a32.71,32.71,0,0,0-15.09.88,97.68,97.68,0,0,0-14.2,5.52c-6.43,2.9-13,5.87-18.24,10.58s-10,9.34-9.45,16.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.54,308.89a1.22,1.22,0,0,1,0-.35c0-.24,0-.59,0-1.05a13,13,0,0,1,.66-4A17.12,17.12,0,0,1,92.27,298a53.93,53.93,0,0,1,6-6,46.67,46.67,0,0,1,8.44-5.75c3.23-1.77,6.8-3.38,10.56-5.08a97.85,97.85,0,0,1,12-4.75,35.59,35.59,0,0,1,13.8-1.57c.86.08,1.71.23,2.49.38l1.46.28-1.47.23a33.31,33.31,0,0,0-12.28,5c-3.66,2.3-6.92,4.92-10.09,7.32a71.77,71.77,0,0,1-9.4,6.27c-3.08,1.69-5.78,3.58-8.37,5.1-1.29.76-2.55,1.45-3.78,2s-2.37,1.1-3.42,1.65c-2.1,1.1-3.86,2.14-5.28,3l-3.26,2-.85.53-.29.17s.08-.08.26-.21l.82-.57c.73-.5,1.8-1.22,3.21-2.12s3.16-2,5.26-3.09,4.62-2.14,7.14-3.73,5.25-3.44,8.35-5.16a71.92,71.92,0,0,0,9.32-6.28c3.16-2.4,6.42-5,10.11-7.37a33.51,33.51,0,0,1,12.47-5.08v.51c-.77-.15-1.6-.29-2.45-.37a35.29,35.29,0,0,0-13.6,1.54,97,97,0,0,0-12,4.7c-3.75,1.68-7.33,3.27-10.54,5a46.22,46.22,0,0,0-8.4,5.65,55.08,55.08,0,0,0-6,5.86,17.47,17.47,0,0,0-3.19,5.4A14.91,14.91,0,0,0,88.54,308.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.76,364.51a2.14,2.14,0,0,1-.41-.18l-1.14-.59c-1-.53-2.41-1.31-4.19-2.2-.88-.47-1.86-1-2.93-1.46s-2.19-1-3.4-1.56a50.12,50.12,0,0,0-8.07-2.81,17.29,17.29,0,0,0-8.4-.21,23.69,23.69,0,0,0-3.56,1.07A17.6,17.6,0,0,0,88.78,358a18.6,18.6,0,0,0-3.61,3c-.76.81-1.13,1.31-1.16,1.28a1.93,1.93,0,0,1,.23-.38,11.66,11.66,0,0,1,.8-1,17.1,17.1,0,0,1,3.56-3.14,18.85,18.85,0,0,1,2.91-1.55,22.8,22.8,0,0,1,3.61-1.13,17.39,17.39,0,0,1,8.61.18,47.82,47.82,0,0,1,8.14,2.87c1.21.54,2.35,1.07,3.39,1.61s2,1,2.91,1.5c1.77.94,3.16,1.76,4.13,2.34l1.1.67C123.64,364.4,123.77,364.49,123.76,364.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.93,358a3.11,3.11,0,0,1,.82.24,18.76,18.76,0,0,1,2.14.93,26.26,26.26,0,0,1,6.26,4.44,25.94,25.94,0,0,1,4.69,6.08,18.53,18.53,0,0,1,1,2.1,3,3,0,0,1,.27.81c-.07,0-.56-1.08-1.57-2.74A29.37,29.37,0,0,0,78.82,364a29.72,29.72,0,0,0-6.09-4.49C71,358.54,69.9,358.09,69.93,358Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.94,318a2.73,2.73,0,0,1,.56.17l1.57.56,2.48.91c1,.36,2,.89,3.21,1.41a76.07,76.07,0,0,1,17.06,10.87,84.52,84.52,0,0,1,8,7.83,88.61,88.61,0,0,1,5.65,7.16c1.49,2.12,2.63,3.88,3.4,5.1l.9,1.41a3.27,3.27,0,0,1,.29.5,2.56,2.56,0,0,1-.37-.45c-.23-.3-.56-.76-1-1.36-.82-1.19-2-2.92-3.52-5s-3.44-4.5-5.7-7.06a86.49,86.49,0,0,0-7.94-7.76A79.86,79.86,0,0,0,48.62,321.3c-1.18-.54-2.21-1.09-3.17-1.47l-2.44-1-1.54-.64A3.16,3.16,0,0,1,40.94,318Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.49,325.71a4.94,4.94,0,0,1-1-.13l-1.2-.23c-.47-.09-1-.09-1.61-.15a16.45,16.45,0,0,0-9,1.78,16.2,16.2,0,0,0-4.09,3,18.85,18.85,0,0,0-2.64,3.25,28.42,28.42,0,0,0-1.8,3.44,3.76,3.76,0,0,1,.27-1,14.88,14.88,0,0,1,1.25-2.59,17.36,17.36,0,0,1,2.61-3.39,15.92,15.92,0,0,1,13.44-4.84,15.38,15.38,0,0,1,1.62.23l1.2.3A4.82,4.82,0,0,1,104.49,325.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.65,284.86a2.56,2.56,0,0,1-.49.3l-1.46.8c-1.27.68-3.1,1.69-5.33,3s-4.81,3-7.59,4.94a64.31,64.31,0,0,0-8.47,7.1,21.73,21.73,0,0,0-3.47,4.49c-.86,1.65-1.68,3.24-2.43,4.77a85.16,85.16,0,0,0-3.64,8.29A50.69,50.69,0,0,0,83,324.38c-.34,1.4-.46,2.2-.5,2.19a2.31,2.31,0,0,1,0-.58c0-.38.13-.94.27-1.65a43,43,0,0,1,1.64-5.9A78.14,78.14,0,0,1,88,310.07q1.13-2.31,2.42-4.79a21.44,21.44,0,0,1,3.53-4.6,62,62,0,0,1,8.56-7.13c2.8-2,5.44-3.58,7.68-4.87s4.1-2.25,5.4-2.88l1.51-.72A2.3,2.3,0,0,1,117.65,284.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.91,324.53a5.6,5.6,0,0,1-.26-1.1c-.15-.81-.34-1.83-.57-3a84.93,84.93,0,0,0-2.48-9.83,85.19,85.19,0,0,0-3.74-9.43c-.51-1.12-.93-2.05-1.28-2.8a6.92,6.92,0,0,1-.42-1.06,5.56,5.56,0,0,1,.59,1c.35.64.83,1.57,1.41,2.74a69.66,69.66,0,0,1,3.89,9.42,69.58,69.58,0,0,1,2.36,9.92c.2,1.29.35,2.33.42,3.06A4.19,4.19,0,0,1,80.91,324.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,294.72a35.67,35.67,0,0,0-4.26-14.14A46.72,46.72,0,0,0,44.06,257l29.3,43.68,3.78,7.79C79.72,304.21,80.3,299.67,80,294.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.86,
    y: 380.79,
    width: 68.13,
    height: 12.08,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.95 390.47 64.75 427.94 109.99 427.94 116.91 390.47 58.95 390.47",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,392.88c0,.13-15.37.24-34.32.24s-34.33-.11-34.33-.24,15.37-.24,34.33-.24S122,392.75,122,392.88Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.1,201.64c2.77-1.9,3.31-6.09,1.67-9s-5-4.63-8.3-5a15.45,15.45,0,0,0-13.16,4.88c-1.76,1.94-3.16,4.45-5.61,5.4-2.15.84-4.59.24-6.87.62a10.39,10.39,0,0,0-7.09,5.5,22.34,22.34,0,0,0-2.27,8.93c-.24,2.84-.35,5.94-2.23,8.07s-4.84,2.6-7.17,4.12a10,10,0,0,0-2.48,13.74c1,1.34,2.38,2.55,2.55,4.2s-.78,2.9-1.19,4.36a6.75,6.75,0,0,0,6.06,8.17c2,0,4.06-.8,5.85,0s2.51,2.9,3.69,4.47a8.43,8.43,0,0,0,10.37,2.29c1.42-.76,2.75-2,4.36-1.93s2.93,1.38,4.52,1.63c2.08.33,4-1.27,5.16-3s2-3.8,3.48-5.25c2-1.91,4.88-2.46,7.45-3.45a21.36,21.36,0,0,0,11-30.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.41,239.77a5.78,5.78,0,0,0-2.35-1.43l.17,0a4,4,0,0,0-.5-.07,2.33,2.33,0,0,0-1.79.29h0a4.27,4.27,0,0,0-2.26,2.11,5.06,5.06,0,0,0,.78,5.16,3.85,3.85,0,0,0,7-1.57A4.78,4.78,0,0,0,593.41,239.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.85,269.51l1.07-55.41a4.69,4.69,0,0,0-4.24-4.73l-25-6.14c-8-.79-13.23,9.08-13.68,17.09-.5,8.91-.76,19.8.34,26.44,2.21,13.34,13.26,15,13.26,15s.56,13.64.65,18.5l-2.52,15.14Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.44,231.56a1.7,1.7,0,0,0,1.66,1.71,1.63,1.63,0,0,0,1.75-1.55,1.71,1.71,0,0,0-1.66-1.72A1.63,1.63,0,0,0,595.44,231.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.46,225.07c.21.22,1.51-.75,3.35-.76s3.2.91,3.4.68-.12-.5-.72-.93a4.72,4.72,0,0,0-2.72-.82,4.58,4.58,0,0,0-2.66.88C592.54,224.56,592.35,225,592.46,225.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612,231.29a1.72,1.72,0,0,0,1.67,1.72,1.63,1.63,0,0,0,1.75-1.55,1.71,1.71,0,0,0-1.66-1.72A1.64,1.64,0,0,0,612,231.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.58,225.29c.21.22,1.51-.75,3.35-.75s3.2.9,3.4.67-.12-.5-.72-.92a4.58,4.58,0,0,0-2.72-.82,4.44,4.44,0,0,0-2.66.88C610.66,224.79,610.47,225.19,610.58,225.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604,239a12.78,12.78,0,0,0-3-.52c-.48,0-.92-.13-1-.45a2.38,2.38,0,0,1,.3-1.4c.44-1.14.89-2.34,1.37-3.59,1.9-5.12,3.27-9.32,3.06-9.4s-1.91,4-3.81,9.13l-1.31,3.61a2.73,2.73,0,0,0-.23,1.85,1.19,1.19,0,0,0,.78.68,3.11,3.11,0,0,0,.8.11A11.39,11.39,0,0,0,604,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.66,260.83a32,32,0,0,0,17.05-4.9s-3.51,10.06-16.89,8.9Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.28,243.38a4.55,4.55,0,0,1,3.73-2,3,3,0,0,1,2.43,1.3,2.71,2.71,0,0,1-3,4.08,6.81,6.81,0,0,1-2.72-1.66,2.07,2.07,0,0,1-.59-.69.94.94,0,0,1,.06-.93",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.41,240.24c-.29,0-.29,2-2,3.42s-3.83,1.22-3.85,1.5c0,.13.48.39,1.38.41a5,5,0,0,0,3.21-1.15,4.36,4.36,0,0,0,1.55-2.86C609.78,240.72,609.55,240.23,609.41,240.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.71,217.71c.19.5,2,.25,4.19.49s3.92.83,4.2.38c.13-.22-.18-.69-.89-1.17a7.31,7.31,0,0,0-6.39-.66C610,217.07,609.63,217.47,609.71,217.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.07,218.72c.32.42,1.59,0,3.12-.06s2.82.27,3.11-.17c.13-.22-.07-.64-.64-1a4.52,4.52,0,0,0-5,.19C593.1,218.08,592.92,218.52,593.07,218.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581,216.93a9.11,9.11,0,0,1,3.34-5.17c.94-.66,2-1.08,2.91-1.83,1.87-1.63,2.22-4.35,3.34-6.57a10.09,10.09,0,0,1,7.49-5.36c2.64-.36,5.39.33,7.94-.41,1.89-.54,3.51-1.84,5.43-2.27,3.73-.85,7.32,1.73,10.14,4.32.11,2.68-2,4.56-4,6.36a9.33,9.33,0,0,1-7.48,2.26c-2.07-.31-4.35-1.26-6.09-.11s-1.81,4-3.42,5.54c-2.29,2.14-6.13.34-9.11,1.34-2.29.77-3.67,3-5.14,5s-3.73,3.78-6.08,3.17A27.69,27.69,0,0,1,581,216.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.79,204.57c1.66-.54,5.07-1.75,5.93-3.25,1.85-3.24,5.23-5.53,8.77-5.46a8.49,8.49,0,0,1,7.89,6.45,12.24,12.24,0,0,1,10.75,6.39,14.53,14.53,0,0,1,.72,1.55,9.3,9.3,0,0,1,.89,7.78c-.53,1.54-1.46,3.27-.63,4.67s2.87,1.4,4.45,1.89a6.18,6.18,0,0,1,4.14,6.76,7.34,7.34,0,0,0-.39,3.05,6.76,6.76,0,0,0,1.91,2.57,7.69,7.69,0,0,1-4.07,12.66c-1.19.26-2.49.26-3.5.93-1.17.77-1.64,2.22-2.44,3.37a6.62,6.62,0,0,1-7.1,2.5,6.1,6.1,0,0,1-1.47-.67,4.75,4.75,0,0,1-4.15,2l-.5-28.15a2.32,2.32,0,0,1-1.65,1.4c-4.48,1.18-5.47-8.1-4.55-10.66a26.24,26.24,0,0,1-4.7-4.6c-1.31-1.8-2.58-6.79-2.4-9.06C615.07,206.85,608.05,204.81,608.79,204.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.83,232c0-2.86,3.52-3.59,6-2.25,1.39.74,2.48,2.28,2.47,5.32-.05,8.11-8.18,6.39-8.19,6.16S628.78,235.31,628.83,232Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.65,238.12s.14.1.38.21a1.39,1.39,0,0,0,1.06,0c.85-.31,1.58-1.66,1.63-3.13a4.56,4.56,0,0,0-.38-2,1.66,1.66,0,0,0-1.06-1.09.71.71,0,0,0-.83.38c-.11.23-.06.39-.11.4s-.17-.13-.1-.47a.86.86,0,0,1,.32-.5,1.08,1.08,0,0,1,.78-.21,2,2,0,0,1,1.47,1.27,4.85,4.85,0,0,1,.48,2.26c-.07,1.64-.91,3.16-2.09,3.49a1.51,1.51,0,0,1-1.29-.22C631.66,238.32,631.62,238.14,631.65,238.12Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.86,202a4.86,4.86,0,0,1,1.66,1.3c.84,1.07,1.22,3.17.79,5.57l0,.21.2,0a7.83,7.83,0,0,1,5.37,4.41,6,6,0,0,1,.49,2,11.48,11.48,0,0,1-.18,2.15,17.07,17.07,0,0,0-.22,2.32,3.76,3.76,0,0,0,.72,2.36,9.81,9.81,0,0,0,4.12,2.88,13.59,13.59,0,0,1,3.85,2.33,10.1,10.1,0,0,1,3.26,6.68,10.53,10.53,0,0,1-.89,5c-.5,1.12-.93,1.66-.88,1.7a2.44,2.44,0,0,0,.33-.38,9.13,9.13,0,0,0,.75-1.23,10.27,10.27,0,0,0,1.09-5.16,10.38,10.38,0,0,0-3.3-7,14.16,14.16,0,0,0-4-2.45,9.41,9.41,0,0,1-3.89-2.69c-.94-1.2-.59-2.82-.41-4.28a12.05,12.05,0,0,0,.17-2.25,6.61,6.61,0,0,0-.55-2.15,8.18,8.18,0,0,0-5.78-4.61l.17.25c.39-2.52-.07-4.69-1-5.81a3.49,3.49,0,0,0-1.31-1A2.29,2.29,0,0,0,619.86,202Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.78,241.05a5.8,5.8,0,0,0-2.35-1.44h.17a2.76,2.76,0,0,0-.49-.07,2.31,2.31,0,0,0-1.79.28h0a4.26,4.26,0,0,0-2.25,2.11,5,5,0,0,0,.77,5.17,3.85,3.85,0,0,0,7-1.57A4.77,4.77,0,0,0,634.78,241.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "578.63 368.46 572.76 377.63 616.12 403.63 615.73 369.77 607.46 361.97 578.63 368.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675,323.61s-5.46-37.83-6.83-39.82-7-6.05-7-6.05l-15.52,32.91,1.55,12.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.89,267.62c1.15.18,19.81,5.77,25.31,10.12l-13.44,46.51-5.23,42.41-39.82,1.42-26.39,4,2.44-4.79s-1.07,1.75-.36-1.89,9.82-14,9.49-16.74-3.48-7.17-4.3-12.56a128.84,128.84,0,0,1-.44-16.32c.46-18.14,2.11-44.49,2.11-44.49l17.93-5.91C608.9,277,624.91,276,633,266.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.57,275.2s-13.74,7.11-16,14.24-6.52,31.23-6.52,31.23,15.47,1.49,20.07-.9S585.57,275.2,585.57,275.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.91,324.5a2.59,2.59,0,0,0,.06-.44c0-.32.06-.73.1-1.25.11-1.09.3-2.66.61-4.59A150,150,0,0,1,651,303.38a107.54,107.54,0,0,1,4.9-14.27c.42-.86.76-1.66,1.12-2.32s.67-1.24,1-1.68l.68-1a1.92,1.92,0,0,0,.22-.37,1.69,1.69,0,0,0-.27.32l-.72,1c-.3.44-.61,1-1,1.66s-.73,1.46-1.17,2.31a100,100,0,0,0-5,14.28,134.21,134.21,0,0,0-3.24,14.9c-.29,1.94-.44,3.52-.52,4.62,0,.52,0,.94,0,1.26A2.44,2.44,0,0,0,646.91,324.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.65,437.44c1.48.31,42.29,10.58,42.29,10.58l6.31-18.14-39.74-17.37Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.48,426.05s6,16.3-5.29,20.2l3.28,4.7,27.8,18.87a4.34,4.34,0,0,0,5.72-.6,4.19,4.19,0,0,0,.66-4.48c-3.59-7.91-16.93-36.94-19.84-37.71l-7.56-2.54a4.9,4.9,0,0,0-4.77,1.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.45,468.58l-22.26-42.47,1.64.57c1.84.47,2.27,1.49,3.12,2.73,2.51,3.69,7.67,13.26,17.74,35.21a4.19,4.19,0,0,1-.24,4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.72,428.94a2.54,2.54,0,0,0,2.9,1.77,2.45,2.45,0,0,0,1.77-2.87,2.68,2.68,0,0,0-3.08-1.85c-1.18.42-2.1,2.08-1.51,3.19",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M692.64,453.77c0,.26-2.31.41-4.21,2.33s-2.17,4.2-2.43,4.16c-.1,0-.23-.59,0-1.54a6.5,6.5,0,0,1,1.84-3.26,6.58,6.58,0,0,1,3.29-1.77C692.05,453.52,692.64,453.66,692.64,453.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.85,458.36c.11.24-1.59,1-2.87,2.84s-1.56,3.63-1.82,3.61-.4-2.11,1.09-4.14S696.82,458.12,696.85,458.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.8,446.29c.12.25-2.5,1.46-4.74,4.09s-3.1,5.36-3.36,5.28.25-3.08,2.68-5.87S687.75,446.07,687.8,446.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.71,442.36c.19.18-1.46,2-2.54,4.76s-1.19,5.19-1.46,5.19-.57-2.58.62-5.53S678.57,442.17,678.71,442.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.54,448.68a3.62,3.62,0,0,1-1.38-.72,10.76,10.76,0,0,1-2.92-3.1,4.78,4.78,0,0,1-1-2.91,1.69,1.69,0,0,1,1.27-1.47,2.68,2.68,0,0,1,1.93.36,5.94,5.94,0,0,1,2.19,7.25,6.92,6.92,0,0,1-6.5,4.1,2.37,2.37,0,0,1-1.78-.9,1.64,1.64,0,0,1,.1-1.94,5.8,5.8,0,0,1,2.56-1.65,12.18,12.18,0,0,1,4.16-.85,3.64,3.64,0,0,1,1.55.16,19.21,19.21,0,0,0-5.46,1.28,5.48,5.48,0,0,0-2.2,1.49.88.88,0,0,0-.06,1.06,1.67,1.67,0,0,0,1.21.52,6.16,6.16,0,0,0,5.59-3.61,5.18,5.18,0,0,0-1.77-6.19,2,2,0,0,0-1.34-.31.92.92,0,0,0-.71.8,4.28,4.28,0,0,0,.77,2.49A15.83,15.83,0,0,0,675.54,448.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.53,323.62A212.26,212.26,0,0,1,665,347.37c-1.92,10.63-4.35,16.61-6.94,19.48s-5.25,2.21-5.25,2.21l-23.46-38.92,8-3.81,9.49,11.06.36-13.89Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.66,320s.4,35.86,2.87,41.59,5.89,8.81,8.6,8.27,27.76-11.85,32.1-24.16l-7.75-8.61s-15.13,8.49-17.33,8.34l-2-26.62Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.7,354.07c.07,0,.17-.78.62-1.95a10.22,10.22,0,0,1,7-6.28c1.21-.32,2-.34,2-.4s-.2-.05-.56-.05a9.13,9.13,0,0,0-1.51.19,9.73,9.73,0,0,0-4.45,2.26,9.83,9.83,0,0,0-2.73,4.19,7.56,7.56,0,0,0-.34,1.48A1.71,1.71,0,0,0,575.7,354.07Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.8,336.94a19.8,19.8,0,0,0,1.66,1.83c1,1.11,2.43,2.68,3.87,4.49s2.65,3.54,3.5,4.81a21.65,21.65,0,0,0,1.4,2,2.1,2.1,0,0,0-.27-.61c-.2-.38-.51-.92-.9-1.57a48.74,48.74,0,0,0-3.43-4.89,49.39,49.39,0,0,0-4-4.45c-.55-.54-1-1-1.32-1.23S646.82,336.92,646.8,336.94Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.21,418.17s-78.79-38-82.29-40.14-15.62-7.51-21.69-4.34-12.55,12.46-9.74,22.89,16.71,27.2,21.57,30.35,44.57,3.16,44.57,3.16l37.65,12.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.61,408.83a3.3,3.3,0,0,0,.48.39c.33.25.8.63,1.45,1.06a55.68,55.68,0,0,0,5.61,3.43,79.12,79.12,0,0,0,8.86,4.05c3.42,1.34,7.26,2.61,11.31,3.81,8.13,2.38,15.55,4.28,20.81,6,2.64.85,4.75,1.6,6.2,2.15l1.67.63a3,3,0,0,0,.59.2l-.56-.27c-.38-.16-.93-.41-1.65-.7-1.43-.59-3.53-1.38-6.16-2.27-5.25-1.81-12.67-3.76-20.79-6.13-4-1.2-7.87-2.46-11.29-3.78a84,84,0,0,1-8.87-4c-2.45-1.29-4.36-2.46-5.65-3.31-.66-.42-1.14-.78-1.48-1A4.79,4.79,0,0,0,556.61,408.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.91,395.65a5.51,5.51,0,0,0-.26,1.77,16.84,16.84,0,0,0,1.76,8.37,5.91,5.91,0,0,0,.94,1.51,31.29,31.29,0,0,1-2-5.66A30,30,0,0,1,553.91,395.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.45,375.82l.38.21,1.09.53,4,2c3.4,1.67,8,4.08,13.12,6.81s9.72,5.19,13.11,6.88c1.69.84,3.07,1.51,4,2l1.11.5c.26.11.39.17.4.15l-.37-.22-1.07-.57-4-2.06c-3.36-1.75-7.95-4.24-13-7s-9.75-5.11-13.18-6.72c-1.71-.81-3.11-1.44-4.09-1.85l-1.12-.47A1.48,1.48,0,0,0,573.45,375.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.17,403.78c.14,1.51,2.36,43.53,2.36,43.53l19.19.67,4.89-43.09Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.24,438.76s-15.67,10.31-22.74.66l-2.09,4.48L600.57,476a4.37,4.37,0,0,0,2.26,5.3,4.2,4.2,0,0,0,4.48-.7c6.5-5.76,30.31-27.07,30.19-30.08l.19-8a4.06,4.06,0,0,0-2.45-3.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.58,481.56l34-33.78-.07,1.73c.1,1.9-.75,2.61-1.69,3.79-2.78,3.48-10.41,11.23-28.41,27.33a4.19,4.19,0,0,1-3.86.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633,442.42a2.56,2.56,0,0,0-.82,3.3,2.45,2.45,0,0,0,3.26.85,2.69,2.69,0,0,0,.85-3.5c-.74-1-2.6-1.39-3.48-.5",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M613.66,464c-.23.1-1.08-2.08-3.47-3.34s-4.65-.83-4.69-1.09c0-.1.5-.4,1.47-.49a6.48,6.48,0,0,1,3.65.79,6.56,6.56,0,0,1,2.66,2.63C613.72,463.36,613.77,464,613.66,464Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.52,469.38c-.2.17-1.46-1.22-3.56-1.91s-3.94-.41-4-.67,1.9-1,4.28-.18S610.74,469.28,610.52,469.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.38,457.17c-.2.19-2.13-2-5.3-3.32s-6-1.38-6-1.66,3-.67,6.4.84S619.58,457.06,619.38,457.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.46,447.32c-.12.24-2.35-.79-5.3-1s-5.31.39-5.39.13,2.3-1.31,5.47-1S620.59,447.14,620.46,447.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.48,446.16a3.56,3.56,0,0,1,.29-1.53,10.91,10.91,0,0,1,2.09-3.7,4.74,4.74,0,0,1,2.51-1.78,1.66,1.66,0,0,1,1.77.78,2.72,2.72,0,0,1,.23,1.95,5.93,5.93,0,0,1-6.29,4.23,6.89,6.89,0,0,1-5.82-5,2.42,2.42,0,0,1,.32-2,1.69,1.69,0,0,1,1.89-.48,5.86,5.86,0,0,1,2.33,2,12,12,0,0,1,2,3.73,3.79,3.79,0,0,1,.31,1.52,19.46,19.46,0,0,0-2.84-4.84,5.47,5.47,0,0,0-2.07-1.66.88.88,0,0,0-1,.25,1.62,1.62,0,0,0-.14,1.31,6.17,6.17,0,0,0,5.1,4.28,5.17,5.17,0,0,0,5.39-3.52,2,2,0,0,0-.1-1.37.94.94,0,0,0-1-.45,4.32,4.32,0,0,0-2.14,1.47A16.09,16.09,0,0,0,613.48,446.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.82,315.54l8.66,21.75s37.34,12.93,40.93,16.67l2.7.1L634.8,328.47s-16.45-10-21.11-11.48-9.52-2.42-9.52-2.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.94,330s-12.6-7.94-18.51-10.06A103.79,103.79,0,0,0,602,316.58l8.58,21.47,24.43,6.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.12,330s1.07-1.91.49-2.86-7.29-2.07-11.51-2.74-6.88.41-6.74,4.28a5.27,5.27,0,0,0-1.57,4c.15,2.41,1.33,2.84,1.33,2.84s-1.39,2.9-.16,4.5,1.73,1.38,1.73,1.38a5.23,5.23,0,0,0,1.65,3.12,14.22,14.22,0,0,0,4.6,1.88l8.51-16Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605,329a9.66,9.66,0,0,0,2,.4c1.21.19,2.9.4,4.76.58s3.56.29,4.79.33a9.79,9.79,0,0,0,2,0,10.4,10.4,0,0,0-2-.26l-4.77-.44-4.77-.47A11.47,11.47,0,0,0,605,329Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.18,335a67.87,67.87,0,0,0,10.15-.18,67.87,67.87,0,0,0-10.15.18Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.32,339.86a12.26,12.26,0,0,0,7.59-.71c0-.11-1.68.39-3.77.58S605.34,339.75,605.32,339.86Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.13,335.41a1.83,1.83,0,0,0-.32.59,7.39,7.39,0,0,0-.46,1.77,19.53,19.53,0,0,0-.17,2.71,8.29,8.29,0,0,0,.09,1.62,3.36,3.36,0,0,0,.77,1.6,7.5,7.5,0,0,0,2.8,1.86,11.78,11.78,0,0,0,2.61.76,8.39,8.39,0,0,0,1.83.1,2.17,2.17,0,0,0,.66-.11,17.45,17.45,0,0,1-2.44-.26,13.51,13.51,0,0,1-2.53-.81,7.43,7.43,0,0,1-2.63-1.79,3,3,0,0,1-.71-1.42,9.1,9.1,0,0,1-.1-1.55,24,24,0,0,1,.09-2.67A13.63,13.63,0,0,1,602.13,335.41Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.46,329.72s-2.31-2.84-4.73-3.08-7.89-1.33-10.48,3.18-6.16,18.36-6.43,23.41,2.08,70.86,2.08,70.86l27,1,3-15.63,16.9,7.91s7-4.16,8-14.26.19-22.69-1.92-26.07S630.46,329.72,630.46,329.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609,358.23s0,.11,0,.33,0,.54,0,.95c0,.86.06,2.1.1,3.7.1,3.23.25,7.91.43,13.77s.37,12.92.56,20.87.41,16.79.65,26.24v.18h.18l20,.71,6.29.23h.16l0-.15c1.33-5.73,2.61-11.27,3.83-16.51v0A78.36,78.36,0,0,0,645.91,384a106.55,106.55,0,0,0-1.25-19.82c-.84-5.51-1.81-9.85-2.53-12.81-.34-1.48-.66-2.62-.86-3.39-.1-.37-.18-.66-.23-.87l-.09-.29a2.37,2.37,0,0,0,.06.3c0,.21.11.5.2.88.18.77.47,1.91.8,3.4.68,3,1.61,7.31,2.42,12.82A108.46,108.46,0,0,1,645.6,384a78.74,78.74,0,0,1-4.71,24.48v0h0L637,425l.19-.15L631,424.6l-20-.7.18.18c-.25-9.45-.49-18.29-.7-26.24s-.39-15-.64-20.87-.41-10.54-.54-13.77c-.07-1.6-.12-2.84-.16-3.69,0-.41,0-.73,0-.95Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.43,306.54l7.07.91-4.23,3.21a3.15,3.15,0,0,1-2.46-1.34A3.19,3.19,0,0,1,619.43,306.54Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.79,309.32l8.1-2.88a1.37,1.37,0,0,0,.83-1.76h0a1.37,1.37,0,0,0-1.79-.8l-10.21,4.06-16.29,6.48-1.65,2.05,2.64.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.38,326.33a4.8,4.8,0,0,0,.84-3.15,12.85,12.85,0,0,1,.2-3.78s1-2.86.14-4a3.48,3.48,0,0,1-.71-2.29s0-3-.81-3.22-8.43-4-9.48-3.66-9.66,7.41-9.66,7.41-.9,2.15,1.06,2.16l-2.66,2.33,4.47,2.06,13.34,7.72S636.57,328.29,637.38,326.33Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.52,319.41a11.47,11.47,0,0,0,1.9-.19,43.9,43.9,0,0,1,4.57-.28,43.08,43.08,0,0,1,4.56.22,12.23,12.23,0,0,0,1.9.15,8.39,8.39,0,0,0-1.86-.42,28.79,28.79,0,0,0-4.61-.33,27.77,27.77,0,0,0-4.6.4A7.48,7.48,0,0,0,619.52,319.41Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619,315.77a9.94,9.94,0,0,1,1.66-1.19,12.14,12.14,0,0,1,4.81-1c1.94-.11,3.72,0,5,0a7.36,7.36,0,0,0,2.08-.17c0-.06-.79,0-2.07-.1a49.93,49.93,0,0,0-5-.13,11.3,11.3,0,0,0-4.92,1.18,4.73,4.73,0,0,0-1.21,1C619,315.58,618.94,315.76,619,315.77Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.9,313.61a7.7,7.7,0,0,0,1.44-.93c.85-.61,2-1.48,3.29-2.46s2.42-1.88,3.23-2.55a7.48,7.48,0,0,0,1.27-1.15,7.65,7.65,0,0,0-1.43.94c-.86.61-2,1.48-3.3,2.46s-2.42,1.88-3.23,2.55A8.32,8.32,0,0,0,617.9,313.61Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.56,327.53c0,.05.34.19,1,.19a3.89,3.89,0,0,0,3.64-2.57,1.6,1.6,0,0,0,.14-.95c-.06,0-.14.34-.39.85a4.55,4.55,0,0,1-1.39,1.65,4.35,4.35,0,0,1-2,.75A6.3,6.3,0,0,0,633.56,327.53Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.2,353.35s5.1,4.55,4.41,18.65.28,18.46.28,18.46l-3-.11L632,362.27a33.88,33.88,0,0,0,2.2-13.07c-.13-5-3.74-19.48-3.74-19.48l1.48.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.68,353.59s5.1,4.55,4.41,18.65.28,18.46.28,18.46l-3-.1-22.9-28.09a33.76,33.76,0,0,0,2.21-13.07c-.13-5-3.74-19.48-3.74-19.48l2.86-1.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.71,329.07s0,.06,0,.17l.11.47c.11.45.27,1.06.47,1.83.44,1.58,1,3.89,1.62,6.77a76.37,76.37,0,0,1,1.43,10.27,38.23,38.23,0,0,1-.07,6.13l-.21,1.6c-.12.53-.2,1.07-.35,1.6l-.23.79-.28.78a6.43,6.43,0,0,1-.78,1.44l-.11.13.12.13,1.49,1.61A211.34,211.34,0,0,1,653.5,382c1.84,2.57,3.28,4.68,4.27,6.15l1.14,1.69.3.43c.07.1.11.15.12.14a1.78,1.78,0,0,1-.08-.16l-.28-.45c-.24-.4-.6-1-1.07-1.73-.95-1.49-2.36-3.63-4.18-6.22a191.79,191.79,0,0,0-15.49-19.27l-1.49-1.63v.26a6.51,6.51,0,0,0,.84-1.55l.29-.8.23-.82c.16-.54.24-1.09.36-1.63l.21-1.62a40.27,40.27,0,0,0,.05-6.2,73.23,73.23,0,0,0-1.53-10.29c-.65-2.88-1.25-5.19-1.73-6.76-.23-.76-.41-1.36-.54-1.81l-.15-.46C634.74,329.12,634.72,329.07,634.71,329.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.37,362.82a4.18,4.18,0,0,0,1.66-.7c.87-.48,1.53-.95,1.48-1a4.42,4.42,0,0,0-1.66.7C634,362.27,633.32,362.73,633.37,362.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.91,408.84a3.52,3.52,0,0,0,.71.45c.47.27,1.16.65,2,1.11,1.72.92,4.1,2.15,6.76,3.45s5.1,2.43,6.88,3.19c.9.38,1.62.68,2.13.87a4,4,0,0,0,.81.26,4.51,4.51,0,0,0-.75-.4l-2.08-1c-1.75-.83-4.17-2-6.82-3.29l-6.8-3.35-2.07-1A3.13,3.13,0,0,0,640.91,408.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.69,339.46l.28.33.83,1,3.2,3.91c2.77,3.37,6.77,8.23,11.47,14.07l0,.06v.09c-.09,6.22-.19,13.39-.3,21h0v.75l-.46-.59-15.93-20.68-.05-.07v-.07c.27-6,.49-11,.65-14.5.08-1.68.14-3,.19-4l0-1c0-.23,0-.34,0-.33v.39c0,.28,0,.64,0,1.08,0,1-.06,2.34-.1,4.05-.09,3.48-.21,8.39-.36,14.31l-.05-.14c4.54,5.85,10.06,13,16,20.63l-.46.15h0c.13-7.6.25-14.78.36-21l.05.15c-4.59-5.76-8.39-10.63-11.1-14.09l-3.17-4-.85-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.79,360.58a34.76,34.76,0,0,1,.39-6,34.25,34.25,0,0,1,.9-5.92,35.25,35.25,0,0,1-.38,6A34.09,34.09,0,0,1,644.79,360.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.61,362.43a44.58,44.58,0,0,1,.7-6.87,45.51,45.51,0,0,1,1.23-6.8,47,47,0,0,1-.71,6.87A46,46,0,0,1,646.61,362.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.29,364.24a47.16,47.16,0,0,1,.71-6.87,45.2,45.2,0,0,1,1.23-6.79,47.16,47.16,0,0,1-.71,6.87A45.2,45.2,0,0,1,648.29,364.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.86,366.55a43.93,43.93,0,0,1,.71-6.87,46.33,46.33,0,0,1,1.22-6.8,47,47,0,0,1-.71,6.87A46,46,0,0,1,649.86,366.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.3,368.48a47,47,0,0,1,.71-6.87,46,46,0,0,1,1.22-6.8,44.68,44.68,0,0,1-.7,6.87A45.51,45.51,0,0,1,651.3,368.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.32,370.75a47,47,0,0,1,.71-6.87,45.18,45.18,0,0,1,1.23-6.8,47,47,0,0,1-.71,6.87A45.18,45.18,0,0,1,653.32,370.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655,372.68a45.43,45.43,0,0,1,.71-6.87,46.33,46.33,0,0,1,1.22-6.8,45.43,45.43,0,0,1-.71,6.87A46,46,0,0,1,655,372.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.67,293.41a9.29,9.29,0,0,1,.34,1.68c.19,1.09.43,2.66.67,4.62.51,3.92,1,9.34,1.49,15.35s.75,11.44.93,15.38c.08,1.91.14,3.48.18,4.67a12.48,12.48,0,0,1,0,1.71,9.35,9.35,0,0,1-.2-1.7c-.09-1.19-.2-2.76-.34-4.66-.29-4-.67-9.4-1.09-15.37s-.92-11.42-1.33-15.33c-.21-1.9-.38-3.46-.51-4.65A12.4,12.4,0,0,1,580.67,293.41Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletjournalPana);
export default __webpack_public_path__ + "static/media/Bullet journal-pana.a4847942644a4dc2990baf775de60f7e.svg";
export { ForwardRef as ReactComponent };